import { isFunction, isNil as isNil$1, reverse, isObject as isObject$1, isArray as isArray$1, uniq, isString as isString$1, isNumber, isMap, last, reject, isEmpty as isEmpty$2, first, findLast, isPlainObject, isBoolean, isUndefined } from 'lodash-es';
import { isFunction as isFunction$1, isArray, isObject, isString, trim, isEmpty as isEmpty$1, isNil, eq, includes, find, map, findIndex, filter, flatten, differenceBy, findLast as findLast$1, first as first$1, last as last$1, chunk, sortBy, uniq as uniq$1, uniqBy, isEqual } from 'lodash';
import * as CircularJSON from 'circular-json';
import produce from 'immer';
import 'reflect-metadata';

var Disposable;
(function (Disposable) {
    function isInstance(target) {
        return isFunction(target['dispose']);
    }
    Disposable.isInstance = isInstance;
    function disposableThatRuns(callable) {
        return {
            dispose: () => callable()
        };
    }
    Disposable.disposableThatRuns = disposableThatRuns;
})(Disposable || (Disposable = {}));

// import _ from 'lodash';
// this won't work till I target es2015, @see http://stackoverflow.com/a/41102182/1248812
// export class CustomError extends Error {
//     constructor(message) {
//         super();
//         this.message = message;
//         this.stack = (new Error()).stack;
//         this.name = this.constructor.name;
//     }
// }
//
// export class IllegalStateError extends CustomError {
//     constructor(message) {
//         super(message);
//     }
// }
const lang = {
    abstractMethod: function (constructor, name = undefined) {
        throw new Error(`AbstractMethod: ${constructor.name} must implement abstract method ${name}`);
    },
    illegalState: function (message) {
        throw new Error(`IllegalState: ${message}`);
    },
    illegalArgument: function (message) {
        throw new Error('IllegalArgument: ' + message);
    },
    notImplemented: function (message) {
        throw new Error('MethodNotImplemented: ' + message);
    },
    methodNotSupported: function (reason = undefined) {
        throw new Error('MethodNotSupported' + reason ? `: ${reason}` : '');
    },
    "try": function (func) {
        return isFunction$1(func) ? func() : null;
    },
    wrapInArray: function (arrayOrOtherwise) {
        return isArray(arrayOrOtherwise) ? arrayOrOtherwise : [arrayOrOtherwise];
    },
    /**
     * Returns the prototype chain of the object (including itself) with the first element
     * being the object itself.
     * @param object
     * @param uptoConstructor
     * @returns {any[]}
     */
    prototypeChain(object, uptoConstructor = Object) {
        assert.isTruthy(isObject(object));
        let prototypes = [];
        let proto = object;
        while (true) {
            proto = Object.getPrototypeOf(proto);
            if (!proto)
                break;
            prototypes.push(proto);
            if (proto.constructor == uptoConstructor)
                break;
        }
        return prototypes;
    },
    /**
     * Returns the constructor can of the class (including itself) with the first element
     * being the class itself.
     * @param constructor
     * @param uptoConstructor
     * @returns {any[]}
     */
    constructorChain(constructor, uptoConstructor) {
        assert.isTruthy(isObject(constructor.prototype));
        let constructors = [];
        let currentConstructor = constructor;
        while (true) {
            if (!currentConstructor)
                break;
            constructors.push(currentConstructor);
            if (currentConstructor == uptoConstructor || currentConstructor == Object)
                break;
            currentConstructor = lang.constructorSuper(currentConstructor);
        }
        return constructors;
    },
    constructorSuper(constructor) {
        return Object.getPrototypeOf(constructor.prototype).constructor;
    },
    isBlank(s) {
        // empty strings are falsey
        return isString(s) ? !trim(s) : isEmpty$1(s);
    },
};
const assert = {
    // todo: have this delegate to notNil then remove.
    notNull: (value, name = 'value') => {
        if (!isString(value) && !value)
            throw new Error(`expected ${name} to be non null, got: ${typeof value}`);
        return value;
    },
    notNil: (value, name = 'value') => {
        if (isNil(value))
            throw new Error(`expected ${name} to be non null`);
        return value;
    },
    isNil: (value, name = 'value') => {
        if (!isNil(value))
            throw new Error(`expected ${name} to be null or undefined, got: ${typeof value}`);
        return value;
    },
    notPresent: function (value, name = 'value') {
        if (value != null && typeof value !== 'undefined')
            throw new Error(`expected ${name} to be null or undefined, got: ${value}`);
    },
    notEmpty: function (value, name = 'value') {
        assert.notNull(value, name);
        assert.isInteger(value.length);
        if (value.length < 1)
            throw new Error(`expected ${name} have length > 0, got: ${value.length}`);
        return value;
    },
    notBlank: function (value, name = 'value') {
        assert.isString(value);
        assert.isInteger(value.length);
        if (value.length < 1)
            throw new Error(`expected ${name} have length > 0, got: ${value.length}`);
        return value;
    },
    isArray(array, name = 'value') {
        if (!isArray(array)) {
            throw new Error(`expected ${name} to be an array, got: ${typeof array}`);
        }
        return array;
    },
    isFunction(thing, message) {
        if (!(isFunction$1(thing))) {
            throw new Error(message || `expected to get a function, got: ${typeof thing}`);
        }
        return thing;
    },
    isTruthy: (value, message) => {
        if (!value) {
            throw new Error(message || `expected to get a truthy value, got: ${value}`);
        }
        return value;
    },
    isFalsey: (value, message) => {
        if (value) {
            throw new Error(message || `expected to get a falsey value, got: ${value}`);
        }
        return value;
    },
    isInteger: (value) => {
        if (!((typeof value === "number") && Math.floor(value) === value)) {
            throw new Error(`expected to get an integer, got a ${typeof value} with value ${value}`);
        }
        return value;
    },
    isNumber: (value) => {
        if (!(typeof value === "number")) {
            throw new Error(`expected to get a number, got a ${typeof value} with value ${value}`);
        }
        return value;
    },
    isString(value) {
        if (!(typeof value === "string")) {
            throw new Error(`expected to get a string, got a ${typeof value} with value ${value}`);
        }
        return value;
    },
    defined: (target, propertyName) => {
        if (typeof target[propertyName] === 'undefined')
            throw new Error(`property ${propertyName} is undefined`);
    },
    equal: (a, b) => {
        if (!eq(a, b)) {
            throw new Error(`expected items to be equal, got ${a} and ${b}`);
        }
    },
    value(value) {
        return {
            isOneOf(items) {
                if (!includes(items, value)) {
                    throw new Error(`expected to get one of ${items.join(',')}, got a ${typeof value} with value ${value}`);
                }
                return value;
            },
            isInstanceOrNull: (type, message) => {
                if (value && !(value instanceof type)) {
                    throw new Error(message || `expected to get null or instance of ${type.name}, got: ${typeof value}`);
                }
                return value;
            },
            isInstance: (type, message) => {
                if (!(value instanceof type)) {
                    throw new Error(message || `expected to get null or instance of ${type.name}, got: ${typeof value}`);
                }
                return value;
            },
        };
    },
    list(items) {
        return {
            onlyContains(constraints) {
                items.forEach(item => {
                    if (!includes(constraints, item)) {
                        throw new Error(`expected to get one of ${constraints.join(',')}, got a ${typeof items} with value ${items}`);
                    }
                });
                return items;
            }
        };
    },
    oneOrNoneOf(options, a, b, callback, otherwise) {
        if (options) {
            if (!isNil(options[a]) && !isNil(options[b])) {
                lang.illegalState(`expected either one of none of '${a.toString()}' and '${b.toString()}' but got both`);
            }
            if (!isNil(options[a]) || !isNil(options[b])) {
                return callback();
            }
            else {
                return otherwise;
            }
        }
        else {
            return otherwise;
        }
    },
    oneOf(options, a, b) {
        if (!isNil(options[a]) && !isNil(options[b])) {
            lang.illegalState(`expected only one of '${a.toString()}' and '${b.toString()}' but got both`);
        }
        if (isNil(options[a]) && isNil(options[b])) {
            lang.illegalState(`expected one of '${a.toString()}' and '${b.toString()}' but got none`);
        }
    }
};

class OptionsHelper {
    constructor(options) {
        this.options = options;
    }
    static for(options) {
        return new OptionsHelper(options);
    }
    get(key, defaultValue) {
        if (isNil$1(this.options) || isNil$1(this.options[key])) {
            return isFunction(defaultValue) ? defaultValue() : defaultValue;
        }
        else {
            return this.options[key];
        }
    }
    withOptional(key, callback) {
        if (!isNil$1(this.options) && !isNil$1(this.options[key])) {
            callback(this.options[key]);
        }
    }
    withOneOrNoneOf(a, b, callback) {
        if (!isNil$1(this.options)) {
            if (!isNil$1(this.options[a]) && !isNil$1(this.options[b])) {
                lang.illegalState(`expected either one of none of '${a.toString()}' and '${b.toString()}' but got both`);
            }
            if (!isNil$1(this.options[a]) || !isNil$1(this.options[b])) {
                return callback(this.options);
            }
        }
    }
    withEitherOf(a, b, callback) {
        const aIsNil = isNil$1(this.options && this.options[a]);
        const bIsNil = isNil$1(this.options && this.options[b]);
        if (!aIsNil && !bIsNil) {
            lang.illegalState(`expected only one of '${a.toString()}' and '${b.toString()}' but got both`);
        }
        if (aIsNil && bIsNil) {
            lang.illegalState(`expected one of '${a.toString()}' and '${b.toString()}' but got none`);
        }
        callback(this.options);
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

class GarbageCollector {
    constructor() {
        this._garbage = [];
    }
    onDispose(dispose) {
        this.registerDisposable({ dispose });
    }
    registerDisposable(disposable) {
        assert.notNil(disposable);
        assert.isFunction(disposable.dispose);
        this._garbage.push(disposable);
        return disposable;
    }
    dispose() {
        if (!!this._garbage) {
            this._garbage.forEach(item => item.dispose());
            this._garbage = undefined;
        }
        else {
            // Note this is happening in places where a disposable model like that created in
            // BooleanValueModelChainMixin.orNot(..) uses the dsl to create a new model.  In this
            // case both the dsl and the the OrNot model will try and dispose of the other model.
            // TODO: Fix this https://coolon.atlassian.net/browse/PEC-120
            // lang.illegalState("Disposed called twice.")
            // Logger.get(this).info("Disposed called twice.  Pectin does this in various places... not harmful but would be nice to fix.")
        }
    }
    isDisposed() {
        return !this._garbage;
    }
}
(function (GarbageCollector) {
    function Mixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__garbage = new GarbageCollector();
            }
            dispose() {
                this.__garbage.dispose();
            }
            registerDisposable(disposable) {
                return this.__garbage.registerDisposable(disposable);
            }
            onDispose(dispose) {
                this.__garbage.onDispose(dispose);
            }
            isDisposed() {
                return this.__garbage.isDisposed();
            }
        };
    }
    GarbageCollector.Mixin = Mixin;
})(GarbageCollector || (GarbageCollector = {}));

class ListRegistration extends GarbageCollector {
    constructor(listener) {
        super();
        this.listener = listener;
    }
}
class EventListenerList {
    constructor(listChangeCallback = undefined) {
        this.listChangeCallback = listChangeCallback;
        this._registrations = [];
    }
    dispose() {
        this._registrations = undefined;
    }
    /**
     * Registers a listener.
     * @param listener
     * @return [Disposable] returns a HandlerRegistration that can be used to de-register the listener and free
     * the memory reference to it.  e.g. registration.dispose();
     */
    add(listener) {
        assert.notNull(listener);
        let registration = new ListRegistration(listener);
        this._registrations.unshift(registration);
        registration.onDispose(() => {
            if (this._registrations) {
                let index = this._registrations.indexOf(registration);
                if (index > -1) {
                    this._registrations.splice(index, 1);
                    this.listChangeCallback && this.listChangeCallback();
                }
                else {
                    console.warn(`dispose() -> called twice on a registration!!`);
                }
                this.fireSubscriptionsChanged();
            }
            else {
                // console.warn(`registration disposed after EventListenerList has already been disposed.`);
            }
        });
        this.fireSubscriptionsChanged();
        return registration;
    }
    fire(invoker) {
        if (!this._registrations) {
            lang.illegalState('EventListenerList already disposed');
        }
        return reverse(this._registrations).map((registration) => {
            return invoker(registration.listener);
        });
    }
    fireAndWait(invoker) {
        return Promise.all(this.fire(invoker));
    }
    map(mapFunction) {
        return this._registrations.map(r => mapFunction(r.listener));
    }
    onSubscriptionsChanged(callback) {
        return this.lazySubscriptionChangedListeners.add(callback);
    }
    get listenerCount() {
        return this._registrations.length;
    }
    get lazySubscriptionChangedListeners() {
        if (!this._lazySubscriptionChangedListeners) {
            this._lazySubscriptionChangedListeners = new EventListenerList();
        }
        return this._lazySubscriptionChangedListeners;
    }
    hasSubscriptionListeners() {
        return !!this._lazySubscriptionChangedListeners;
    }
    fireSubscriptionsChanged() {
        if (this.hasSubscriptionListeners()) {
            this.lazySubscriptionChangedListeners.fire(callback => callback());
        }
    }
}

const INSTANCE_SYMBOL = Symbol('pectin:instance');
class Pectin {
    constructor() {
        this._commandListeners = new EventListenerList();
        this._transactionErrorListeners = new EventListenerList();
        if (Pectin[INSTANCE_SYMBOL]) {
            throw new Error("Error - use Pectin.get()");
        }
    }
    static get() {
        Pectin[INSTANCE_SYMBOL] = Pectin[INSTANCE_SYMBOL] || new Pectin();
        return Pectin[INSTANCE_SYMBOL];
    }
    addCommandListener(listener) {
        return this._commandListeners.add(listener);
    }
    onTransactionRaceCondition(listener) {
        return this._transactionErrorListeners.add(listener);
    }
    _notifyRaceCondition(existing, next) {
        this._transactionErrorListeners.fire(listener => listener(existing, next));
    }
    _notifyCommandStart(command) {
        this._commandListeners.fire(listener => listener.onStart && listener.onStart(command));
    }
    _notifyCommandFinished(command) {
        this._commandListeners.fire(listener => listener.onFinish && listener.onFinish(command));
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

// import "reflect-metadata";
const DEBUG_CONTEXT_METADATA_KEY = Symbol("pectin:debugContext");
class DebugContext {
    constructor(targetInstance) {
        this.targetInstance = targetInstance;
        this.className = targetInstance.constructor.name;
    }
    /**
     * @deprecated use #getOrCreate instead. (this is still used in restilence)
     * @param targetInstance
     */
    static get(targetInstance) {
        return DebugContext.getOrCreate(targetInstance);
    }
    static getOrCreate(targetInstance) {
        const context = targetInstance[DEBUG_CONTEXT_METADATA_KEY];
        if (!context) {
            targetInstance[DEBUG_CONTEXT_METADATA_KEY] = new DebugContext(targetInstance);
        }
        return targetInstance[DEBUG_CONTEXT_METADATA_KEY];
    }
    static tryGet(targetInstance) {
        return targetInstance[DEBUG_CONTEXT_METADATA_KEY];
    }
    static tag(targetInstance, tag) {
        DebugContext.getOrCreate(targetInstance).tag(tag);
    }
    static clearTag(targetInstance) {
        try {
            // this will barf if used on revoked proxies which happens often when assigning new models as
            // the old ones will have been disposed.
            DebugContext.getOrCreate(targetInstance).tag(undefined);
        }
        catch (error) {
            // ignore
        }
    }
    /**
     * If the instance has a debug context it returns the debug label, otherwise it returns undefined.
     * @param targetInstance
     */
    static getDebugLabel(targetInstance) {
        return (isObject$1(targetInstance) || isFunction(targetInstance)) ?
            targetInstance[DEBUG_CONTEXT_METADATA_KEY]?.getDebugLabel() :
            undefined;
    }
    static attach(target, context) {
        if (!target[DEBUG_CONTEXT_METADATA_KEY]) {
            target[DEBUG_CONTEXT_METADATA_KEY] = context;
        }
    }
    tag(tag) {
        this._tag = tag;
    }
    getTag() {
        return this._tag;
    }
    getDebugLabel() {
        return this._tag ? `${this.className} (${this._tag})` : this.className;
    }
}
(function (DebugContext) {
    function TagProperty(tag) {
        return (target, propertyKey) => {
            const backingPropertyKey = `__DebugContext.TagPropertyBackingValue${propertyKey.toString()}`;
            // property getter method
            const getter = function () {
                return this[backingPropertyKey];
            };
            // property setter method
            const setter = function (newVal) {
                if (this[backingPropertyKey]) {
                    DebugContext.clearTag(this[backingPropertyKey]);
                }
                DebugContext.tag(newVal, tag || `${target.constructor.name}.${propertyKey.toString()}`);
                this[backingPropertyKey] = newVal;
            };
            // Delete exiting property and replace it with our get/setters.
            delete this[propertyKey];
            // Create new property with getter and setter
            Object.defineProperty(target, propertyKey, {
                get: getter,
                set: setter,
                enumerable: true,
                configurable: true
            });
        };
    }
    DebugContext.TagProperty = TagProperty;
    function getTagOrDefault(options, defaultTag) {
        return options && options.tag ? options.tag : defaultTag;
    }
    DebugContext.getTagOrDefault = getTagOrDefault;
})(DebugContext || (DebugContext = {}));

const LOGGER_CONTEXT = Symbol.for("pectin:logger");
const LOGGER_CONTEXT_NAME = Symbol.for("pectin:logger.prefix");
class ConsoleDestination {
    constructor(console, enableGroups = true) {
        this.console = console;
        this.enableGroups = enableGroups;
        this.handlers = new Map();
        this.formatMethodName = (log) => {
            return log.context.tag ?
                `${log.context.name}.${log.message} (${log.context.tag})` :
                `${log.context.name}.${log.message}`;
        };
        this.handlers.set('enter', (log) => {
            this.startGroup(this.formatMethodName(log));
            if (log.optionalParams && log.optionalParams.length > 0) {
                console.log('args', ...(log.optionalParams || []));
            }
        });
        this.handlers.set('exit', (log) => {
            let baseMessage = `<-- ${this.formatMethodName(log)}`;
            if (log.optionalParams && log.optionalParams.length > 0) {
                if (log.optionalParams[0] instanceof Error) {
                    baseMessage = `${baseMessage}!!!`;
                }
                console.log(baseMessage, ...(log.optionalParams || []));
            }
            else {
                console.log(baseMessage);
            }
            this.endGroup();
        });
        this.handlers.set('log', (log) => {
            console.log(log.message, ...(log.optionalParams || []));
        });
        this.handlers.set('info', (log) => {
            console.info(log.message, ...(log.optionalParams || []));
        });
        this.handlers.set('warn', (log) => {
            console.warn(log.message, ...(log.optionalParams || []));
        });
        this.handlers.set('error', (log) => {
            console.error(log.message, ...(log.optionalParams || []));
        });
    }
    on(message) {
        const handler = this.handlers.get(message.type);
        handler && handler(message);
    }
    startGroup(name) {
        if (this.enableGroups && console.group) {
            console.group(name);
        }
        else {
            console.log(`--> ${name}`);
        }
    }
    endGroup() {
        if (this.enableGroups && console.groupEnd) {
            console.groupEnd();
        }
    }
}
class RootDestination extends GarbageCollector {
    constructor() {
        super(...arguments);
        this.destinations = new Set();
    }
    hasSubscribers() {
        return this.destinations.size > 0;
    }
    on(log) {
        this.destinations.forEach(d => d.on(log));
    }
    add(dest) {
        this.destinations.add(dest);
        return Disposable.disposableThatRuns(() => {
            return this.destinations.delete(dest);
        });
    }
}
class Logger {
    static logToConsole() {
        Logger.rootDestination.add(new ConsoleDestination(console));
    }
    static logTo(destination) {
        Logger.rootDestination.add(destination);
    }
    static publish(message) {
        return Logger.rootDestination.on(message);
    }
    static isActive(context, type) {
        return Logger.rootDestination.hasSubscribers();
    }
    static get(target) {
        switch (typeof target) {
            case "function":
                return Logger.ClassContext.get(target);
            case "object":
                return Logger.InstanceContext.get(target);
            case "string":
                return Logger.NamedContext.get(target);
            default:
                return Logger.NamedContext.get('');
        }
    }
    static setContext(instance, context) {
        instance[LOGGER_CONTEXT_NAME] = context;
    }
}
Logger.rootDestination = new RootDestination();
(function (Logger) {
    class AbstractContext {
        // around<T>(blockName: string, func: () => T, ...args: any[]): T {
        //     this.enter(blockName, ...args);
        //     let result: T;
        //     try {
        //         result = func();
        //         return result;
        //     } finally {
        //         this.exit(blockName, result);
        //     }
        // }
        enter(methodName, ...args) {
            args.length > 0 ? this.publish('enter', methodName, ...args) : this.publish('enter', methodName);
        }
        exit(methodName, result) {
            this.publish('exit', methodName, result);
        }
        log(message, ...optionalParams) {
            this.publish('log', message, ...optionalParams);
        }
        info(message, ...optionalParams) {
            this.publish('info', message, ...optionalParams);
        }
        warn(message, ...optionalParams) {
            this.publish('warn', message, ...optionalParams);
        }
        error(message, ...optionalParams) {
            this.publish('error', message, ...optionalParams);
        }
        runWithDebug(name, func) {
            try {
                return func();
            }
            catch (error) {
                Logger.get(this).log(`Unhandled exception in: ${name}`);
                Logger.get(this).error(error);
                throw error;
            }
        }
        publish(type, message, ...optionalParams) {
            if (Logger.isActive(this, type)) {
                const self = this;
                const event = {
                    context: self,
                    type: type
                };
                if (message) {
                    event.message = message;
                }
                if (optionalParams.length > 0) {
                    event.optionalParams = optionalParams;
                }
                Logger.publish(event);
            }
        }
    }
    Logger.AbstractContext = AbstractContext;
    class ClassContext extends AbstractContext {
        constructor(targetClass) {
            super();
            this.targetClass = targetClass;
        }
        static get(klass) {
            if (!klass[LOGGER_CONTEXT]) {
                klass[LOGGER_CONTEXT] = new ClassContext(klass);
            }
            return klass[LOGGER_CONTEXT];
        }
        get name() {
            return this.targetClass.name;
        }
        get tag() {
            return undefined;
        }
    }
    Logger.ClassContext = ClassContext;
    class InstanceContext extends AbstractContext {
        constructor(instance, classContext) {
            super();
            this.instance = instance;
            this.classContext = classContext;
        }
        static get(instance) {
            if (!instance[LOGGER_CONTEXT]) {
                instance[LOGGER_CONTEXT] = new InstanceContext(instance, ClassContext.get(instance.constructor));
            }
            return instance[LOGGER_CONTEXT];
        }
        get name() {
            const debugContext = DebugContext.tryGet(this.instance);
            return debugContext ? debugContext.className : this.classContext.name;
        }
        get tag() {
            return DebugContext.tryGet(this.instance)?.getTag();
        }
    }
    Logger.InstanceContext = InstanceContext;
    class NamedContext extends AbstractContext {
        constructor(name, tag = undefined) {
            super();
            this.name = name;
            this.tag = tag;
        }
        static get(name) {
            let context = this.contexts.get(name);
            if (!context) {
                context = new NamedContext(name);
                this.contexts.set(name, context);
            }
            return context;
        }
    }
    NamedContext.contexts = new Map();
    Logger.NamedContext = NamedContext;
})(Logger || (Logger = {}));

const TRACER = Symbol('pectin:tracer');
const ORIGINAL_FUNCTION = Symbol('pectin:tracer:original-function');
let _defaultArgFormatter = {
    format(arg) {
        return isObject$1(arg) ? DebugContext.tryGet(arg)?.getDebugLabel() ?? arg : arg;
    }
};
class Tracer {
    constructor(target) {
        this.target = target;
    }
    trace(functionName, options) {
        let method = this.target[functionName];
        if (!method[ORIGINAL_FUNCTION]) {
            // @ts-ignore whatthe?!??!
            this.target[functionName] = Tracer.wrapMethod(method, functionName, options);
            this.target[functionName][ORIGINAL_FUNCTION] = method;
        }
        return {
            dispose: () => this.untrace(functionName)
        };
    }
    untrace(functionName) {
        let method = this.target[functionName];
        if (method[ORIGINAL_FUNCTION]) {
            this.target[functionName] = this.target[functionName][ORIGINAL_FUNCTION];
        }
    }
}
(function (Tracer) {
    const instances = new Map();
    function forClass(klass) {
        if (!klass[TRACER]) {
            klass[TRACER] = new Tracer(klass.prototype);
        }
        return klass[TRACER];
    }
    Tracer.forClass = forClass;
    function forInstance(instance) {
        if (!instance[TRACER]) {
            instance[TRACER] = new Tracer(instance);
        }
        return instance[TRACER];
    }
    Tracer.forInstance = forInstance;
    function getArgNames(func) {
        // First match everything inside the function argument parens.
        const args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];
        // Split the arguments string into an array comma delimited.
        return args.split(',').map(function (arg) {
            // Ensure no inline comments are parsed and trim the whitespace.
            return arg.replace(/\/\*.*\*\//, '').trim();
        }).filter(function (arg) {
            // Ensure no undefined values are added.
            return arg;
        });
    }
    function wrapMethod(f, methodName, options) {
        return function (...functionArgs) {
            const printArgs = !options || isNil$1(options.args) || options.args;
            const printResult = printArgs || options.result;
            if (!options || !options.predicate || options.predicate(this)) {
                const logger = Logger.get(this);
                try {
                    if (printArgs) {
                        let debugArgs;
                        // const argNames = getArgNames(f);
                        debugArgs = isFunction(options?.formatArgs) ? options.formatArgs(functionArgs) : functionArgs.map(a => _defaultArgFormatter.format(a));
                        logger.enter(methodName.toString(), ...debugArgs);
                    }
                    else {
                        logger.enter(methodName.toString());
                    }
                    const result = f.call(this, ...functionArgs);
                    if (printResult) {
                        // todo: add formatResult options as well.
                        logger.exit(methodName.toString(), Array.isArray(result) ? result.map(e => _defaultArgFormatter.format(e)) : _defaultArgFormatter.format(result));
                    }
                    else {
                        logger.exit(methodName.toString());
                    }
                    return result;
                }
                catch (err) {
                    logger.exit(methodName.toString(), err);
                    throw err;
                }
            }
            else {
                return f.call(this, ...functionArgs);
            }
        };
    }
    Tracer.wrapMethod = wrapMethod;
})(Tracer || (Tracer = {}));

function Trace(options) {
    return (target, propertyKey, descriptor) => {
        assert.isFalsey(isFunction(target)); // only handling instance methods for now.
        descriptor.value = Tracer.wrapMethod(descriptor.value, propertyKey, options);
        return descriptor;
    };
}

/**
 * @file Automatically generated by barrelsby.
 */

var AllowNil;
(function (AllowNil) {
    function gateFunction(func, options) {
        return (value, index) => {
            if (isNotNil(value) || (options && options.allowNil)) {
                return func(value, index);
            }
            else {
                return undefined;
            }
        };
    }
    AllowNil.gateFunction = gateFunction;
    function isNotNil(value) {
        return !isNil(value);
    }
    AllowNil.isNotNil = isNotNil;
    function isNil$1(value) {
        return isNil(value);
    }
    AllowNil.isNil = isNil$1;
})(AllowNil || (AllowNil = {}));

var Functions;
(function (Functions) {
    Functions.identity = (item) => item;
    Functions.noop = () => { };
})(Functions || (Functions = {}));

var CanIdentify;
(function (CanIdentify) {
    function createIdentityFunction(options, defaultIdentity) {
        const emptyOptions = !options || (!options.identifiedBy && !options.identifiedWith);
        if (emptyOptions && !defaultIdentity) {
            lang.illegalArgument('must specify at least on of identifiedBy or identifiedWith or a defaultIdentity, got none.');
        }
        if (options) {
            if (options.identifiedBy && options.identifiedWith) {
                lang.illegalArgument('can only specify identifiedBy or identifiedWith, got both.');
            }
            const identityFunction = options.identifiedWith || ((item) => {
                return item ? item[options.identifiedBy] : undefined;
            });
            assert.isFunction(identityFunction);
            return (item) => {
                const customIdentity = identityFunction(item);
                // NOTE: we return the instance if the id is nil.  This allows the case where
                // non persisted entities (i.e. without ids) won't have the same identity.
                return isNil$1(customIdentity) ? item : customIdentity;
            };
        }
        else {
            return defaultIdentity || Functions.identity;
        }
    }
    CanIdentify.createIdentityFunction = createIdentityFunction;
    function wrap(source) {
        return isFunction(source['identityOf']) ? source['identityOf'] : Functions.identity;
    }
    CanIdentify.wrap = wrap;
})(CanIdentify || (CanIdentify = {}));

var DependsOnOptions;
(function (DependsOnOptions) {
    function arrayify(thing) {
        if (isNil$1(thing)) {
            return [];
        }
        else {
            return isArray$1(thing) ? thing : [thing];
        }
    }
    function forEach(options, callback) {
        if (options && options.dependsOn) {
            return arrayify(options.dependsOn).forEach(callback);
        }
    }
    DependsOnOptions.forEach = forEach;
    function extract(options) {
        return options && options.dependsOn ? arrayify(options.dependsOn) : [];
    }
    DependsOnOptions.extract = extract;
    function addDependency(options, dependency) {
        return options ?
            { ...options, dependsOn: arrayify(dependency).concat(options.dependsOn || []) } :
            { dependsOn: arrayify(dependency) };
    }
    DependsOnOptions.addDependency = addDependency;
})(DependsOnOptions || (DependsOnOptions = {}));

// TODO: subclass this into Value and List change transactions (currently its broken if people want to use the types with lists;
class Transaction {
    constructor(origin) {
        this.origin = origin;
        this._allDependencies = [];
        this._pendingDependents = [];
        this._sealed = false;
        this._commitWritten = false;
        this._commitFinished = false;
        this._completed = false;
        this._commitCallbacks = [];
        this._completeCallbacks = [];
        this._logListeners = [];
        this.initialValue = origin.value;
    }
    /**
     * Seals this transaction and prevents further dependents being added.  This should be called
     * immediately after onTransactionStart has been fired so and all interested parties have joined
     * the transaction.
     * We also pass in the the write callback here for convenience since having it in the constructor
     * @param writeCallback
     */
    seal(writeCallback) {
        this._sealed = true;
        this.writeCallback = assert.isFunction(writeCallback);
    }
    isSealed() {
        return this._sealed;
    }
    onCommit(callback, debugContext) {
        assert.isFalsey(this._commitWritten);
        this._commitCallbacks.push({ callback, debugContext });
    }
    onComplete(callback) {
        this._completeCallbacks.push(callback);
    }
    hasModel(model) {
        return this.origin === model;
    }
    addLogger(logger) {
        this._logListeners.push(logger);
    }
    get committedValue() {
        assert.isTruthy(this._commitWritten);
        return this._committedValue;
    }
    addDependent(dependent) {
        assert.isFalsey(this._sealed, "Can't join a sealed transaction.");
        this._allDependencies.push(dependent);
        this._pendingDependents.push(dependent);
        dependent.onComplete(tx => {
            this.notifyDependentCompleted(tx);
        });
    }
    notifyDependentCompleted(tx) {
        this._pendingDependents = this._pendingDependents.filter(d => d !== tx);
        this.checkIfComplete();
    }
    commit(value) {
        assert.isTruthy(this._sealed, "Can't commit a transaction until it's sealed");
        this._committedValue = this.origin.coerceValue(value);
        // ensure our source model has the new value before we notify anyone else.
        this.writeCallback(this._committedValue);
        this._commitWritten = true;
        this._logListeners.forEach(l => {
            this._safelyExecuteFunction("notify log listeners callback", () => l.notifyCommit(this));
        });
        // console.log("about to notify -> ", this.getDependents().map(d => DebugContext.get(d).getDebugLabel()))
        this._commitCallbacks.forEach(c => {
            this._safelyExecuteFunction("transaction commit callback", () => c.callback(this));
        });
        this._commitFinished = true;
        this.checkIfComplete();
    }
    // @Memoize()
    // getDependents() {
    //   return this._commitCallbacks.map(c => c.debugContext);
    // }
    checkIfComplete() {
        if (!this._completed && this._commitFinished && this._pendingDependents.length < 1) {
            this.completeTransaction();
        }
    }
    completeTransaction() {
        this._completed = true;
        this._logListeners.forEach(l => l.notifyComplete(this));
        this._completeCallbacks.forEach(c => {
            this._safelyExecuteFunction("transactionComplete callback", () => c(this));
        });
    }
    isComplete() {
        return this._completed;
    }
    hasChanged() {
        assert.isTruthy(this._commitWritten, "Can't check until transaction has committed.");
        return this.origin.hasChanged(this.initialValue, this.committedValue);
    }
    isRoot() {
        return this instanceof Transaction.Root;
    }
    onRootTransactionFinalised(listener) {
        this.getRoot().onFinalised(listener);
    }
    afterRootTransactionFinalised(listener) {
        this.getRoot().afterFinalised(listener);
    }
    visitDependencies(visitor) {
        this._allDependencies.forEach(d => visitor(d));
    }
    hasDependencies() {
        return this._allDependencies.length > 0;
    }
    getSourceDebugContext() {
        return DebugContext.getOrCreate(this.origin);
    }
    toGraph() {
        return new Transaction.Graph(this);
    }
    get debug() {
        const self = this;
        return {
            debugContextLabel: DebugContext.tryGet(self.origin)?.getDebugLabel(),
            initialValue: self.initialValue,
            commitWritten: self._commitWritten,
            commitFinished: self._commitFinished,
            committedValue: self._committedValue,
            hasChanged: self.origin.hasChanged(self.initialValue, self._committedValue),
            type: self.constructor.name
        };
    }
    dumpToLogs(transactionName = "tx") {
        Logger.get(this).info('You can view the following transaction graph at: https://dreampuf.github.io/GraphvizOnline');
        try {
            Logger.get(this).log(this.toGraph().toDot({
                name: transactionName,
                originStyle: Transaction.DEFAULT_ORIGIN_STYLE
            }));
        }
        catch (error) {
            Logger.get(this).warn("Tried to create dot file but failed:", error);
        }
    }
    dumpErrorToLogs(error, transactionName = "tx") {
        console.error(error);
        console.info('You can view the following transaction graph at: https://dreampuf.github.io/GraphvizOnline');
        try {
            Logger.get(this).log(this.toGraph().toDot({
                name: "tx",
                originStyle: Transaction.DEFAULT_ORIGIN_ERROR_STYLE
            }));
        }
        catch (error) {
            Logger.get(this).warn("Tried to create dot file but failed:", error);
        }
    }
    _safelyExecuteFunction(name, func) {
        try {
            func();
        }
        catch (error) {
            Logger.get(this).log(`Unhandled exception in: ${name}`);
            Logger.get(this).error(error);
            throw error;
        }
    }
}
(function (Transaction) {
    /**
     * Root Transaction
     */
    class Root extends Transaction {
        constructor() {
            super(...arguments);
            this._afterSealListeners = [];
            this._onFinaliseListeners = [];
            this._afterFinalisedListeners = [];
        }
        getRoot() {
            return this;
        }
        seal(writeCallback) {
            super.seal(writeCallback);
            uniq(this._afterSealListeners).forEach(callback => {
                this._safelyExecuteFunction("transaction onSealComplete", () => callback(this));
            });
        }
        onSealComplete(callback) {
            this._afterSealListeners.push(callback);
        }
        hasAncestor(model) {
            return this.origin === model;
        }
        visitParents(callback) {
            // noop.
        }
        afterFinalised(listener) {
            this._afterFinalisedListeners.push(listener);
        }
        fireAfterFinalised() {
            uniq(this._afterFinalisedListeners).forEach(callback => {
                this._safelyExecuteFunction("transaction afterFinalised", () => callback(this));
            });
        }
        onFinalised(listener) {
            this._onFinaliseListeners.push(listener);
        }
        fireFinalised() {
            uniq(this._onFinaliseListeners).forEach(callback => {
                this._safelyExecuteFunction("transaction onFinalised", () => callback(this));
            });
        }
    }
    Transaction.Root = Root;
    class Joined extends Transaction {
        constructor(dependentModel, onSourceTransactionsCommitted) {
            super(dependentModel);
            this.onSourceTransactionsCommitted = onSourceTransactionsCommitted;
            this._pendingParentTransactions = [];
            this._allParentTransactions = []; // this is only here for debug purposes
            this._hasSourceTransactionThatChanged = false;
        }
        dependsOn(sourceTx, hasDebugContext) {
            this.validateRootTransaction(sourceTx);
            this._allParentTransactions.push(sourceTx);
            this._pendingParentTransactions.push(sourceTx);
            sourceTx.addDependent(this);
            sourceTx.onCommit(tx => this.notifySourceCommitted(tx), hasDebugContext);
        }
        validateRootTransaction(sourceTx) {
            if (!this.rootTransaction) {
                this.rootTransaction = sourceTx.getRoot();
                this.rootTransaction.onSealComplete(() => this.validateAncestry());
            }
            else {
                if (this.rootTransaction !== sourceTx.getRoot()) {
                    Logger.get(this).error('Transaction started the belongs to a different root.');
                    Logger.get(this).info('You can view the following transaction graph at: https://dreampuf.github.io/GraphvizOnline');
                    Logger.get(this).log(this.rootTransaction.toGraph().toDot({
                        name: "existingRootTransaction"
                    }));
                    Logger.get(this).log(sourceTx.toGraph().toDot({
                        name: "newTransaction",
                        originStyle: {
                            fontcolor: "white",
                            fillcolor: 'red'
                        }
                    }));
                    lang.illegalState('Transaction started the belongs to a different root.');
                }
            }
        }
        notifySourceCommitted(tx) {
            this._hasSourceTransactionThatChanged = this._hasSourceTransactionThatChanged || tx.hasChanged();
            this._pendingParentTransactions = this._pendingParentTransactions.filter(sourceTx => sourceTx !== tx);
            if (this._pendingParentTransactions.length < 1) {
                this._safelyExecuteFunction("transaction notifySourceCommitted", () => {
                    this.onSourceTransactionsCommitted(this);
                });
            }
        }
        hasSourceTransactionsThatChanged() {
            return this._hasSourceTransactionThatChanged;
        }
        commit(value) {
            super.commit(value);
        }
        getRoot() {
            return this.rootTransaction;
        }
        hasAncestor(model) {
            for (let i = 0; i < this._allParentTransactions.length; i++) {
                const parent = this._allParentTransactions[i];
                if (parent.hasModel(model) || parent.hasAncestor(model)) {
                    return true;
                }
            }
            return false;
        }
        // protected findCircularDependencyPath(): Transaction<any>[] {
        //   const parent = new Set<Transaction<any>>();
        //   const model = this.origin;
        //   const accumulator = function (tx: Transaction<any>) {
        //     if (tx.hasModel(model)) {
        //       parent.add(tx)
        //     }
        //     if (tx.hasAncestor(model) && !parent.has(tx.origin)) {
        //       tx.visitParents(accumulator)
        //     }
        //   };
        //   this.visitParents(accumulator);
        //   return Array.from(parent);
        // }
        visitParents(callback) {
            for (let i = 0; i < this._allParentTransactions.length; i++) {
                callback(this._allParentTransactions[i]);
            }
        }
        validateAncestry() {
            if (this.hasAncestor(this.origin)) {
                Logger.get(this).error('Circular dependency detected:', {
                    // moreThanNoInfo: this.findCircularDependencyPath().map(tx => DebugContext.tryGet(tx.origin)?.getDebugLabel()),
                    graph: "TODO I need to print out the affected subgraph here.."
                });
                lang.illegalState('Circular dependency detected');
            }
        }
    }
    Transaction.Joined = Joined;
    function formatValueForLabel(value) {
        if (isArray$1(value)) {
            if (value.length < 1) {
                return "[]";
            }
            else {
                return `[${formatScalar(value[0])}...]`;
            }
        }
        else {
            return formatScalar(value);
        }
    }
    function formatScalar(value) {
        if (isObject$1(value)) {
            const debugContext = DebugContext.tryGet(value);
            return debugContext ?
                debugContext.getDebugLabel() :
                value.constructor ?
                    value.constructor.name :
                    "object";
        }
        return isString$1(value) ? `'${value}'` : `${value}`;
    }
    class Edge {
        constructor(source, dest) {
            this.source = source;
            this.dest = dest;
        }
        toDot() {
            return `${this.source.id} -> ${this.dest.id} [${this.getEdgeAttributes()}]`;
        }
        getEdgeAttributes() {
            const bits = [];
            const debug = this.source.debugSnapshot;
            const lineStyle = debug.commitWritten ?
                debug.commitFinished ? "solid" : "dashed" :
                "dotted"; // initial value.
            bits.push(`style=${lineStyle}`);
            if (debug.hasChanged) {
                bits.push(`color="black"`);
            }
            else {
                bits.push(`color="grey"`);
            }
            // use the initial value.
            if (!this.dest.isLeaf()) {
                bits.push(`label="${formatValueForLabel(debug.commitWritten ? debug.committedValue : debug.initialValue)}"`);
            }
            return bits.join(" ");
        }
    }
    Transaction.Edge = Edge;
    class Node {
        constructor(id, tx) {
            this.id = id;
            this.tx = tx;
            this.debugSnapshot = tx.debug;
        }
        setStyle(style) {
            this.style = style;
        }
        toDot() {
            const allAttrs = {
                ...this.getStyleAttributes(),
                ...this.getAttributes()
            };
            const bits = [];
            for (const key in allAttrs) {
                bits.push(`${key}="${allAttrs[key]}"`);
            }
            return `${this.id}[${bits.join(' ')}]`;
        }
        hasSource(tx) {
            return this.tx === tx;
        }
        getStyleAttributes() {
            const result = {
                shape: "rect"
            };
            if (this.style) {
                for (const key in this.style) {
                    result[key] = this.style[key];
                }
                if (result['fillcolor']) {
                    result['style'] = 'filled';
                }
            }
            return result;
        }
    }
    Transaction.Node = Node;
    class TransactionNode extends Node {
        getAttributes() {
            return {
                label: this.debugSnapshot.debugContextLabel
            };
        }
        isLeaf() {
            return false;
        }
    }
    Transaction.TransactionNode = TransactionNode;
    class TransactionTerminationNode extends Node {
        getAttributes() {
            const self = this;
            return {
                label: formatValueForLabel(self.debugSnapshot.committedValue)
            };
        }
        getStyleAttributes() {
            return {
                shape: "none"
            };
        }
        isLeaf() {
            return true;
        }
        hasSource(tx) {
            return false;
        }
    }
    Transaction.TransactionTerminationNode = TransactionTerminationNode;
    class Graph {
        constructor(graphOrigin) {
            this.graphOrigin = graphOrigin;
            this._nodes = new Map();
            this._edges = new Map();
            this.rootTransaction = graphOrigin.getRoot();
            this.addDependencies(this.rootTransaction);
        }
        addDependencies(tx) {
            const node = this.getTransactionModelNode(tx);
            const debug = tx.debug;
            // console.log({tx: debug.debugContextLabel,type:debug.type, dependencies: tx["_allDependencies"].length, v: debug.committedValue});
            if (tx.hasDependencies()) {
                tx.visitDependencies(dependent => {
                    this.addEdge(node, this.getTransactionModelNode(dependent));
                    this.addDependencies(dependent);
                });
            }
            else {
                this.addEdge(node, this.getTransactionTerminationNode(tx));
            }
        }
        get edges() {
            return Array.from(this._edges.values());
        }
        getTransactionModelNode(tx) {
            let node = this._nodes.get(tx.origin);
            if (!node) {
                node = new TransactionNode(`${this._nodes.size}`, tx);
                this._nodes.set(tx.origin, node);
            }
            return node;
        }
        getTransactionTerminationNode(tx) {
            let txNode = this.getTransactionModelNode(tx);
            const id = `_${txNode.id}`; // we don't have a model for this so we generate an id and use that to track it.
            let node = this._nodes.get(id);
            if (!node) {
                node = new TransactionTerminationNode(id, tx);
                this._nodes.set(id, node);
            }
            return node;
        }
        addEdge(from, to) {
            const edgeId = `${from.id}:${to.id}`;
            if (!this._edges.has(edgeId)) {
                this._edges.set(edgeId, new Edge(from, to));
            }
        }
        toDot(options) {
            const opts = OptionsHelper.for(options);
            const nodes = Array.from(this._nodes.values()).map(n => {
                if (n.hasSource(this.rootTransaction)) {
                    if (n.hasSource(this.graphOrigin)) {
                        n.setStyle(opts.get("originStyle", Transaction.DEFAULT_ROOT_STYLE));
                    }
                    else {
                        n.setStyle(opts.get("rootStyle", Transaction.DEFAULT_ROOT_STYLE));
                    }
                }
                else {
                    if (n.hasSource(this.graphOrigin)) {
                        n.setStyle(opts.get("originStyle", Transaction.DEFAULT_ORIGIN_STYLE));
                    }
                }
                return n.toDot();
            });
            const edges = this.edges.map(e => e.toDot());
            return `digraph ${opts.get("name", "pectinTransaction")} {${nodes.join(`;`)} ${edges.join(`;`)}}`;
        }
    }
    Transaction.Graph = Graph;
    Transaction.DEFAULT_ROOT_STYLE = {
        fontcolor: "#307d30",
        fillcolor: "#7FFF91"
    };
    Transaction.DEFAULT_ORIGIN_STYLE = {
        fontcolor: "#5E5CEC",
        fillcolor: "#DADEFF"
    };
    Transaction.DEFAULT_ORIGIN_ERROR_STYLE = {
        fontcolor: "white",
        fillcolor: 'red'
    };
})(Transaction || (Transaction = {}));

/**
 * Note: this would be better implemented as a Mixin but we'd need the ability for the mixin to extend classes with private members.
 * https://github.com/microsoft/TypeScript/issues/17744#issuecomment-558990381
 * https://github.com/microsoft/TypeScript/pull/30979
 */
class ComputedModelMechanics extends GarbageCollector {
    constructor(sourceModel, sourceModelStore, options) {
        super();
        this.sourceModel = sourceModel;
        this.sourceModelStore = sourceModelStore;
        this.options = options;
        this.__neverComputed = true;
        this.__ignoreSourceChangeEvents = false;
        const self = this;
        this.__computedStore = {
            read() {
                if (self.isGateOpen()) {
                    // compute on first call if not prior.
                    // This creates double computes when firing change events as the read of the previous
                    // value triggers a compute, as does the actual handling of the event.
                    self.ensureSourceComputed();
                    return self.sourceModelStore.read();
                }
                else {
                    return self.__lastPublicValue;
                }
            },
            write(value) {
                self.__neverComputed = false;
                self.__lastPublicValue = value;
                self.sourceModelStore.write(value);
            }
        };
        this.__lastPublicValue = sourceModelStore.read(); // bypass any gate state to get the initialValue.
        // intialise our gating
        this.initialiseGating(options);
        // track all our regular dependencies.
        DependsOnOptions.forEach(options, m => {
            assert.notNil(m);
            this.sourceModel.trackSource(m);
        });
        // and handle any source changes.
        this.registerDisposable(this.sourceModel.onSourceTransactionStart(tx => this.handleSourceTransactionStart(tx)));
    }
    /**
     * Safely creates a gate from the specified options.  Returns null if the options are nil or don't
     * contain any gate options.
     * @param gateOptions
     */
    initialiseGating(gateOptions) {
        if (gateOptions && (gateOptions.postponeUntil || gateOptions.postponeWhile)) {
            this.__invertGate = !!gateOptions.postponeWhile;
            this.__gate = gateOptions.postponeWhile || gateOptions.postponeUntil;
            assert.notNil(this.__gate);
            this.sourceModel.trackSource(this.__gate);
        }
    }
    get computedStore() {
        return this.__computedStore;
    }
    handleSourceTransactionStart(sourceTx) {
        if (!this.__ignoreSourceChangeEvents) {
            if (!this.sourceModel.isInTransaction()) {
                this.sourceModel.joinTransaction(sourceTx, joinedTX => {
                    // TODO: need to add specific tests for hasSourceTransactionThatChanged.
                    // This ensures that computed models only fire if one or more of their source transactions changes. Previously we
                    // had the case where a binding was returning the previous value but computed models were still being computed (since they
                    // weren't checking if their parent actually changed).
                    // currently this is picked up by binding.spec "doesn't fire events if the binding returns the current value." and
                    // by the MultipleSelectionModel spec  describe("and one item selected" => it("someSelected is true", () => expect(subject.someSelected.value).to.be.true)
                    if (this.isGateOpen() && joinedTX.hasSourceTransactionsThatChanged()) {
                        joinedTX.commit(this.computeSourceValue({ onErrorDumpStateOf: joinedTX }));
                    }
                    else {
                        // the gate has closed during the transaction, do a noop.
                        joinedTX.commit(joinedTX.initialValue);
                    }
                }, this.sourceModel);
            }
            else {
                if (this.sourceModel.currentTransaction instanceof Transaction.Joined) {
                    this.sourceModel.currentTransaction.dependsOn(sourceTx, this.sourceModel);
                }
                else {
                    lang.illegalState(`doh, looks a source has changed when we're not in a joined transaction `);
                }
            }
        }
    }
    runInTransaction(func) {
        if (this.isGateOpen()) {
            // we don't know what the function will do, it could well change the values of
            // some of our sources so we ignore any changes while we run the transaction.
            return this.__whileIgnoringSourceChangeEvents(() => {
                if (this.sourceModel.isInTransaction()) {
                    return this._safelyExecuteFunction('runInTransaction callback', func, { onErrorDumpStateOf: this.sourceModel.currentTransaction });
                }
                else {
                    const tx = this.sourceModel.startTransaction();
                    try {
                        return this._safelyExecuteFunction('runInTransaction callback', func, { onErrorDumpStateOf: tx });
                    }
                    finally {
                        if (this.isGateOpen()) {
                            const newValue = this.computeSourceValue({ onErrorDumpStateOf: tx });
                            this.__lastPublicValue = newValue;
                            tx.commit(newValue);
                        }
                        else {
                            // the gate has closed during the transaction, do a noop.
                            tx.commit(tx.initialValue);
                        }
                    }
                }
            });
        }
        else {
            return this._safelyExecuteFunction('runInTransaction callback', func);
        }
    }
    isGateOpen() {
        return this.__gate ? !!(this.__invertGate ? !this.__gate.value : this.__gate.value) : true;
    }
    /**
     * Computes the value if it's never been computed before.
     * This method will not fire any events.
     */
    ensureSourceComputed() {
        this.__assertGateOpen();
        if (this.__neverComputed) {
            this.__computedStore.write(this.computeSourceValue());
        }
    }
    computeSourceValue(debugOptions) {
        this.__assertGateOpen();
        return this._safelyExecuteFunction('doComputeValue()', () => {
            return this.sourceModel.doComputeValue();
        }, debugOptions);
    }
    _safelyExecuteFunction(name, func, debugOptions) {
        try {
            return func();
        }
        catch (error) {
            const message = `Unhandled exception in ${name}`;
            console.trace(message);
            console.error(error);
            if (debugOptions) {
                const transactions = Array.isArray(debugOptions.onErrorDumpStateOf) ? debugOptions.onErrorDumpStateOf : [debugOptions.onErrorDumpStateOf];
                transactions.forEach(tx => tx?.dumpErrorToLogs(error));
            }
            throw error;
        }
    }
    __assertGateOpen() {
        assert.isTruthy(this.isGateOpen(), "expected gate to be open but it wasn't");
    }
    __whileIgnoringSourceChangeEvents(func) {
        this.__ignoreSourceChangeEvents = true;
        try {
            return func();
        }
        finally {
            this.__ignoreSourceChangeEvents = false;
        }
    }
}

class Converters {
    static identity() {
        return {
            fromSource(value) {
                return value;
            },
            toSource(value) {
                return value;
            },
            toLeft(value) {
                return value;
            },
            toRight(value) {
                return value;
            }
        };
    }
    static multiplyBy(amount) {
        return {
            fromSource(num) {
                return num * amount;
            },
            toSource(num) {
                return num / amount;
            },
            toLeft(num) {
                return isNumber(num) ? num * amount : undefined;
            },
            toRight(num) {
                return isNumber(num) ? num / amount : undefined;
            }
        };
    }
    static divideBy(amount) {
        return {
            fromSource(num) {
                return num / amount;
            },
            toSource(num) {
                return num * amount;
            },
            toLeft(num) {
                return isNumber(num) ? num / amount : undefined;
            },
            toRight(num) {
                return isNumber(num) ? num * amount : undefined;
            }
        };
    }
}

class HasValue {
    constructor(options) {
        this._transactionLoggers = new EventListenerList();
        this._transactionStartListeners = new EventListenerList();
        this._valueChangeListeners = new EventListenerList();
        const self = this;
        this._valueStore = {
            read() {
                return self.__value;
            },
            write(value) {
                self.__value = self.coerceValue(value);
            }
        };
        if (options) {
            this._valueStore.write(options.initialValue);
        }
        this._identityOf = CanIdentify.createIdentityFunction(options, Functions.identity);
        this._changed = options && options.changed ? options.changed : HasValue.changed;
    }
    // Trap for the unwary, if you override only one of the get/set accessors in a subclass
    // it will nuke the other one and drive you nuts.  .
    get value() {
        return this.valueStore.read();
    }
    get valueStore() {
        return this._valueStore;
    }
    hasChanged(a, b) {
        return this._changed(a, b);
    }
    coerceValue(value) {
        return value;
    }
    get identityOf() {
        return this._identityOf;
    }
    startTransaction() {
        return this.__startTransaction();
    }
    /**
     * Joins this model to the specified transaction.  This method can be invoked multiple times during a single
     * transaction as long as they all have the same root.  In this case the commit callback will be invoked
     * after all the source models have committed.
     * @param sourceTx the transaction to join.
     * @param onSourceTransactionsCommitted a callback to execute when all joined transaction has committed.
     * @param debugContextOwner
     */
    joinTransaction(sourceTx, onSourceTransactionsCommitted, debugContextOwner) {
        if (this.__currentTransaction instanceof Transaction.Joined) {
            this.__currentTransaction.dependsOn(sourceTx, debugContextOwner);
            return this.__currentTransaction;
        }
        else {
            const tx = new Transaction.Joined(this, onSourceTransactionsCommitted);
            tx.dependsOn(sourceTx, debugContextOwner);
            return this.__startTransaction(tx);
        }
    }
    __startTransaction(transaction) {
        if (this.__currentTransaction) {
            Pectin.get()._notifyRaceCondition(this.__currentTransaction, transaction);
            this.__currentTransaction.dumpErrorToLogs('Start transaction called when transaction already in process.', "currentTransaction");
            if (transaction) {
                transaction.dumpToLogs("newTransaction");
            }
            lang.illegalState('Start transaction called when transaction already in process.');
        }
        // console.log(`${DebugContext.get(this).getDebugLabel()}.__startTransaction`, {dependents: this.getTransactionListenerContexts().map(c => c && DebugContext.get(c).getDebugLabel())});
        this.__currentTransaction = transaction || new Transaction.Root(this);
        this._transactionLoggers.fire(l => l.notifyStart(this.__currentTransaction));
        this._fireTransactionStart(this.__currentTransaction);
        const self = this;
        if (this._transactionLoggers.listenerCount > 0) {
            this.__currentTransaction.addLogger({
                notifyStart(tx) {
                    // not fired by the tx
                },
                notifyCommit(tx) {
                    self._transactionLoggers.fire(l => l.notifyCommit(tx));
                },
                notifyComplete(tx) {
                    self._transactionLoggers.fire(l => l.notifyComplete(tx));
                },
                notifyEnd(tx) {
                    // not fired by the tx
                }
            });
        }
        this.__currentTransaction.seal(committedValue => {
            this.valueStore.write(committedValue);
        });
        this.__currentTransaction.onComplete((tx) => {
            this.assertCurrentTransaction(tx);
            // todo: should I fire this after the root transaction completes?
            if (tx.hasChanged()) {
                this._fireValueChange(tx);
            }
            this.__currentTransaction = undefined;
            // TODO: how am I using onTransactionEnd listeners? are they needed now that there's a rootTx after end?
            this._transactionLoggers.fire(l => l.notifyEnd(tx));
            if (tx.isRoot()) {
                tx.fireFinalised();
                tx.fireAfterFinalised();
            }
        });
        return this.__currentTransaction;
    }
    assertCurrentTransaction(tx) {
        assert.notNil(this.__currentTransaction, '__currentTransaction');
        assert.isTruthy(tx === this.__currentTransaction);
    }
    _fireTransactionStart(tx) {
        this._transactionStartListeners.fire(l => {
            this._safelyExecuteFunction("onTransactionStart(..) callback", () => l.callback(tx));
        });
    }
    /**
     * @deprecated This has been replaced by transaction listeners
     */
    _fireValueChange(tx) {
        this._valueChangeListeners.fire(listener => {
            return listener(tx.committedValue, tx.initialValue, tx);
        });
    }
    _safelyExecuteFunction(name, func) {
        return Logger.get(this).runWithDebug(name, func);
    }
    addTransactionLogger(logger) {
        return this._transactionLoggers.add(logger);
    }
    /**
     * Adds a transaction start listener to this model.  When fired all models involved in the transaction will
     * still report their initial value.
     * @param listener
     * @param listenerContext the object that is listening. This can be used to for debugging purposes.
     */
    // @Trace()
    onTransactionStart(listener, listenerContext) {
        return this._transactionStartListeners.add({ callback: listener, debugContext: listenerContext });
    }
    /**
     * This listener will be called when all participants in the transaction have committed and
     * the transaction is no longer active.
     * @param listener
     */
    onTransactionFinalised(listener, debugContext) {
        return this._transactionStartListeners.add({
            callback: tx => {
                tx.onRootTransactionFinalised(root => {
                    this._safelyExecuteFunction("onRootTransactionFinalised(..) callback", () => listener(tx));
                });
            }, debugContext
        });
    }
    getTransactionListenerContexts() {
        return this._transactionStartListeners.map(l => l.debugContext);
    }
    /**
     * @deprecated This has been replaced by the DSL for user land code and by
     * transaction listeners for lower level requirements.
     *
     * Adds a value change listener to this model.
     * @param func
     * @returns {Disposable} returns a dispose instance that can be used to remove the listener
     * and free the memory reference.
     */
    onValueChange(func) {
        return this._valueChangeListeners.add(func);
    }
    get currentTransaction() {
        return this.__currentTransaction;
    }
    isInTransaction() {
        return !!this.currentTransaction;
    }
    isChanging() {
        return this.isInTransaction();
    }
}
(function (HasValue) {
    function isNilOrEmpty(item) {
        return isNil$1(item) || Array.isArray(item) && item.length == 0;
    }
    HasValue.isNilOrEmpty = isNilOrEmpty;
    function bothNilOrEmpty(a, b) {
        return isNilOrEmpty(a) && isNilOrEmpty(b);
    }
    HasValue.bothNilOrEmpty = bothNilOrEmpty;
    function changed(a, b) {
        if (bothNilOrEmpty(a, b)) {
            return false;
        }
        else {
            return a !== b;
        }
    }
    HasValue.changed = changed;
})(HasValue || (HasValue = {}));

var HasDependents;
(function (HasDependents) {
    function Mixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__sourceMap = new Map();
                this.__otherGarbage = new GarbageCollector();
                this.__txStartListeners = new EventListenerList();
            }
            trackSource(source) {
                assert.notNil(source);
                return this.__trackSource(source);
            }
            untrackSource(source) {
                if (source) {
                    this.__untrackSource(source);
                }
            }
            // registers a disposable shouldn't trigger a change.
            registerDisposable(disposable) {
                return this.__otherGarbage.registerDisposable(disposable);
            }
            dispose() {
                this.__getSourceMap().forEach(registration => {
                    registration.dispose();
                });
                this.__otherGarbage.dispose();
                this.__getSourceMap().clear();
            }
            onSourceTransactionStart(transactionListener) {
                return this.__txStartListeners.add(transactionListener);
            }
            sourceModels() {
                return Array.from(this.__getSourceMap().keys());
            }
            __getSourceMap() {
                return this.__sourceMap;
            }
            _alreadyDependsOn(sourceModel) {
                return !!this.__getSourceMap().get(sourceModel);
            }
            __trackSource(source) {
                if (!(source instanceof HasValue)) {
                    lang.illegalState(`source must be an instance of HasValue, got ${source}`);
                }
                if (this.__getSourceMap().has(source)) {
                    lang.illegalState(`Source model already being tracked.`);
                }
                let transactionStartedRegistration = source.onTransactionStart(tx => this.__txStartListeners.fire(l => l(tx)), this);
                this.__getSourceMap().set(source, transactionStartedRegistration);
                const self = this;
                return {
                    dispose() {
                        self.__untrackSource(source);
                    }
                };
            }
            __untrackSource(source) {
                // delete returns true rather than the deleted value, so doing the get and delete separately
                let valueChangeRegistration = this.__getSourceMap().get(source);
                if (valueChangeRegistration) { // in case we're called more than once. should probably barf instead...
                    valueChangeRegistration.dispose();
                }
                this.__getSourceMap().delete(source);
            }
        };
    }
    HasDependents.Mixin = Mixin;
})(HasDependents || (HasDependents = {}));

class ReadonlyProxyHandler {
    set(target, property, value) {
        if (property === 'value') {
            throw lang.illegalState("can't set the value on readonly models");
        }
        // The default behavior to store the value
        target[property] = value;
        // Indicate success
        return true;
    }
}

// TODO: Add a throttling variant that collects intermediate values and pushes the collected result as an array.
class ThrottledAccumulator {
    constructor(millisecondDelay, delayInitial) {
        this.millisecondDelay = millisecondDelay;
        this.delayInitial = delayInitial;
        this.listeners = new EventListenerList();
    }
    subscribe(callback) {
        return this.listeners.add(callback);
    }
    push(value) {
        if (!this.collectedValues) {
            if (this.delayInitial) {
                this.startCollecting(value);
            }
            else {
                // push the first value through immediately and start a timer.
                this.notifyListeners([value]);
                this.startCollecting();
            }
        }
        else {
            // in a timer so we collect things.
            this.collectedValues.push(value);
        }
    }
    startCollecting(initialValue) {
        this.collectedValues = isNil$1(initialValue) ? [] : [initialValue];
        this.timeout = setTimeout(() => this.onTimeoutFinished(), this.millisecondDelay);
    }
    onTimeoutFinished() {
        const values = this.collectedValues;
        if (values.length > 0) {
            // we got something the last tick so publish and continue collecting until we get an empty tick.
            this.notifyListeners(values);
            this.startCollecting();
        }
        else {
            // we've had a subsequent tick with no data so we reset to virgin state.
            this.collectedValues = undefined;
        }
    }
    notifyListeners(values) {
        this.listeners.fire(callback => callback(values));
    }
}

class TransactionObserver {
    constructor(options) {
        this.options = options;
        this.eventListenerList = new EventListenerList();
        this.rootListenerList = new EventListenerList();
        this.models = [];
        this.events = [];
        this.notifyRootFinalised = (rootTx) => {
            this.rootListenerList.fire(l => l(rootTx));
        };
    }
    observe(name, hasValue) {
        const model = new TransactionObserver.Model(name, hasValue, this.options, event => this.notifyEvent(event), this.notifyRootFinalised);
        this.models.push(model);
        return hasValue;
    }
    /**
     * @deprecated use onTransactionFinished
     * @param callback
     */
    onRootFinalised(callback) {
        return this.onTransactionFinished(callback);
    }
    onTransactionFinished(callback) {
        return this.rootListenerList.add(callback);
    }
    onEvent(callback) {
        this.eventListenerList.add(callback);
        return this;
    }
    notifyEvent(event) {
        this.events.push(event);
        this.eventListenerList.fire(l => l(event));
    }
    get errors() {
        return [];
    }
    get sequence() {
        return this.events.map(e => e.toString());
    }
    reset() {
        this.events = [];
    }
}
(function (TransactionObserver) {
    function format(value) {
        if (isNil$1(value)) {
            return '?';
        }
        else {
            if (isMap(value)) {
                return CircularJSON.stringify(Array.from(value.entries()).reduce((sum, entry) => {
                    const key = entry[0];
                    sum[key] = entry[1];
                    return sum;
                }, {}));
            }
            else {
                return isObject$1(value) ? CircularJSON.stringify(value) : value;
            }
        }
    }
    class Model {
        constructor(name, hasValue, options, callback, rootFinaliseCallback) {
            this.name = name;
            this.hasValue = hasValue;
            this.options = options;
            this.callback = callback;
            this.rootFinaliseCallback = rootFinaliseCallback;
            this.hangingTimeout = undefined;
            const self = this;
            this.hasValue.addTransactionLogger({
                notifyStart(tx) {
                    if (options?.detectHanging) {
                        self.hangingTimeout = setTimeout(() => {
                            if (!tx.isComplete()) {
                                console.error("Hanging transaction detected", tx.getSourceDebugContext().getDebugLabel());
                                console.error(tx.toGraph().toDot());
                            }
                        }, 2000);
                    }
                    tx.onRootTransactionFinalised(rootFinaliseCallback);
                    if (options?.verbose) {
                        callback(new Event(name, "start", { initialValue: tx.initialValue }, payload => format(payload.initialValue)));
                    }
                },
                notifyCommit(tx) {
                    if (tx.hasChanged()) {
                        callback(new Event(name, 'commit', {
                            initialValue: tx.initialValue,
                            committedValue: tx.committedValue
                        }, payload => `${format(payload.initialValue)}->${format(payload.committedValue)}`));
                    }
                    else {
                        callback(new Event(name, 'commit', "no change"));
                    }
                },
                notifyComplete(tx) {
                    if (options?.verbose) {
                        callback(new Event(name, "complete"));
                    }
                },
                notifyEnd(tx) {
                    if (options?.verbose) {
                        callback(new Event(name, "end"));
                    }
                    if (!isNil$1(self.hangingTimeout)) {
                        clearTimeout(self.hangingTimeout);
                    }
                }
            });
        }
    }
    TransactionObserver.Model = Model;
    class Event {
        constructor(modelName, type, payload, payloadFormatter) {
            this.modelName = modelName;
            this.type = type;
            this.payload = payload;
            this.payloadFormatter = payloadFormatter;
        }
        get name() {
            return `${this.modelName}->${this.type}`;
        }
        toString() {
            const formattedPayload = this.payload ?
                this.payloadFormatter ? this.payloadFormatter(this.payload) : this.payload :
                '';
            return `${this.modelName}->${this.type}(${formattedPayload})`;
        }
    }
    TransactionObserver.Event = Event;
})(TransactionObserver || (TransactionObserver = {}));

/**
 * @file Automatically generated by barrelsby.
 */

/**
 * A point in time snap shot of a models value.
 */
class ValueQuery {
    constructor(value, identityOf) {
        this.value = value;
        this.identityOf = identityOf;
    }
    /**
     * Returns true if the identity of the current value === the identity of the other.
     * @param other the value to compare to the models current value.
     */
    equals(other) {
        return this.identityOf(this.value) === this.identityOf(other);
    }
    /**
     * Returns true if the current value is `null` or `undefined`..
     */
    isNil() {
        return isNil(this.value);
    }
    /**
     * Returns true if the identity of any of the other values === the identity of they current value.
     * @param others the values to compare with the models current value.
     */
    isAnyOf(others) {
        return !!find(others, other => this.equals(other));
    }
}

class ValueModel extends HasValue {
    /**
     * Returns a read only version of the model.  Multiple calls will return the same instance.
     */
    get readonly() {
        return lang.abstractMethod(this, "readonly");
    }
    /**
     * Returns a snapshot of the current state.
     */
    query() {
        return new ValueQuery(this.value, this.identityOf);
    }
}
(function (ValueModel) {
    class Constant extends ValueModel {
        constructor(constantValue) {
            super({ initialValue: constantValue });
            this.constantValue = constantValue;
            DebugContext.getOrCreate(this).tag(`constant`);
        }
        get readonly() {
            return this;
        }
    }
    function constant(value) {
        return new Constant(value);
    }
    ValueModel.constant = constant;
    ValueModel.TRUE = constant(true);
    ValueModel.FALSE = constant(false);
    function isInstance(object) {
        return object instanceof ValueModel;
    }
    ValueModel.isInstance = isInstance;
    function wrap(value) {
        return ValueModel.isInstance(value) ? value : constant(value);
    }
    ValueModel.wrap = wrap;
})(ValueModel || (ValueModel = {}));

class MutableValueModel extends ValueModel {
    constructor(initialValue = undefined, options) {
        super({ initialValue, ...options });
        if (!isNil$1(initialValue)) {
            this.valueStore.write(this.coerceValue(initialValue));
        }
    }
    // Trap for the unwary, if you override only one of the get/set accessors in a subclass
    // it will nuke the other one and drive you nuts.  .
    get value() {
        return this.valueStore.read();
    }
    set value(value) {
        this.startTransaction().commit(value);
    }
    runInTransaction(func) {
        const draft = new MutableValueModel(this.value);
        const tx = this.startTransaction();
        this._safelyExecuteFunction('runInTransaction', () => func(draft));
        tx.commit(draft.value);
    }
    get readonly() {
        if (!this.__readonly) {
            this.__readonly = new Proxy(this, new ReadonlyProxyHandler());
            DebugContext.getOrCreate(this.__readonly).tag(`readonly`);
        }
        return this.__readonly;
    }
}
(function (MutableValueModel) {
    /**
     * @deprecated use ValueModel.wrap instead
     * @param object
     */
    function wrap(object) {
        return ValueModel.wrap(object);
    }
    MutableValueModel.wrap = wrap;
})(MutableValueModel || (MutableValueModel = {}));

class Binding extends GarbageCollector {
    // the "source" is on the left... as far as the converter is concerned.. this needs to be
    // make explicit to the toSource/fromSource match the left and right.
    constructor(left, right, binding) {
        super();
        this._writeInProgress = false;
        this._direction = new MutableValueModel();
        this.rightCommitCallback = (rightTx) => {
            Logger.get(this).runWithDebug("rightCommitCallback", () => {
                const value = this._converter.toRight(this._left.value, this._right.value);
                rightTx.commit(value);
            });
        };
        this.leftCommitCallback = (leftTx) => {
            Logger.get(this).runWithDebug("leftCommitCallback", () => {
                const value = this._converter.toLeft(this._right.value, this._left.value);
                leftTx.commit(value);
            });
        };
        this._left = assert.notNil(left);
        this._right = assert.notNil(right);
        this._converter = assert.notNil(binding);
        this.rightDependsOn(this._left);
        this.leftDependsOn(this._right);
        DependsOnOptions.forEach({ dependsOn: binding.leftDependsOn }, d => this.leftDependsOn(d));
        DependsOnOptions.forEach({ dependsOn: binding.rightDependsOn }, d => this.rightDependsOn(d));
    }
    rightDependsOn(other) {
        const self = this;
        this.registerDisposable(other.onTransactionStart((sourceTx) => {
            if (!self._right.isChanging() && !self._writeInProgress) {
                self._direction.value = Binding.Direction.RIGHT;
                this._right.joinTransaction(sourceTx, this.rightCommitCallback, this);
                sourceTx.onRootTransactionFinalised(() => {
                    self._direction.value = undefined;
                });
            }
        }, this));
        return this;
    }
    leftDependsOn(other) {
        const self = this;
        this.registerDisposable(other.onTransactionStart((sourceTx) => {
            if (!self._left.isChanging() && !self._writeInProgress) {
                self._direction.value = Binding.Direction.LEFT;
                this._left.joinTransaction(sourceTx, this.leftCommitCallback, this);
                sourceTx.onRootTransactionFinalised(() => {
                    self._direction.value = undefined;
                });
            }
        }, this));
        return this;
    }
    convertRightToLeft() {
        return this._converter.toLeft(this._right.value, this._left.value);
    }
    convertLeftToRight() {
        return this._converter.toRight(this._left.value, this._right.value);
    }
    writeLeft() {
        this.doWrite(() => {
            this._left.value = this.convertRightToLeft();
        }, Binding.Direction.LEFT);
        return this;
    }
    writeRight() {
        this.doWrite(() => {
            this._right.value = this.convertLeftToRight();
        }, Binding.Direction.RIGHT);
        return this;
    }
    /**
     * We need this since a leftDependsOn change will trigger a left update that will trigger a right update. This way
     * we'll only ever perform on write on any give dependency change.
     * TODO: It would be nice if I can add this to the callbacks directly.  i.e. if (!this._updateInProgress && !...isChanging())
     * @param func
     */
    doWrite(func, direction) {
        if (!this._writeInProgress) {
            try {
                this._writeInProgress = true;
                this._direction.value = direction;
                Logger.get(this).runWithDebug("doWrite", () => func());
            }
            finally {
                this._direction.value = undefined;
                this._writeInProgress = false;
            }
        }
    }
    get direction() {
        return this._direction.readonly;
    }
    isWritingLeft() {
        return this._direction.value === Binding.Direction.LEFT;
    }
    isWritingRight() {
        return this._direction.value === Binding.Direction.RIGHT;
    }
    isChangeImperative() {
        return this._writeInProgress;
    }
}
(function (Binding) {
    function adaptConverter(converter) {
        return {
            toRight(leftValue, currentRightValue) {
                return converter.toSource(leftValue, currentRightValue);
            },
            rightDependsOn: converter.toSourceDependsOn,
            toLeft(rightValue, currentLeftValue) {
                return converter.fromSource(rightValue, currentLeftValue);
            },
            leftDependsOn: converter.fromSourceDependsOn
        };
    }
    Binding.adaptConverter = adaptConverter;
    class Identity extends Binding {
        constructor(left, right) {
            super(left, right, {
                toLeft(rightValue) {
                    return rightValue;
                },
                toRight(leftValue) {
                    return leftValue;
                }
            });
        }
    }
    Binding.Identity = Identity;
})(Binding || (Binding = {}));
(function (Binding) {
    let Direction;
    (function (Direction) {
        Direction["LEFT"] = "left";
        Direction["RIGHT"] = "right";
    })(Direction = Binding.Direction || (Binding.Direction = {}));
})(Binding || (Binding = {}));

/**
 * @deprecated use ValueModel.constant(value) instead
 */
class Constant extends ValueModel {
    constructor(constantValue) {
        super({ initialValue: constantValue });
        this.constantValue = constantValue;
        DebugContext.getOrCreate(this).tag(`constant`);
    }
    get readonly() {
        return this;
    }
}
(function (Constant) {
    /**
     * @deprecated use ValueModel.TRUE instead
     */
    Constant.TRUE = ValueModel.TRUE;
    /**
     * @deprecated use ValueModel.FALSE instead
     */
    Constant.FALSE = ValueModel.FALSE;
})(Constant || (Constant = {}));

/**
 * @deprecated use MutableListModel<T> instead
 */
class ValueHolder extends MutableValueModel {
}

class AbstractComputedValueModel extends HasDependents.Mixin(ValueModel) {
    constructor(options) {
        super({ initialValue: undefined, ...options });
        this._allowNil = !!options?.allowNil;
        // Note: this would be better implemented as a Mixin but we'd need the ability for the mixin to extend classes with private members.
        this.computedModelMechanics = this.registerDisposable(new ComputedModelMechanics(this, this._valueStore, options));
    }
    get valueStore() {
        return this.computedModelMechanics.computedStore;
    }
    runInTransaction(func) {
        return this.computedModelMechanics.runInTransaction(func);
    }
    get allowNil() {
        return this._allowNil;
    }
    // @ts-ignore hmmmm
    get readonly() {
        return this;
    }
}

class ReducingValueModel extends AbstractComputedValueModel {
    constructor(sources, options) {
        super(ReducingValueModel.prepareOptions(sources, options));
    }
    doComputeValue() {
        let values = map(this.sourceModels(), s => s.value);
        return this.compute(values);
    }
}
(function (ReducingValueModel) {
    function create(source, fn, options = { initialValue: undefined }) {
        return new ReduceValueModelImpl(source, fn, options);
    }
    ReducingValueModel.create = create;
    class ReduceValueModelImpl extends ReducingValueModel {
        constructor(sources, fn, options) {
            super(sources, options);
            this.fn = fn;
        }
        compute(value) {
            return this.fn(value);
        }
    }
    ReducingValueModel.ReduceValueModelImpl = ReduceValueModelImpl;
    function prepareOptions(sources, options) {
        return { ...DependsOnOptions.addDependency(options, sources), allowNil: true };
    }
    ReducingValueModel.prepareOptions = prepareOptions;
})(ReducingValueModel || (ReducingValueModel = {}));

// not sure if there's an easier way to do this... but I'm implementing manually here.
class AndValueModel extends ReducingValueModel {
    constructor(sources = [], options) {
        super(sources, options);
        this._defaultValue = false;
    }
    setDefault(value) {
        this._defaultValue = value;
        return this;
    }
    addSource(source) {
        this.runInTransaction(() => {
            this.trackSource(source);
        });
    }
    compute(values) {
        return values.length > 0 ? values.reduce((a, b) => a && b) : this._defaultValue;
    }
}
(function (AndValueModel) {
    class Truthy extends AndValueModel {
        compute(values) {
            return super.compute(values.map(v => !!v));
        }
    }
    AndValueModel.Truthy = Truthy;
})(AndValueModel || (AndValueModel = {}));

class ChangeMonitorValueModel extends ValueModel {
    constructor(source, changingValue, stableValue, _millisecondDelay = 250) {
        super({ initialValue: stableValue });
        this.changingValue = changingValue;
        this.stableValue = stableValue;
        this._millisecondDelay = _millisecondDelay;
        this._source = source;
        this._registration = this._source.onTransactionFinalised(() => this.triggerUpdate());
    }
    get readonly() {
        return this;
    }
    dispose() {
        this._registration.dispose();
    }
    triggerUpdate() {
        if (this.value === this.stableValue) {
            this.updateState(this.changingValue);
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => this.updateState(this.stableValue), this._millisecondDelay);
    }
    updateState(value) {
        this.__startTransaction().commit(value);
    }
    immutable() {
        return this;
    }
}

/**
 * Exists in the absence of the generic ValueModel<Array>.
 */
class ComputedValueModel extends AbstractComputedValueModel {
    constructor(source, options) {
        super(options);
        this.source = source;
        assert.notNull(source, 'source');
        this.trackSource(source);
    }
    doComputeValue() {
        return this.compute(this.source.value);
    }
}
(function (ComputedValueModel) {
    function fromList(source, fn, options) {
        return new ComputedValueModelImpl(source, fn, options);
    }
    ComputedValueModel.fromList = fromList;
    function fromValue(source, fn, options) {
        return new ComputedValueModelImpl(source, fn, options);
    }
    ComputedValueModel.fromValue = fromValue;
    class ComputedValueModelImpl extends ComputedValueModel {
        constructor(source, fn, options) {
            super(source, { initialValue: undefined, ...options });
            this.fn = fn;
        }
        compute(value) {
            return this.fn(value);
        }
    }
    ComputedValueModel.ComputedValueModelImpl = ComputedValueModelImpl;
})(ComputedValueModel || (ComputedValueModel = {}));

class DelegatingValueModel extends MutableValueModel {
    constructor(options) {
        super(options?.initialValue);
        this._garbage = new GarbageCollector();
        this._delegatingIdentityOf = CanIdentify.createIdentityFunction(options, (item) => this.defaultIdentityOf(item));
        this._garbage.onDispose(() => {
            this._currentDelegateBinding?.dispose();
        });
    }
    dispose() {
        this._garbage.dispose();
    }
    registerDisposable(disposable) {
        return this._garbage.registerDisposable(disposable);
    }
    get identityOf() {
        return this._delegatingIdentityOf;
    }
    identifiedBy(key) {
        return DelegatingValueModel.wrap(this, { initialValue: undefined, identifiedBy: key });
    }
    identifiedWith(func) {
        return DelegatingValueModel.wrap(this, { initialValue: undefined, identifiedWith: func });
    }
    get defaultIdentityOf() {
        if (this._userDelegate) {
            return ValueModel.isInstance(this._userDelegate) ? this._userDelegate.identityOf : Functions.identity;
        }
        else {
            return ValueModel.isInstance(this._defaultDelegate) ? this._defaultDelegate.identityOf : Functions.identity;
        }
    }
    joinTransaction(sourceTx, onCommit, debugContextOwner) {
        if (this.currentTransaction instanceof Transaction.Joined) {
            this.currentTransaction.dependsOn(sourceTx, debugContextOwner);
            return this.currentTransaction;
        }
        else {
            // We return a custom transaction subclass so that the dsl can change the delegate inside a transaction.
            const tx = new DelegatingValueModel.JoinedTransaction(this, onCommit, delegate => {
                this._userDelegate = delegate;
                return this.updateBinding();
            });
            tx.dependsOn(sourceTx, debugContextOwner);
            return this.__startTransaction(tx);
        }
    }
    setDelegate(delegate) {
        this.runInTransaction(draft => {
            this._userDelegate = delegate;
            draft.value = this.updateBinding();
        });
    }
    setDefault(defaultValueOrModel) {
        this.runInTransaction(draft => {
            this._defaultDelegate = (defaultValueOrModel instanceof ValueModel) ? defaultValueOrModel : new MutableValueModel(defaultValueOrModel);
            draft.value = this.updateBinding();
        });
    }
    /**
     * Updated the binding based on the current user and default delegates.  Returns the new value
     * as determined by the binding.
     * @protected
     */
    updateBinding() {
        // dispose the current binding if it exists
        this._currentDelegateBinding?.dispose();
        this._currentDelegateBinding = undefined;
        // get the model to bind too.
        const delegate = this._userDelegate || this._defaultDelegate;
        if (delegate) {
            const self = this;
            this._currentDelegateBinding = new Binding(delegate, this, {
                toLeft(rightValue, currentLeftValue) {
                    // prevent overwriting the default. TODO https://coolon.atlassian.net/browse/PEC-130
                    if (delegate !== self._userDelegate) {
                        return currentLeftValue;
                    }
                    else {
                        return rightValue;
                    }
                },
                toRight(leftValue, currentRightValue) {
                    return leftValue ?? self._defaultDelegate?.value;
                }
            });
            if (this._defaultDelegate) {
                this._currentDelegateBinding.rightDependsOn(this._defaultDelegate);
            }
        }
        return this._currentDelegateBinding?.convertLeftToRight();
    }
    getDelegate() {
        return this._userDelegate;
    }
    getSourceValue() {
        return this._userDelegate ? this._userDelegate.value : undefined;
    }
    getDefaultValue() {
        return this._defaultDelegate ? this._defaultDelegate.value : undefined;
    }
    withDefault(defaultValueOrModel) {
        this.setDefault(defaultValueOrModel);
        return this;
    }
    hasUserDelegate() {
        return !!this._userDelegate;
    }
    hasUserDefault() {
        return !!this._defaultDelegate;
    }
}
(function (DelegatingValueModel) {
    function hasDelegate(valueModel) {
        return valueModel instanceof DelegatingValueModel && valueModel.hasUserDelegate();
    }
    DelegatingValueModel.hasDelegate = hasDelegate;
    /**
     * Wraps an exiting model with a delegate.  This is equivalent to calling `const dm = new DelegatingValueModel(); dm.setDelegate(source);`
     * @param source the model to use as the initial delegate.
     * @param options
     */
    function wrap(source, options) {
        const delegate = new this(options);
        delegate.setDelegate(source);
        return delegate;
    }
    DelegatingValueModel.wrap = wrap;
    class JoinedTransaction extends Transaction.Joined {
        constructor(source, onCommit, onUpdateDelegate) {
            super(source, onCommit);
            this.source = source;
            this.onUpdateDelegate = onUpdateDelegate;
            this.delegateChanged = false;
        }
        updateDelegate(delegate) {
            this.delegateChanged = true;
            return this.onUpdateDelegate(delegate);
        }
        hasSourceTransactionsThatChanged() {
            return this.delegateChanged || super.hasSourceTransactionsThatChanged();
        }
    }
    DelegatingValueModel.JoinedTransaction = JoinedTransaction;
})(DelegatingValueModel || (DelegatingValueModel = {}));

class Guard extends ValueModel {
    constructor() {
        super({ initialValue: false });
    }
    get value() {
        return this.valueStore.read();
    }
    whileTrue(fun) {
        this.startTransaction().commit(true);
        try {
            fun();
        }
        finally {
            this.startTransaction().commit(false);
        }
    }
}

class IdentityValueModel extends AbstractComputedValueModel {
    constructor(source, options) {
        super({ initialValue: source.value, ...options, allowNil: true, identifiedWith: source.identityOf });
        this._source = assert.notNull(source, 'source');
        this.trackSource(source);
    }
    doComputeValue() {
        return this._source.value;
    }
}

class MappedValueModel extends AbstractComputedValueModel {
    constructor(source, options) {
        super({ initialValue: undefined, ...options });
        this._source = assert.notNull(source, 'source');
        this.trackSource(source);
    }
    doComputeValue() {
        let value = this._source ? this._source.value : undefined;
        if (AllowNil.isNil(value)) {
            return this.allowNil ? this.compute(undefined) : undefined;
        }
        else {
            return this.compute(value);
        }
    }
}
(function (MappedValueModel) {
    function create(source, fn, options = {
        initialValue: undefined,
        allowNil: false
    }) {
        return new MappedValueModelImpl(source, fn, options);
    }
    MappedValueModel.create = create;
    class MappedValueModelImpl extends MappedValueModel {
        constructor(source, fn, options) {
            super(source, options);
            this.fn = fn;
        }
        compute(value) {
            return this.fn(value);
        }
    }
    MappedValueModel.MappedValueModelImpl = MappedValueModelImpl;
})(MappedValueModel || (MappedValueModel = {}));

class OrValueModel extends ReducingValueModel {
    constructor(sources = [], options) {
        super(sources, options);
        this._defaultValue = false;
    }
    compute(values) {
        return values.length > 0 ? values.reduce((a, b) => a || b) : this._defaultValue;
    }
    setDefault(value) {
        this._defaultValue = value;
        return this;
    }
    addSource(source) {
        this.runInTransaction(() => {
            this.trackSource(source);
        });
    }
}
(function (OrValueModel) {
    class Truthy extends OrValueModel {
        compute(values) {
            return super.compute(values.map(v => !!v));
        }
    }
    OrValueModel.Truthy = Truthy;
})(OrValueModel || (OrValueModel = {}));

class ThrottledValueModel extends ValueModel {
    constructor(source, millisecondDelay = 250, delayInitial = true) {
        super({ initialValue: source.value });
        this.source = source;
        this._garbage = new GarbageCollector();
        const accumulator = new ThrottledAccumulator(millisecondDelay, delayInitial);
        this._garbage.registerDisposable(this.source.onTransactionFinalised((tx) => {
            if (tx.hasChanged()) {
                return accumulator.push(tx.committedValue);
            }
        }));
        this._garbage.registerDisposable(accumulator.subscribe(values => this.syncToSource(last(values))));
    }
    get readonly() {
        return this;
    }
    dispose() {
        this._garbage.dispose();
    }
    syncToSource(value) {
        const tx = this.__startTransaction().commit(value);
    }
    immutable() {
        return this;
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

class ListQuery {
    constructor(value, identityOf) {
        this.value = value;
        this.identityOf = identityOf;
    }
    get length() {
        return this.value ? this.value.length : 0;
    }
    first() {
        return this.length > 0 ? this.value[0] : undefined;
    }
    last() {
        return this.length > 0 ? this.value[this.length - 1] : undefined;
    }
    isEmpty() {
        return this.value.length === 0;
    }
    includes(value) {
        if (value) {
            const id = this.identityOf(value);
            return this.includesMatching((item) => this.identityOf(item) === id);
        }
        else {
            return false;
        }
    }
    indexOf(value) {
        if (value) {
            const id = this.identityOf(value);
            return this.findIndex((item) => {
                return this.identityOf(item) === id;
            });
        }
        else {
            return -1;
        }
    }
    findIndex(predicate) {
        return findIndex(this.value, (item) => predicate(item));
    }
    select(predicate) {
        return filter(this.value, predicate);
    }
    reject(predicate) {
        return filter(this.value, v => !predicate(v));
    }
    findMatching(predicate) {
        return find(this.value, predicate);
    }
    findByIdentity(id) {
        return this.findMatching(item => this.identityOf(item) === id);
    }
    includesMatching(predicate) {
        return !!this.findMatching((item) => predicate(item));
    }
}

class ListModel extends HasValue {
    get length() {
        return this.value ? this.value.length : 0;
    }
    coerceValue(value) {
        return ListModel.Helpers.coerceToList(value);
    }
    get readonly() {
        return lang.abstractMethod(this, 'readonly');
    }
    /**
     * Returns a point in time snapshot of this list model with identity aware query methods.
     */
    query() {
        return new ListQuery(this.value, this.identityOf);
    }
}
(function (ListModel) {
    class Constant extends ListModel {
        constructor(constantValue) {
            super({ initialValue: constantValue });
            this.constantValue = constantValue;
            DebugContext.getOrCreate(this).tag(`constant`);
        }
        get readonly() {
            return this;
        }
    }
    function constant(value) {
        return new Constant(value);
    }
    ListModel.constant = constant;
    function isInstance(item) {
        return item instanceof ListModel;
    }
    ListModel.isInstance = isInstance;
    function wrap(value) {
        return ListModel.isInstance(value) ? value : constant(value);
    }
    ListModel.wrap = wrap;
    ListModel.Helpers = {
        coerceToList(value) {
            return isNil$1(value) ?
                [] :
                isArray$1(value) ?
                    value :
                    [value];
        }
    };
})(ListModel || (ListModel = {}));

class MutableListModel extends ListModel {
    constructor(initialValue = [], options) {
        super({ initialValue: initialValue, ...options });
    }
    // Trap for the unwary, if you override only one of the get/set accessors in a subclass
    // it will nuke the other one and drive you nuts.  .
    get value() {
        return this.valueStore.read();
    }
    set value(value) {
        this.startTransaction().commit(value);
    }
    get readonly() {
        if (!this.__readonly) {
            this.__readonly = new Proxy(this, new ReadonlyProxyHandler());
            DebugContext.getOrCreate(this.__readonly).tag(`readonly`);
        }
        return this.__readonly;
    }
    runInTransaction(func) {
        const draft = new MutableListModel(this.value, { identifiedWith: this.identityOf });
        const tx = this.startTransaction();
        this._safelyExecuteFunction('runInTransaction', () => func(draft));
        tx.commit(draft.value);
    }
    push(value) {
        const newContent = this.value.slice();
        newContent.push(value);
        this.value = newContent;
    }
    /**
     * Removes the item from the list that matches this items identity or by reference equality if the
     * list model hasn't had it's identity tracking configured using `identifiedBy` or `identifiedWith`.
     * @param value the value to remove.
     */
    remove(value) {
        assert.notNil(value);
        const id = this.identityOf(value);
        let foundCount = 0;
        return this.removeMatching(v => this.identityOf(v) == id) > 0;
    }
    /**
     * Replaces an item in the list.  The item is to replace using the #identifiedBy property.
     * @param item
     * @param options
     */
    replace(item, options) {
        let index = this.query().indexOf(item);
        if (index >= 0) {
            let newList = [].concat(this.value);
            newList[index] = (options && options.with) || item;
            this.value = newList;
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Replaces an item in the list or adds it if it's not present.
     * @param item the item to add
     * @param options
     * @return true if the item was replaced, false if it was added.
     */
    replaceOrPush(item, options) {
        const replaced = this.replace(item, options);
        if (!replaced) {
            this.push(OptionsHelper.for(options).get("with", item));
        }
        return replaced;
    }
    removeMatching(predicate) {
        const newList = reject(this.value, predicate);
        const difference = this.length - newList.length;
        if (difference > 0) {
            this.value = newList;
        }
        return difference;
    }
    splice(index, deleteCount, ...values) {
        const newList = [...this.value];
        newList.splice(index, deleteCount, ...values);
        this.value = newList;
    }
    insert(index, value) {
        this.splice(index, 0, value);
    }
    unshift(value) {
        const clone = this.value.concat([]);
        clone.unshift(value);
        this.value = clone;
    }
    pop() {
        if (this.query().isEmpty()) {
            return null;
        }
        else {
            const last = this.value[this.length - 1];
            this.value = this.value.slice(0, -1);
            return last;
        }
    }
}

/**
 * @deprecated use MutableListModel<T> instead
 */
class ListHolder extends MutableListModel {
}

// TODO: Yikes, an egregious cut and paste from AbstractListModel.. I beat my head a mixins for longer than I'd like
class AbstractComputedListModel extends HasDependents.Mixin(ListModel) {
    constructor(options) {
        super(options);
        // Note: this would be better implemented as a Mixin but we'd need the ability for the mixin to extend classes with private members.
        this.computedModelMechanics = this.registerDisposable(new ComputedModelMechanics(this, this._valueStore, options));
    }
    get valueStore() {
        return this.computedModelMechanics.computedStore;
    }
    runInTransaction(func) {
        return this.computedModelMechanics.runInTransaction(func);
    }
    isGateOpen() {
        return this.computedModelMechanics.isGateOpen();
    }
    get readonly() {
        return this;
    }
    immutable() {
        return this.readonly;
    }
}

/**
 * Exists in the absence of the generic ValueModel<Array>.
 */
class ComputedListModel extends AbstractComputedListModel {
    constructor(__source, options) {
        super(options);
        this.__source = __source;
        assert.notNull(__source, 'source');
        this.trackSource(__source);
    }
    doComputeValue() {
        return this.compute(this.__source.value);
    }
}
(function (ComputedListModel) {
    function fromList(source, fn, options) {
        return new ComputedListModelFromList(source, fn, { initialValue: [], ...options });
    }
    ComputedListModel.fromList = fromList;
    function fromValue(source, fn, options) {
        return new ComputedListModelFromHasValue(source, fn, { initialValue: [], ...options });
    }
    ComputedListModel.fromValue = fromValue;
    class ComputedListModelFromList extends ComputedListModel {
        constructor(source, fn, options) {
            super(source, options);
            this.source = source;
            this.fn = fn;
        }
        compute(value) {
            return this.fn(value);
        }
    }
    ComputedListModel.ComputedListModelFromList = ComputedListModelFromList;
    class ComputedListModelFromHasValue extends ComputedListModel {
        constructor(source, fn, options) {
            super(source, options);
            this.source = source;
            this.fn = fn;
            this.allowNil = options && options.allowNil;
        }
        compute(value) {
            if (isNil$1(value)) {
                return this.allowNil ? this.fn(null) : [];
            }
            else {
                return this.fn(value);
            }
        }
    }
    ComputedListModel.ComputedListModelFromHasValue = ComputedListModelFromHasValue;
})(ComputedListModel || (ComputedListModel = {}));

class ConcatenatingListModel extends AbstractComputedListModel {
    constructor(sources, options) {
        super(options);
        this.sources = sources;
        this.sources.forEach(s => this.trackSource(s));
    }
    doComputeValue() {
        return this.sources.map(s => s.value);
    }
}

class DelegatingListModel extends MutableListModel {
    constructor(options) {
        super(options?.initialValue);
        this._garbage = new GarbageCollector();
        this._hasDelegate = new MutableValueModel(false);
        this._delegatingIdentityOf = CanIdentify.createIdentityFunction(options, (item) => this.defaultIdentityOf(item));
        this._garbage.onDispose(() => {
            this._currentDelegateBinding?.dispose();
        });
    }
    dispose() {
        this._garbage.dispose();
    }
    registerDisposable(disposable) {
        return this._garbage.registerDisposable(disposable);
    }
    // doComputeValue(): T[] {
    //     let sourceValue = this.getSourceValue();
    //     return _.isNil(sourceValue) || _.isEmpty(sourceValue) ? this.getDefaultValue() : sourceValue;
    // }
    get identityOf() {
        return this._delegatingIdentityOf;
    }
    get defaultIdentityOf() {
        if (this._userDelegate) {
            return ListModel.isInstance(this._userDelegate) ? this._userDelegate.identityOf : Functions.identity;
        }
        else {
            return ListModel.isInstance(this._defaultDelegate) ? this._defaultDelegate.identityOf : Functions.identity;
        }
    }
    // push(value: T) {
    //     assert.isFunction(this.getDelegate()['push']);
    //     this.getDelegate()['push'](value)
    // }
    //
    // splice(index: number, deleteCount: number, ...values: T[]) {
    //     assert.isFunction(this.getDelegate()['splice']);
    //     this.getDelegate()['splice'](index, deleteCount, ...values);
    // }
    //
    // insert(index: number, value: T) {
    //     assert.isFunction(this.getDelegate()['insert']);
    //     this.getDelegate()['insert'](index, value)
    // }
    //
    // unshift(value: T) {
    //     assert.isFunction(this.getDelegate()['unshift']);
    //     this.getDelegate()['unshift'](value)
    // }
    //
    // pop(): T {
    //     assert.isFunction(this.getDelegate()['pop']);
    //     return this.getDelegate()['pop']();
    // }
    //
    // remove(value: T) {
    //     assert.isFunction(this.getDelegate()['remove']);
    //     this.getDelegate()['remove'](value);
    // }
    //
    // removeMatching(predicate: (value: T) => boolean) {
    //     assert.isFunction(this.getDelegate()['removeMatching']);
    //     this.getDelegate()['removeMatching'](predicate);
    // }
    //
    // replace(item: T, options?: { with: T }) {
    //     assert.isFunction(this.getDelegate()['replace']);
    //     this.getDelegate()['replace'](item, options);
    // }
    // delegateTo(delegate) {
    //     this.setDelegate(delegate);
    // }
    joinTransaction(sourceTx, onCommit, debugContextOwner) {
        if (this.currentTransaction instanceof Transaction.Joined) {
            this.currentTransaction.dependsOn(sourceTx, debugContextOwner);
            return this.currentTransaction;
        }
        else {
            // We return a custom delegate so that the dsl can update both the value and delegate during
            // a transaction.
            // We return a custom delegate so that the dsl can update both the value and delegate during
            // a transaction.
            const tx = new DelegatingListModel.JoinedTransaction(this, onCommit, delegate => {
                this._userDelegate = delegate;
                return this.updateBinding();
            });
            tx.dependsOn(sourceTx, debugContextOwner);
            return this.__startTransaction(tx);
        }
    }
    setDelegate(delegate) {
        this.runInTransaction(draft => {
            this._userDelegate = delegate;
            draft.value = this.updateBinding();
        });
    }
    getDelegate() {
        return this._userDelegate;
    }
    setDefault(defaultValueOrModel) {
        this.runInTransaction((draft) => {
            this._defaultDelegate = defaultValueOrModel instanceof ListModel ? defaultValueOrModel : new MutableListModel(defaultValueOrModel);
            draft.value = this.updateBinding();
        });
    }
    getSourceValue() {
        return this._userDelegate ? this._userDelegate.value : [];
    }
    getDefaultValue() {
        return this._defaultDelegate ? this._defaultDelegate.value : [];
    }
    withDefault(defaultValueOrModel) {
        this.setDefault(defaultValueOrModel);
        return this;
    }
    /**
     * Updated the binding based on the current user and default delegates.  Returns the new value
     * as determined by the binding.
     * @protected
     */
    updateBinding() {
        // dispose the current binding if it exists
        this._currentDelegateBinding?.dispose();
        this._currentDelegateBinding = undefined;
        // get the model to bind too.
        const delegate = this._userDelegate || this._defaultDelegate;
        if (delegate) {
            const self = this;
            this._currentDelegateBinding = new Binding(delegate, this, {
                toLeft(rightValue, currentLeftValue) {
                    // prevent overwriting the default. TODO https://coolon.atlassian.net/browse/PEC-130
                    if (delegate !== self._userDelegate) {
                        return currentLeftValue;
                    }
                    else {
                        return rightValue;
                    }
                },
                toRight(leftValue) {
                    return (isNil$1(leftValue) || isEmpty$2(leftValue)) ? self._defaultDelegate?.value : leftValue;
                }
            });
            if (this._defaultDelegate) {
                this._currentDelegateBinding.rightDependsOn(this._defaultDelegate);
            }
        }
        return this._currentDelegateBinding?.convertLeftToRight();
    }
}
(function (DelegatingListModel) {
    /**
     * Wraps an exiting model with a delegate.  This is equivalent to calling `const dm = new DelegatingListModel(); dm.setDelegate(source);`
     * @param source the model to use as the initial delegate.
     * @param options
     */
    function wrap(source, options) {
        const delegate = new DelegatingListModel(options);
        delegate.setDelegate(source);
        return delegate;
    }
    DelegatingListModel.wrap = wrap;
    class JoinedTransaction extends Transaction.Joined {
        constructor(source, onCommit, onUpdateDelegate) {
            super(source, onCommit);
            this.source = source;
            this.onUpdateDelegate = onUpdateDelegate;
        }
        updateDelegate(delegate) {
            return this.onUpdateDelegate(delegate);
        }
    }
    DelegatingListModel.JoinedTransaction = JoinedTransaction;
})(DelegatingListModel || (DelegatingListModel = {}));

class IdentityListModel extends ComputedListModel.ComputedListModelFromList {
    constructor(source, options) {
        super(source, Functions.identity, { initialValue: [], ...options, identifiedWith: source.identityOf });
    }
}

/**
 * @deprecated use chain(listModel).sort/sortBy/sortUsing
 */
class SortedListModel extends ComputedListModel {
    constructor(sourceModel, sorterModel) {
        super(sourceModel, { initialValue: [], identifiedWith: sourceModel.identityOf });
        this.sourceModel = sourceModel;
        assert.notNil(sorterModel);
        this.sorterModel = ValueModel.isInstance(sorterModel) ? sorterModel : new MutableValueModel(sorterModel);
        this.dependsOn(this.sorterModel);
    }
    get identityOf() {
        return this.sourceModel.identityOf;
    }
    compute(values) {
        return this.sorter ? this.sorter.sort(values) : values;
    }
    get sorter() {
        return this.sorterModel.value;
    }
}

/**
 * @deprecated use lodash with `chain(listModel).sortUsing(items => _.sortBy(items, attrs))`
 */
class TextAttributeSorter {
    constructor() {
        this.attributes = [];
    }
    sortBy(...attrs) {
        this.attributes = attrs;
        return this;
    }
    sort(items) {
        // TODO: make it like this.
        // http://stackoverflow.com/questions/2802341/javascript-natural-sort-of-alphanumerical-strings/38641281#38641281
        return items.sort((a, b) => {
            for (let attr of this.attributes) {
                let aAttr = (a && a[attr]) ? a[attr].toString() : '';
                let bAttr = (b && b[attr]) ? b[attr].toString() : '';
                const result = aAttr.localeCompare(bAttr, undefined /* Ignore language */, { sensitivity: 'base' });
                if (result != 0)
                    return result;
            }
            // See http://stackoverflow.com/a/29830220/1248812
            return 0;
        });
    }
}

class ThrottledListModel extends ListModel {
    constructor(source, millisecondDelay = 250, delayInitial = true) {
        super({ initialValue: source.value });
        this.source = source;
        this._garbage = new GarbageCollector();
        const accumulator = new ThrottledAccumulator(millisecondDelay, delayInitial);
        this._garbage.registerDisposable(this.source.onTransactionFinalised((tx) => {
            if (tx.hasChanged()) {
                return accumulator.push(tx.committedValue);
            }
        }));
        this._garbage.registerDisposable(accumulator.subscribe(a => this.setValue(last(a))));
    }
    get readonly() {
        return this;
    }
    dispose() {
        this._garbage.dispose();
    }
    setValue(value) {
        const tx = this.__startTransaction().commit(value);
    }
    immutable() {
        return this;
    }
}

var Deferred;
(function (Deferred) {
    function defer() {
        const finished = new MutableValueModel(false);
        const deferred = {
            resolve: undefined,
            reject: undefined,
            promise: undefined,
            get finished() {
                return !!finished.value;
            }
        };
        deferred.promise = new Promise((resolve, reject) => {
            deferred.resolve = ((value) => {
                finished.value = true;
                resolve(value);
            });
            deferred.reject = ((value) => {
                finished.value = true;
                reject(value);
            });
        });
        return deferred;
    }
    Deferred.defer = defer;
})(Deferred || (Deferred = {}));

3;
class AsyncOperation {
    constructor(initialState, millisecondDelay) {
        this.initialState = initialState;
        this.millisecondDelay = millisecondDelay;
    }
    applyMutation(dto, update) {
        // TODO: create pectin Decorator utilities the automates cloning with proxies intact.
        if (isFunction(dto["produce"])) {
            return dto["produce"](draft => {
                update(draft);
            });
        }
        else {
            return produce(dto, draft => {
                update(draft);
            });
        }
    }
}

class AsyncDestroy extends AsyncOperation {
    constructor(initialState, millisecondDelay, performDestroy, callbacks) {
        super(initialState, millisecondDelay);
        this.performDestroy = performDestroy;
        this.callbacks = callbacks;
        this.finished = Deferred.defer();
    }
    update(mutator) {
        // ignore.
    }
    destroy() {
        this.performDestroy(this.initialState)
            .then(() => this.notifyComplete())
            .catch(error => this.notifyFailure());
    }
    isUpdateFor(dto) {
        return this.initialState === dto;
    }
    getCurrentDraft() {
        return this.initialState;
    }
    hasUnprocessedUpdates() {
        return false;
    }
    getUnprocessedUpdates() {
        return [];
    }
    // @Trace()
    notifyFailure() {
        this.callbacks.onFailure(this, this.initialState, []);
    }
    // @Trace()
    notifyComplete() {
        this.callbacks.onComplete(this);
    }
}

var ImmutableMap;
(function (ImmutableMap) {
    const EMPTY_MAP = new Map();
    function empty() {
        return EMPTY_MAP;
    }
    ImmutableMap.empty = empty;
})(ImmutableMap || (ImmutableMap = {}));

const EMPTY_ARRAY = [];
class ImmutableMultiMap {
    constructor(mutableMap = new Map()) {
        this.mutableMap = mutableMap;
    }
    get(key) {
        return this.mutableMap.get(key) ?? EMPTY_ARRAY;
    }
    keys() {
        return this.mutableMap.keys();
    }
    values() {
        return this.mutableMap.values();
    }
    entries() {
        return this.mutableMap.entries();
    }
    has(key) {
        return this.mutableMap.has(key) && this.mutableMap.get(key).length > 0;
    }
    get size() {
        return this.mutableMap.size;
    }
}
(function (ImmutableMultiMap) {
    const EMPTY_MAP = new Map();
    function empty() {
        return EMPTY_MAP;
    }
    ImmutableMultiMap.empty = empty;
})(ImmutableMultiMap || (ImmutableMultiMap = {}));

class MapModel extends HasValue {
    constructor(options) {
        super(options);
    }
    get(key, defaultValue) {
        return this.value.get(key) ?? defaultValue;
    }
    coerceValue(value) {
        return isNil$1(value) ? ImmutableMap.empty() : value;
    }
    has(key) {
        return this.value.has(key);
    }
    get size() {
        return this.value.size;
    }
}

class MultiMapModel extends HasValue {
    constructor(options) {
        super(options);
    }
    get(key, defaultValue) {
        const result = this.value.get(key);
        return isEmpty$2(result) && defaultValue ? defaultValue : result;
    }
    getFirst(key) {
        return first(this.get(key));
    }
    coerceValue(value) {
        return isNil$1(value) ? ImmutableMultiMap.empty() : value;
    }
    get size() {
        return this.value.size;
    }
}

class MutableMapModel extends MapModel {
    constructor(initialValue = undefined) {
        super({ initialValue });
        if (!isNil$1(initialValue)) {
            this.valueStore.write(this.coerceValue(initialValue));
        }
    }
    set(key, value) {
        this.runInTransaction(map => {
            map.set(key, value);
        });
    }
    delete(key) {
        this.runInTransaction(map => {
            map.delete(key);
        });
    }
    clear() {
        this.runInTransaction(map => {
            map.clear();
        });
    }
    runInTransaction(func) {
        const draft = new Map(this.value.entries());
        const tx = this.startTransaction();
        this._safelyExecuteFunction('runInTransaction', () => func(draft));
        tx.commit(draft);
    }
    get readonly() {
        if (!this.__readonly) {
            this.__readonly = new Proxy(this, new ReadonlyProxyHandler());
            DebugContext.getOrCreate(this.__readonly).tag(`readonly`);
        }
        return this.__readonly;
    }
}

class AbstractComputedMapModel extends HasDependents.Mixin(MapModel) {
    constructor(options) {
        super({ initialValue: new Map(), ...options });
        this._allowNil = !!options?.allowNil;
        // Note: this would be better implemented as a Mixin but we'd need the ability for the mixin to extend classes with private members.
        this.computedModelMechanics = this.registerDisposable(new ComputedModelMechanics(this, this._valueStore, options));
    }
    get valueStore() {
        return this.computedModelMechanics.computedStore;
    }
    runInTransaction(func) {
        return this.computedModelMechanics.runInTransaction(func);
    }
    get readonly() {
        return this;
    }
}

class AbstractComputedMultiMapModel extends HasDependents.Mixin(MultiMapModel) {
    constructor(options) {
        super({ initialValue: new ImmutableMultiMap(), ...options });
        this._allowNil = !!options?.allowNil;
        // Note: this would be better implemented as a Mixin but we'd need the ability for the mixin to extend classes with private members.
        this.computedModelMechanics = this.registerDisposable(new ComputedModelMechanics(this, this._valueStore, options));
    }
    get valueStore() {
        return this.computedModelMechanics.computedStore;
    }
    runInTransaction(func) {
        return this.computedModelMechanics.runInTransaction(func);
    }
    get readonly() {
        return this;
    }
}

class DelegatingMapModel extends AbstractComputedMapModel {
    constructor(options) {
        super({ initialValue: undefined, ...options, allowNil: true });
    }
    get value() {
        return this.valueStore.read();
    }
    doComputeValue() {
        return this.getSourceValue();
    }
    get identityOf() {
        return this._delegate instanceof MapModel ? this._delegate.identityOf : Functions.identity;
    }
    joinTransaction(sourceTx, onCommit, hasDebugContext) {
        if (this.currentTransaction instanceof Transaction.Joined) {
            this.currentTransaction.dependsOn(sourceTx, hasDebugContext);
            return this.currentTransaction;
        }
        else {
            // We return a custom delegate so that the dsl can update both the value and delegate during a transaction.
            const tx = new DelegatingMapModel.JoinedTransaction(this, onCommit, delegate => {
                if (this._delegate) {
                    this.untrackSource(this._delegate);
                }
                this._delegate = delegate;
                if (this._delegate) {
                    this.trackSource(this._delegate);
                }
            });
            tx.dependsOn(sourceTx, hasDebugContext);
            return this.__startTransaction(tx);
        }
    }
    setDelegate(delegate) {
        this.runInTransaction(() => {
            if (this._delegate) {
                this.untrackSource(this._delegate);
            }
            this._delegate = delegate;
            if (this._delegate) {
                this.trackSource(this._delegate);
            }
        });
    }
    getDelegate() {
        return this._delegate;
    }
    getSourceValue() {
        return this._delegate ? this._delegate.value : undefined;
    }
    // getDefaultValue(): V {
    //     return this._defaultDelegate ? this._defaultDelegate.value : undefined;
    // }
    //
    // withDefault(defaultValueOrModel: IMutableValueModel<V> | V): this {
    //     this.setDefault(defaultValueOrModel);
    //     return this;
    // }
    hasUserDelegate() {
        // TODO: the delegate placeholder model is never used.
        return !!this._delegate && this._delegate != this._delegatePlaceHolder;
    }
    hasUserDefault() {
        return !!this._defaultDelegate;
    }
}
(function (DelegatingMapModel) {
    function hasDelegate(mapModel) {
        return mapModel instanceof DelegatingMapModel && mapModel.hasUserDelegate();
    }
    DelegatingMapModel.hasDelegate = hasDelegate;
    /**
     * Wraps an exiting model with a delegate.  This is equivalent to calling `const dm = new DelegatingMapModel(); dm.setDelegate(source);`
     * @param source the model to use as the initial delegate.
     * @param options
     */
    function wrap(source, options) {
        const delegate = new this(options);
        delegate.setDelegate(source);
        return delegate;
    }
    DelegatingMapModel.wrap = wrap;
    class JoinedTransaction extends Transaction.Joined {
        constructor(source, onCommit, onUpdateDelegate) {
            super(source, onCommit);
            this.source = source;
            this.onUpdateDelegate = onUpdateDelegate;
            this.delegateChanged = false;
        }
        updateDelegate(delegate) {
            this.delegateChanged = true;
            this.onUpdateDelegate(delegate);
        }
        hasSourceTransactionsThatChanged() {
            return this.delegateChanged || super.hasSourceTransactionsThatChanged();
        }
    }
    DelegatingMapModel.JoinedTransaction = JoinedTransaction;
})(DelegatingMapModel || (DelegatingMapModel = {}));

class DelegatingMultiMapModel extends AbstractComputedMultiMapModel {
    constructor(options) {
        super({ initialValue: undefined, ...options, allowNil: true });
    }
    get value() {
        return this.valueStore.read();
    }
    doComputeValue() {
        return this.getSourceValue();
    }
    get identityOf() {
        return this._delegate instanceof MultiMapModel ? this._delegate.identityOf : Functions.identity;
    }
    joinTransaction(sourceTx, onCommit, hasDebugContext) {
        if (this.currentTransaction instanceof Transaction.Joined) {
            this.currentTransaction.dependsOn(sourceTx, hasDebugContext);
            return this.currentTransaction;
        }
        else {
            // We return a custom transaction so that the dsl can update both the value and delegate during a transaction.
            const tx = new DelegatingMultiMapModel.JoinedTransaction(this, onCommit, delegate => {
                if (this._delegate) {
                    this.untrackSource(this._delegate);
                }
                this._delegate = delegate;
                if (this._delegate) {
                    this.trackSource(this._delegate);
                }
            });
            tx.dependsOn(sourceTx, hasDebugContext);
            return this.__startTransaction(tx);
        }
    }
    setDelegate(delegate) {
        this.runInTransaction(() => {
            if (this._delegate) {
                this.untrackSource(this._delegate);
            }
            this._delegate = delegate;
            if (this._delegate) {
                this.trackSource(this._delegate);
            }
        });
    }
    getDelegate() {
        return this._delegate;
    }
    getSourceValue() {
        return this._delegate ? this._delegate.value : undefined;
    }
    // getDefaultValue(): V {
    //     return this._defaultDelegate ? this._defaultDelegate.value : undefined;
    // }
    //
    // withDefault(defaultValueOrModel: IMutableValueModel<V> | V): this {
    //     this.setDefault(defaultValueOrModel);
    //     return this;
    // }
    hasUserDelegate() {
        // TODO: the delegate placeholder model is never used.
        return !!this._delegate && this._delegate != this._delegatePlaceHolder;
    }
    hasUserDefault() {
        return !!this._defaultDelegate;
    }
}
(function (DelegatingMultiMapModel) {
    function hasDelegate(mapModel) {
        return mapModel instanceof DelegatingMultiMapModel && mapModel.hasUserDelegate();
    }
    DelegatingMultiMapModel.hasDelegate = hasDelegate;
    /**
     * Wraps an exiting model with a delegate.  This is equivalent to calling `const dm = new DelegatingMapModel(); dm.setDelegate(source);`
     * @param source the model to use as the initial delegate.
     * @param options
     */
    function wrap(source, options) {
        const delegate = new this(options);
        delegate.setDelegate(source);
        return delegate;
    }
    DelegatingMultiMapModel.wrap = wrap;
    class JoinedTransaction extends Transaction.Joined {
        constructor(source, onCommit, onUpdateDelegate) {
            super(source, onCommit);
            this.source = source;
            this.onUpdateDelegate = onUpdateDelegate;
            this.delegateChanged = false;
        }
        updateDelegate(delegate) {
            this.delegateChanged = true;
            this.onUpdateDelegate(delegate);
        }
        hasSourceTransactionsThatChanged() {
            return this.delegateChanged || super.hasSourceTransactionsThatChanged();
        }
    }
    DelegatingMultiMapModel.JoinedTransaction = JoinedTransaction;
})(DelegatingMultiMapModel || (DelegatingMultiMapModel = {}));

class HasManyIndex extends AbstractComputedMultiMapModel {
    constructor(sourceList, identifiedWith) {
        super({ initialValue: new ImmutableMultiMap(), identifiedWith });
        this.sourceList = sourceList;
        this.trackSource(sourceList);
    }
    static identifiedBy(sourceList, key) {
        const identifiedWith = item => item ? item[key] : undefined;
        return new HasManyIndex(sourceList, identifiedWith);
    }
    static identifiedWith(sourceList, identifiedWith) {
        return new HasManyIndex(sourceList, identifiedWith);
    }
    doComputeValue() {
        const map = new Map();
        this.sourceList.value.forEach(entity => {
            if (!isNil$1(entity)) {
                const key = this.identityOf(entity);
                let list = map.get(key);
                if (!list) {
                    list = [];
                    map.set(key, list);
                }
                list.push(entity);
            }
        });
        return new ImmutableMultiMap(map);
    }
}

class HasOneIndex extends AbstractComputedMapModel {
    constructor(sourceList, identifiedWith) {
        super({ initialValue: new Map(), identifiedWith });
        this.sourceList = sourceList;
        this.trackSource(sourceList);
    }
    static identifiedBy(sourceList, key) {
        const identifiedWith = item => item ? item[key] : undefined;
        return new HasOneIndex(sourceList, identifiedWith);
    }
    static identifiedWith(sourceList, identifiedWith) {
        return new HasOneIndex(sourceList, identifiedWith);
    }
    doComputeValue() {
        const map = new Map();
        this.sourceList.value.forEach(entity => {
            const key = this.identityOf(entity);
            let value = map.get(key);
            if (!value) {
                map.set(key, entity);
            }
            else {
                console.warn(`indexBy: Found duplicate entry for existing key=${key}`, {
                    originalEntry: value,
                    duplicateEntry: entity,
                    identifiedWith: this.identityOf
                });
            }
        });
        return map;
    }
}

class MappedMapModel extends AbstractComputedMapModel {
    constructor(sourceMap, compute, options) {
        super({ initialValue: new Map(), ...options });
        this.sourceMap = sourceMap;
        this.compute = compute;
        this.trackSource(sourceMap);
        this.allowNil = !!options?.allowNil;
        this.safelyMapValue = AllowNil.gateFunction(compute, options);
    }
    doComputeValue() {
        const result = new Map();
        Array.from(this.sourceMap.value.entries()).forEach(entry => {
            result.set(entry[0], this.safelyMapValue(entry[1]));
        });
        return result;
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

class AsyncUpdate extends AsyncOperation {
    constructor(initialState, millisecondDelay, performUpdate, callbacks) {
        super(initialState, millisecondDelay);
        this.initialState = initialState;
        this.performUpdate = performUpdate;
        this.callbacks = callbacks;
        this._drafts = [];
        this.finished = Deferred.defer();
        this._sealed = false;
        this.pendingUpdates = [];
        this.postSealUpdatesUpdates = [];
        this._destroyRequested = false;
        this._drafts.push(assert.notNil(initialState));
        this.restartTimer();
    }
    update(mutator) {
        const previousDraft = this.getCurrentDraft();
        this._drafts.push(this.applyMutation(previousDraft, draft => {
            mutator(draft);
        }));
        this.callbacks.onDraftUpdate(this.getCurrentDraft(), previousDraft);
        if (this.isSealed()) {
            this.postSealUpdatesUpdates.push(mutator);
        }
        else {
            this.pendingUpdates.push(mutator);
            this.restartTimer();
        }
    }
    destroy() {
        this._destroyRequested = true;
    }
    get destroyRequested() {
        return this._destroyRequested;
    }
    getCurrentDraft() {
        return last(this._drafts);
    }
    isUpdateFor(dto) {
        return !!findLast(this._drafts, dto);
    }
    isSealed() {
        return !!this._sealed;
    }
    sealAndSaveState() {
        this._sealed = true;
        // re-apply all our mutations
        let dto = this.initialState;
        for (const update of this.pendingUpdates) {
            dto = this.applyMutation(dto, update);
        }
        this.pendingUpdates = [];
        this.performUpdate(dto, this.initialState)
            .then(() => this.notifyComplete())
            .catch(error => this.notifyFailure());
    }
    // @Trace()
    notifyFailure() {
        this.callbacks.onFailure(this, this.getCurrentDraft(), this.pendingUpdates);
    }
    // @Trace()
    notifyComplete() {
        this.callbacks.onComplete(this);
    }
    restartTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => this.sealAndSaveState(), this.millisecondDelay);
    }
    hasUnprocessedUpdates() {
        return this.postSealUpdatesUpdates.length > 0;
    }
    getUnprocessedUpdates() {
        return this.postSealUpdatesUpdates;
    }
}

/**
 * TODO: rapid keyboard updates aren't quite working yet.
 */
class AsyncMutableListModel extends ComputedListModel {
    constructor(sourceList, identifiedWith, saveExisting) {
        super(sourceList, {
            initialValue: [],
            identifiedWith
        });
        this.sourceList = sourceList;
        this.saveExisting = saveExisting;
        this.inFlightJobs = new MutableListModel();
        this.inflightCreateDtos = new MutableListModel();
        this.inflightUpdateDtos = new MutableListModel();
        this.inflightDestroyDtos = new MutableListModel();
        this.millisecondDelay = 150;
        this.sourceModelIndex = this.registerDisposable(HasOneIndex.identifiedWith(this.sourceList, identifiedWith));
        this.inflightCreatesIndex = HasOneIndex.identifiedWith(this.inflightCreateDtos, identifiedWith);
        this.inflightUpdatesIndex = HasOneIndex.identifiedWith(this.inflightUpdateDtos, identifiedWith);
        this.inflightDestroysIndex = HasOneIndex.identifiedWith(this.inflightDestroyDtos, identifiedWith);
        this.trackSource(this.inflightCreatesIndex);
        this.trackSource(this.inflightUpdatesIndex);
        this.trackSource(this.inflightDestroysIndex);
        // const txo = new TransactionObserver({verbose: true}).onEvent(e => console.log(e.name, e.payload));
        // txo.observe('this.inflightUpdateDtos', this.inflightUpdateDtos);
        // txo.observe('this', this);
    }
    static create(sourceList, identifier, saveExisting) {
        let identifiedWith = isFunction(identifier) ? identifier : ((dto) => dto[identifier]);
        return new AsyncMutableListModel(sourceList, identifiedWith, saveExisting);
    }
    enableCreate(save) {
        this.saveNew = save;
        return this;
    }
    enableLazyCreate(lazyCreate) {
        assert.isFunction(this.saveNew, 'lazy creates must have a create callback defined. Call enableCreate(...) before this method to provide one.');
        this.createNew = lazyCreate;
        return this;
    }
    enableDestroy(destroy) {
        this.destroyExisting = destroy;
        return this;
    }
    withDelay(millisecondDelay) {
        this.millisecondDelay = millisecondDelay;
        return this;
    }
    update(id, mutation) {
        const dto = this.getCurrentSourceValueWithId(id) ?? this.inflightCreatesIndex.get(id);
        if (dto) {
            this.getOrStartOperation(dto, () => this.createAsyncUpdateOperation(dto, this.inflightUpdateDtos, this.saveExisting)).update(mutation);
        }
        else {
            // lazy creates
            assert.isFunction(this.saveNew, `No source element with id=${id}, to enable lazy creates call enableLazyCreates(...) to provide an entity factory.`);
            console.log("lazy create");
            this.create(this.createNew(id)).update(mutation);
        }
    }
    create(dto) {
        return this.getOrStartOperation(dto, () => {
            return this.createAsyncUpdateOperation(dto, this.inflightCreateDtos, this.saveNew);
        });
    }
    destroy(dto) {
        this.getOrStartOperation(dto, () => {
            this.inflightDestroyDtos.push(dto);
            return new AsyncDestroy(dto, this.millisecondDelay, this.destroyExisting, {
                onDraftUpdate: (draft) => {
                    // don't care
                },
                onFailure: (failedUpdate, latestDraft) => {
                    this.inflightDestroyDtos.remove(latestDraft);
                    this.inFlightJobs.remove(failedUpdate);
                },
                onComplete: update => {
                    this.inflightDestroyDtos.remove(update.getCurrentDraft());
                    this.inFlightJobs.remove(update);
                }
            });
        }).destroy();
    }
    compute() {
        return this.sourceList.value
            .filter(dto => {
            const dtoId = this.identityOf(dto);
            return !this.inflightDestroysIndex.has(dtoId) && !this.inflightCreatesIndex.has(dtoId);
        })
            .map(item => {
            const identity = this.identityOf(item);
            const update = this.inflightUpdatesIndex.get(identity);
            // if (update) {
            //     console.log(`found update -> ${identity}`, JSON.stringify(update))
            // }
            return update ?? item;
        })
            .concat(this.inflightCreateDtos.value);
    }
    getOrStartOperation(dto, factory) {
        assert.isTruthy(dto);
        const existing = this.inFlightJobs.query().findMatching(u => u.isUpdateFor(dto));
        if (existing) {
            return existing;
        }
        else {
            const job = factory();
            this.inFlightJobs.push(job);
            return job;
        }
    }
    getCurrentSourceValueOf(dto) {
        return this.getCurrentSourceValueWithId(this.identityOf(dto));
    }
    getCurrentSourceValueWithId(id) {
        return this.sourceModelIndex.get(id);
    }
    getMostRecentValueWith(id) {
        return this.sourceModelIndex.get(id);
    }
    createAsyncUpdateOperation(dto, drafts, saveMethod) {
        assert.isTruthy(dto);
        const self = this;
        drafts.push(dto);
        return new AsyncUpdate(dto, this.millisecondDelay, saveMethod, {
            onDraftUpdate: (is, was) => {
                // console.log("updating draft", JSON.stringify({is, was}));
                drafts.replace(was, { with: is });
            },
            onFailure: (failedUpdate, draft) => {
                this.inFlightJobs.remove(failedUpdate);
                drafts.remove(draft);
            },
            onComplete: (completedUpdate) => {
                this.inFlightJobs.remove(completedUpdate);
                drafts.remove(completedUpdate.getCurrentDraft());
                if (completedUpdate.destroyRequested) {
                    self.destroy(dto);
                }
                else {
                    if (completedUpdate.hasUnprocessedUpdates()) {
                        // more changes were made after the update had started saving.
                        const nextOperation = self.createAsyncUpdateOperation(this.getCurrentSourceValueOf(dto), this.inflightUpdateDtos, this.saveExisting);
                        completedUpdate.getUnprocessedUpdates().forEach(pendingUpdate => nextOperation.update(pendingUpdate));
                    }
                }
            },
        });
    }
    isUpdating(id) {
        return !!this.inflightUpdatesIndex.get(id);
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

class Stream extends GarbageCollector {
    constructor() {
        super();
        this._listeners = new EventListenerList();
        this.registerDisposable(this._listeners);
    }
    subscribe(callback) {
        return this._listeners.add(callback);
    }
    // don't trace this, it's used by the tracer and will kill everything.
    publish(message) {
        this._listeners.fire(callback => callback(message));
    }
    publishAndWait(message) {
        return this._listeners.fireAndWait(callback => callback(message));
    }
    /**
     * @deprecated use #getSubscriberCount instead.
     */
    get subscriptionCount() {
        return this._listeners.listenerCount;
    }
    getSubscriberCount() {
        return this._listeners.listenerCount;
    }
    onSubscriptionsChanged(callback) {
        this._listeners.onSubscriptionsChanged(callback);
    }
}

class MutableStream extends Stream {
    // don't trace this, it's used by the tracer and will kill everything.
    publish(message) {
        super.publish(message);
    }
    publishAndWait(message) {
        return super.publishAndWait(message);
    }
    get readonly() {
        if (!this.__readonly) {
            this.__readonly = new MutableStream.ReadonlyStream(this);
        }
        return this.__readonly;
    }
}
(function (MutableStream) {
    class ReadonlyStream extends Stream {
        constructor(source) {
            super();
            this.source = source;
            this.registerDisposable(source.subscribe(item => {
                this.publish(item);
            }));
        }
    }
    MutableStream.ReadonlyStream = ReadonlyStream;
})(MutableStream || (MutableStream = {}));

class ComputedStream extends Stream {
    constructor(source) {
        super();
        assert.notNull(source);
        this.registerDisposable(source.subscribe(message => this.handleSourceStreamEvent(message)));
    }
}

class DelegatingStream extends Stream {
    constructor() {
        super();
        this._subscription = undefined;
        this._delegate = undefined;
        this.onDispose(() => this.setDelegate(undefined));
    }
    getDelegate() {
        return this._delegate;
    }
    setDelegate(delegate) {
        this._subscription?.dispose();
        this._delegate = delegate;
        if (delegate) {
            this._subscription = delegate.subscribe(message => this.publish(message));
        }
    }
}

class FilteredStream extends ComputedStream {
    constructor(source, predicate) {
        super(source);
        this.predicate = predicate;
        assert.notNull(predicate);
    }
    // @trace
    handleSourceStreamEvent(message) {
        if (this.predicate(message)) {
            this.publish(message);
        }
    }
}

class MappedStream extends ComputedStream {
    constructor(source, mapFunction) {
        super(source);
        this.mapFunction = mapFunction;
        assert.notNull(mapFunction);
    }
    // @trace
    handleSourceStreamEvent(message) {
        // console.log(message);
        this.publish(this.mapFunction(message));
    }
}

// TODO: Add a throttling variant that collects intermediate values and pushes the collected result as an array.
class ThrottledAccumulatorStream extends Stream {
    constructor(source, millisecondDelay = 250, delayInitial = true) {
        super();
        this.source = source;
        this.millisecondDelay = millisecondDelay;
        this.delayInitial = delayInitial;
        const accumulator = new ThrottledAccumulator(millisecondDelay, delayInitial);
        this.registerDisposable(this.source.subscribe(value => accumulator.push(value)));
        this.registerDisposable(accumulator.subscribe(v => this.publish(v)));
    }
}
/**
 * @deprecated user ThrottledAccumulatorStream instead.  Please note, unlike the chuncking stream the accumulator stream
 * will delaying the publishing of the first event.
 */
class ThrottledChunkingStream extends ThrottledAccumulatorStream {
    constructor(source, millisecondDelay = 250) {
        super(source, millisecondDelay, true);
    }
}

class ThrottledStream extends Stream {
    constructor(source, millisecondDelay = 250, delayInitial = true) {
        super();
        this.source = source;
        const accumulator = new ThrottledAccumulator(millisecondDelay, delayInitial);
        this.registerDisposable(source.subscribe(value => accumulator.push(value)));
        this.registerDisposable(accumulator.subscribe(values => this.publish(last(values))));
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

/**
 * @file Automatically generated by barrelsby.
 */

class Registration {
    constructor(source, adapter) {
        this.source = source;
        this.adapter = adapter;
    }
    isFor(source, adapterClass) {
        return source === this.adapter || (source === this.source && this.adapter.constructor === adapterClass);
    }
}
class AdapterRegistry extends GarbageCollector {
    constructor(debugContext) {
        super();
        this.debugContext = debugContext;
        this.registrations = [];
        this.onDispose(() => {
            this.registrations = undefined;
        });
    }
    getOrCreateAdapter(sourceOrAdapter, adapterClass, factory) {
        return this.getAdapter(sourceOrAdapter, adapterClass) || this.createAdapter(sourceOrAdapter, factory);
    }
    getAdapter(sourceOrAdapter, adapterClass) {
        if (sourceOrAdapter instanceof adapterClass) {
            return sourceOrAdapter;
        }
        else {
            const registration = this.registrations.find(r => r.isFor(sourceOrAdapter, adapterClass));
            return registration ? registration.adapter : null;
        }
    }
    createAdapter(source, factory) {
        assert.notNil(source);
        const adapter = factory(source);
        this.registrations.push(new Registration(source, adapter));
        return adapter;
    }
}

class DisposableSubscription extends GarbageCollector {
    constructor(subscribeFunctionName, subscriber) {
        super();
        this.subscribeFunctionName = subscribeFunctionName;
        this.subscriber = subscriber;
        this.onDispose(() => this.setDelegate(undefined));
    }
    setDelegate(delegate) {
        this.currentSubscription?.dispose();
        if (delegate && isFunction(delegate[this.subscribeFunctionName])) {
            this.currentSubscription = delegate[this.subscribeFunctionName](this.subscriber);
        }
    }
    getProxy(onDispose) {
        assert.isFunction(onDispose);
        const self = this;
        return {
            dispose: () => {
                self.dispose();
                onDispose();
            }
        };
    }
}
// @ts-ignore
class ProxySubscription extends GarbageCollector {
    constructor(subscribeFunctionName, subscriber, proxy) {
        super();
        this.subscribeFunctionName = subscribeFunctionName;
        this.subscriber = subscriber;
        this.proxy = proxy;
        this.onDispose(() => this.setDelegate(undefined));
    }
    setDelegate(delegate) {
        const canSubscribe = delegate && isFunction(delegate[this.subscribeFunctionName]);
        const subscriptionDelegate = canSubscribe ? delegate[this.subscribeFunctionName](this.subscriber) : undefined;
        this.proxy.setDelegate(subscriptionDelegate);
    }
    getProxy(onDispose) {
        assert.isFunction(onDispose);
        const self = this;
        return new Proxy(this.proxy, {
            get(subscriptionProxy, p, receiver) {
                if (p === "dispose") {
                    return () => {
                        onDispose();
                        subscriptionProxy.setDelegate(undefined);
                        // forward the method call to the proxy;
                        subscriptionProxy.dispose();
                    };
                }
                else {
                    return subscriptionProxy[p];
                }
            }
        });
    }
}
// @ts-ignore
class SubscriberList extends GarbageCollector {
    constructor(subscribeFunctionName, subscriptionProxyFactory) {
        super();
        this.subscribeFunctionName = subscribeFunctionName;
        this.subscriptionProxyFactory = subscriptionProxyFactory;
        this.subscriptions = new MutableListModel();
        this.onDispose(() => {
            this.subscriptions.value.forEach(s => s.dispose());
            this.subscriptions.value = [];
        });
    }
    addSubscriber(subscriber) {
        const subscription = this.subscriptionProxyFactory ?
            new ProxySubscription(this.subscribeFunctionName, subscriber, this.subscriptionProxyFactory()) :
            new DisposableSubscription(this.subscribeFunctionName, subscriber);
        this.subscriptions.push(subscription);
        subscription.setDelegate(this._currentDelegate);
        return subscription.getProxy(() => {
            this.subscriptions.remove(subscription);
        });
    }
    setDelegate(delegate) {
        this._currentDelegate = delegate;
        this.subscriptions.value.forEach(s => s.setDelegate(delegate));
    }
}
class DelegateProxyHandler {
    constructor(targetClass, garbage) {
        this.targetClass = targetClass;
        this.garbage = garbage;
        this.propertyDelegates = new Map();
        this.functionDelegates = new Map();
        this.subscriptionDelegates = new Map();
    }
    dispose() {
        this.garbage.dispose();
    }
    registerDisposable(disposable) {
        return this.garbage.registerDisposable(disposable);
    }
    forProperty(propertyName, delegateFactory) {
        assert.isFalsey(this.hasDelegateFor(propertyName));
        this.propertyDelegates.set(propertyName, this.garbage.registerDisposable(delegateFactory()));
    }
    // @ts-ignore
    forFunction(functionName, defaultReturn) {
        assert.isFalsey(this.hasDelegateFor(functionName));
        this.functionDelegates.set(functionName, defaultReturn);
    }
    // @ts-ignore
    forSubscriptionFunction(functionName) {
        assert.isFalsey(this.hasDelegateFor(functionName));
        this.subscriptionDelegates.set(functionName, this.garbage.registerDisposable(new SubscriberList(functionName)));
    }
    // @ts-ignore
    forSubscriptionFunctionWithProxy(functionName, proxyFactory) {
        assert.isFalsey(this.hasDelegateFor(functionName));
        this.subscriptionDelegates.set(functionName, this.garbage.registerDisposable(new SubscriberList(functionName, proxyFactory)));
    }
    hasDelegateFor(key) {
        return this.hasPropertyDelegate(key) || this.hasFunctionDelegate(key) || this.hasSubscriptionDelegate(key);
    }
    // Proxy handler implementation.
    get(garbageCollector, property, receiver) {
        if (this.garbage.isDisposed()) {
            lang.illegalState(`Trying to access "${property.toString()}" on a disposed DelegateProxyHandler (TODO: add better debug info)"`);
        }
        if (property === 'setDelegate') {
            return (delegate) => this.setDelegate(delegate);
        }
        if (property === 'getDelegate') {
            return () => this.getDelegate();
        }
        if (property === 'dispose') {
            return () => this.dispose();
        }
        if (this.hasPropertyDelegate(property)) {
            return this.propertyDelegates.get(property);
        }
        if (this.hasFunctionDelegate(property)) {
            // return the delegate function or return a function that returns the default value if specified.
            return this._delegate ? this._delegate[property].bind(this._delegate) : () => this.functionDelegates.get(property);
        }
        if (this.hasSubscriptionDelegate(property)) {
            return (subscriber) => this.subscriptionDelegates.get(property).addSubscriber(subscriber);
        }
        if (this._delegate && !isNil$1(this._delegate[property])) {
            lang.illegalState(`Delegate registered for ${this._delegate.constructor.name} doesn't support ${property}. `);
        }
        // This lets our proxy implement GarbageCollector methods
        return this.garbage[property];
    }
    hasPropertyDelegate(property) {
        return this.propertyDelegates.has(property);
    }
    hasFunctionDelegate(property) {
        return this.functionDelegates.has(property);
    }
    hasSubscriptionDelegate(property) {
        return this.subscriptionDelegates.has(property);
    }
    setDelegate(delegate) {
        this._delegate = delegate;
        this.propertyDelegates.forEach((propertyDelegate, key) => {
            propertyDelegate.setDelegate(delegate ? delegate[key] : null);
        });
        this.subscriptionDelegates.forEach((subscriptionManager, functionName) => {
            subscriptionManager.setDelegate(delegate);
        });
    }
    getDelegate() {
        return this._delegate;
    }
}
(function (DelegateProxyHandler) {
    function create(targetClass, builder) {
        const garbage = new GarbageCollector();
        const handler = new DelegateProxyHandler(targetClass, garbage);
        builder(handler);
        return new Proxy(garbage, handler);
    }
    DelegateProxyHandler.create = create;
})(DelegateProxyHandler || (DelegateProxyHandler = {}));

class Mixin {
}
(function (Mixin) {
    function createProxy(original, mixin) {
        return new Proxy(original, new Handler(original, mixin));
    }
    Mixin.createProxy = createProxy;
    class Handler {
        // @ts-ignore
        constructor(original, mixin) {
            this.original = original;
            this.mixin = mixin;
        }
        // @ts-ignore
        get(target, property, receiver) {
            return !isNil$1(this.mixin[property]) ? this.mixin[property] : target[property];
        }
    }
    Mixin.Handler = Handler;
})(Mixin || (Mixin = {}));

class ProxyRegistry extends GarbageCollector {
    constructor(debugContext) {
        super();
        this.debugContext = debugContext;
        this._registrations = [];
        this.onDispose(() => {
            this._registrations = undefined;
        });
    }
    get registrations() {
        if (!this._registrations) {
            lang.illegalState('Attempting the use a disposed ProxyRegistry');
        }
        return this._registrations;
    }
    getOrCreateProxy(source, mixinType, factory) {
        return this.getProxy(source, mixinType) || this.createProxy(source, factory());
    }
    getProxy(source, type) {
        const registration = this.registrations.find(r => r.isFor(source, type));
        return registration ? registration.proxy : null;
    }
    createProxy(source, mixin) {
        assert.notNil(source);
        assert.notNil(mixin);
        let handler = new ProxyRegistry.Handler(mixin, DebugContext.getOrCreate(source), this.debugContext);
        const proxy = new Proxy(source, handler);
        this.onDispose(() => handler.revoke());
        this.registrations.push(new ProxyRegistry.Registration(source, proxy, mixin));
        return proxy;
    }
}
(function (ProxyRegistry) {
    class Registration {
        constructor(source, proxy, mixin) {
            this.source = source;
            this.proxy = proxy;
            this.mixin = mixin;
        }
        isFor(source, mixinType) {
            return (source === this.proxy || source === this.source) && this.mixin.constructor === mixinType;
        }
    }
    ProxyRegistry.Registration = Registration;
    // Todo: Replace this with @coolon/typescript-utilities/Mixin
    class Handler {
        constructor(mixin, sourceDebugContext, dslDebugContext) {
            this.mixin = mixin;
            this.sourceDebugContext = sourceDebugContext;
            this.dslDebugContext = dslDebugContext;
            this._revoked = false;
        }
        revoke() {
            this._revoked = true;
        }
        get(target, property, reciever) {
            if (this._revoked) {
                lang.illegalState(`Trying to access "${property.toString()}" on a proxied "${this.sourceDebugContext.getTag()}" disposed with "${this.dslDebugContext.getDebugLabel()}"`);
            }
            // delegate to the chain first if it exists, otherwise send it to the underlying model.
            return isNil$1(this.mixin[property]) ? target[property] : this.mixin[property];
        }
    }
    ProxyRegistry.Handler = Handler;
})(ProxyRegistry || (ProxyRegistry = {}));

/**
 * @file Automatically generated by barrelsby.
 */

class HasValueMixin {
    constructor(_source, dsl) {
        this._source = _source;
        this.dsl = dsl;
    }
    /**
     * Adds a transaction start listener to this model.  When fired all models involved in the transaction will
     * still report their initial value.
     * @param listener
     */
    onTransactionStart(listener, callbackContext) {
        return this.dsl.registerDisposable(this._source.onTransactionStart(listener, callbackContext));
    }
    /**
     * This listener will be called when all participants in the transaction have committed and
     * the transaction is no longer active.
     * @param listener
     */
    onTransactionFinalised(listener, callbackContext) {
        return this.dsl.registerDisposable(this._source.onTransactionFinalised(listener, callbackContext));
    }
    /**
     *
     */
    onValueChange(listener) {
        return this.dsl.registerDisposable(this._source.onValueChange(listener));
    }
}

class IndexCache extends GarbageCollector {
    constructor(dsl, _source) {
        super();
        this.dsl = dsl;
        this._source = _source;
        this._hasOnes = new Map();
        this._hasManies = new Map();
    }
    getHasOne(key) {
        let idx = this._hasOnes.get(key);
        if (!idx) {
            idx = this.registerDisposable(HasOneIndex.identifiedBy(this._source, key));
            DebugContext.getOrCreate(idx).tag(`indexBy('${key.toString()}')`); // ooo, bug.
            this._hasOnes.set(key, idx);
        }
        return idx;
    }
    getHasMany(key) {
        let idx = this._hasManies.get(key);
        if (!idx) {
            idx = this.registerDisposable(HasManyIndex.identifiedBy(this._source, key));
            DebugContext.getOrCreate(idx).tag(`indexManyBy('${key.toString()}')`);
            this._hasManies.set(key, idx);
        }
        return idx;
    }
}

class ListModelChainMixin extends HasValueMixin {
    constructor(source, dsl) {
        super(source, dsl);
        this.source = source;
    }
    /**
     * Subscribes to the current value of the model and any subsequent changes.
     *
     * @param func the callback to be notified of the current value and any subsequent changes.
     * @param options
     */
    subscribe(func, options = { initialValue: 'evaluate' }) {
        this.dsl.when(this.source).matches(() => true, options).execute(func); // using matches instead of changes lets us use 'evaluate' as the key.
    }
    map(mapFunction, options) {
        const nilSafeMapper = AllowNil.gateFunction(mapFunction, options);
        const func = (values) => map(values, (value, index) => nilSafeMapper(value, index));
        const model = ComputedListModel.fromList(this.source, func, { initialValue: [], ...options });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "map"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    flatMap(mapFunction, options) {
        return this.map(mapFunction).reduceToList(nestedLists => flatten(nestedLists), { tag: 'flatMap' });
    }
    pluck(attribute, options) {
        return this.map(value => value[attribute], {
            tag: DebugContext.getTagOrDefault(options, `pluck('${attribute.toString()})'`),
            ...options
        });
    }
    /**
     * Plucks the array from each item and flattens the result.
     * @param property
     * @param options
     */
    pluckList(property, options) {
        return this.reduceToList(values => flatten(values.map(v => v[property])), {
            tag: DebugContext.getTagOrDefault(options, `pluckList('${property.toString()})'`),
            ...options
        });
    }
    select(predicate, options) {
        return this.reduceToList((values) => filter(values, predicate), {
            tag: DebugContext.getTagOrDefault(options, "select"),
            ...options
        }).identifiedWith(this.source.identityOf);
    }
    /**
     * Select items that are an instance of the specified class.
     * @param ctor
     */
    selectInstanceOf(ctor) {
        return this.select(item => item instanceof ctor);
    }
    /**
     * Prevents any changes from occurring while the specified condition is false.  When the condition becomes true
     * the list will update and fire events if there have been any changes in the meantime.
     * @param condition
     */
    postponeUntil(condition) {
        return this.select(value => true, {
            postponeUntil: condition,
            tag: "postponeUntil"
        });
    }
    /**
     * Prevents any changes from occurring while the specified condition is true.  When the condition becomes false
     * the list will update and fire events if there have been any changes in the meantime.
     * @param condition
     */
    postponeWhile(condition) {
        return this.select(value => true, {
            postponeWhile: condition,
            tag: "postponeWhile"
        });
    }
    /**
     * Replaces any matching items in the list with the specified value. The match is determined by the source
     * list identity function.
     * @param valueOrValueModel the value or model to use for pinning.
     */
    replace(valueOrValueModel) {
        const replaceValue = this.dsl.chain.wrap(valueOrValueModel);
        const mapFunction = item => {
            const shouldReplace = replaceValue.value && this.source.identityOf(item) === this.source.identityOf(replaceValue.value);
            return shouldReplace ? replaceValue.value : item;
        };
        return this.map(mapFunction, {
            dependsOn: replaceValue,
            tag: "merge"
        }).identifiedWith((item) => this.source.identityOf(item));
    }
    /**
     * Replaces any matching items in the list with the specified value. The match is determined by the source
     * list identity function.
     * @param {Array|ListModel} listOrListModel an array or list model that contains the items be replaced in the source list.
     * @param {Object} options
     * @param {String} options.identifiedBy specify a property by which to compare and replace
     */
    replaceAll(listOrListModel, options) {
        const replacementList = this.dsl.chain.wrap(listOrListModel);
        const replacementLookup = options ?
            HasOneIndex.identifiedBy(replacementList, options.identifiedBy) :
            HasOneIndex.identifiedWith(replacementList, this.source.identityOf);
        return this.map(item => {
            const identityOf = replacementLookup.identityOf(item);
            const replaceWith = replacementLookup.get(identityOf);
            // console.log({id: identityOf, replaceWith})
            return replaceWith || item;
        }, { dependsOn: replacementLookup, tag: "replaceAll" })
            .identifiedWith((item) => this.source.identityOf(item));
    }
    reject(predicate, options) {
        return this.select(value => !predicate(value), {
            tag: DebugContext.getTagOrDefault(options, "reject"),
            ...options
        }); //.identifiedWith(this.source.identityOf);
    }
    rejectNil() {
        return this.reject(value => isNil(value), {
            tag: "rejectNil"
        }); //.identifiedWith(this.source.identityOf);
    }
    identifiedBy(key) {
        return this.dsl.chain(DelegatingListModel.wrap(this.source, { identifiedBy: key }));
    }
    identifiedWith(func) {
        return this.dsl.chain(DelegatingListModel.wrap(this.source, { identifiedWith: func }));
    }
    otherwise(arrayOrListModel) {
        const model = DelegatingListModel.wrap(this.source).withDefault(arrayOrListModel);
        DebugContext.getOrCreate(model).tag("otherwise");
        return this.dsl.chain(model);
    }
    substitute(substituteListOrModel, options) {
        assert.oneOf(options, 'while', 'until');
        const trigger = this.dsl.chain.wrap(options.while) || this.dsl.chain(options.until).isFalsey();
        return this.dsl.switchOn(trigger).toList(c => {
            c.equalTo(true, substituteListOrModel);
            c.otherwise(this.source);
        });
    }
    difference(arrayOrListModel, options) {
        const other = this.dsl.chain.wrap(arrayOrListModel);
        const opts = DependsOnOptions.addDependency({ ...options, identifiedWith: this.source.identityOf }, other);
        const func = (values) => differenceBy(values, other.value, this.source.identityOf);
        const model = ComputedListModel.fromList(this.source, func, { initialValue: [], ...opts });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    slice(start, end) {
        const startModel = MutableValueModel.wrap(start);
        const endModel = MutableValueModel.wrap(end);
        const model = ComputedListModel.fromList(this.source, (list) => list.slice(startModel.value, endModel.value), { initialValue: [], identifiedWith: this.source.identityOf, dependsOn: [startModel, endModel] });
        DebugContext.getOrCreate(model).tag(isNil(end) ? `slice(${start})` : `slice(${start}, ${end})`);
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    head(size, options) {
        const model = this.slice(0, size);
        DebugContext.getOrCreate(model).tag({ tag: 'head', ...options }.tag);
        return model;
    }
    tail(size, options) {
        const startModel = this.count().subtract(MutableValueModel.wrap(size)).map(start => Math.max(0, start));
        const model = this.slice(startModel);
        DebugContext.getOrCreate(model).tag({ tag: 'tail', ...options }.tag);
        return model;
    }
    find(predicate, options) {
        const func = (list) => find(list, predicate);
        const model = ComputedValueModel.fromList(this.source, func, {
            tag: DebugContext.getTagOrDefault(options, "find"),
            initialValue: undefined,
            ...options,
            allowNil: false,
            identifiedWith: this.source.identityOf
        });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    findLast(predicate, options) {
        const func = list => findLast$1(list, predicate);
        const model = ComputedValueModel.fromList(this.source, func, {
            tag: DebugContext.getTagOrDefault(options, "findLast"),
            initialValue: undefined,
            ...options,
            allowNil: false,
            identifiedWith: this.source.identityOf
        });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    findIndex(predicate) {
        const model = ComputedValueModel.fromList(this.source, (list) => {
            return findIndex(list, predicate);
        });
        this.dsl.registerDisposable(model);
        return this.dsl.chain.numericValue(model);
    }
    ;
    valueAt(indexModel, options) {
        const func = (values) => {
            const index = indexModel.value;
            return (isNil(index) || index >= values.length || index < 0) ? undefined : values[index];
        };
        const opts = DependsOnOptions.addDependency({
            ...options,
            allowNil: false,
            identifiedWith: this.source.identityOf
        }, indexModel);
        const model = ComputedValueModel.fromList(this.source, func, { initialValue: undefined, ...opts });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "valueAt"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    reduce(func, options) {
        const model = ComputedValueModel.fromList(this.source, func, { initialValue: undefined, ...options });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    reduceToList(func, options) {
        const model = ComputedListModel.fromList(this.source, func, { initialValue: [], ...options });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "reduce"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    concat(arrayOrListModel, options) {
        const otherModel = this.dsl.chain.wrap(arrayOrListModel);
        const opts = Object.assign(DependsOnOptions.addDependency(options, otherModel), { identifiedWith: this.source.identityOf });
        const model = ComputedListModel.fromList(this.source, (values) => [].concat(values, otherModel.value), { initialValue: [], ...opts });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "concat"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    unshift(arrayOrListModel, options) {
        const otherModel = this.dsl.chain.wrap(arrayOrListModel);
        const opts = Object.assign(DependsOnOptions.addDependency(options, otherModel), { identifiedWith: this.source.identityOf });
        const model = ComputedListModel.fromList(this.source, (values) => [].concat(otherModel.value, values), { initialValue: [], ...opts });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "concat"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    prepend(valueOrValueModel, options) {
        const otherModel = this.dsl.chain.wrap(valueOrValueModel).mapToList(v => [v]);
        return this.unshift(otherModel, { tag: "prepend" });
    }
    append(valueOrValueModel, options) {
        const otherModel = this.dsl.chain.wrap(valueOrValueModel).mapToList(v => [v]);
        return this.concat(otherModel, { tag: "append" });
    }
    first(options) {
        const func = (items) => first$1(items);
        const opts = Object.assign({}, options, {
            allowNil: false,
            identifiedWith: this.source.identityOf
        });
        const model = ComputedValueModel.fromList(this.source, func, { initialValue: undefined, ...opts });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "first"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    last(options) {
        const func = (items) => last$1(items);
        const model = ComputedValueModel.fromList(this.source, func, {
            initialValue: undefined,
            ...options,
            allowNil: false,
            identifiedWith: this.source.identityOf
        });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "last"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    /**
     * Allows you to tap into a method chain and observe the result.  The return value is ignored and the value is passed unchanged to the next point in the chain.
     * Note the callback will be invoked immediately if the source has one or more items).  This is to prevent the deep confusion when you add a tap and see nothing.
     *
     * @param func
     */
    tap(func) {
        const chained = this.dsl.chain(this.source);
        chained.subscribe(value => func(value));
        return chained;
    }
    findIn(index, options = {}) {
        const isMissing = index instanceof MapModel ? isNil : isEmpty$1;
        const mapFunction = value => {
            const result = index.get(value);
            if (isMissing(result) && options.onMissing) {
                options.onMissing(value);
            }
            return result;
        };
        const findOptions = {
            tag: "findIn",
            ...options,
            dependsOn: index
        };
        return index instanceof MapModel ?
            this.map(mapFunction, findOptions) :
            this.map(mapFunction, findOptions).reduceToList(values => flatten(values));
    }
    throttle(millisecondDelay = 250) {
        const throttledListModel = this.dsl.chain(this.dsl.registerDisposable(new ThrottledListModel(this.source, millisecondDelay)));
        const valueModelChain = ListModel.isInstance(this.source) ?
            throttledListModel.identifiedWith(this.source.identityOf) :
            throttledListModel;
        DebugContext.getOrCreate(valueModelChain).tag(`throttle(millisecondDelay=${millisecondDelay})`);
        return valueModelChain;
    }
    ;
    count() {
        return this.dsl.chain.numericValue(this.reduce(items => items ? items.length : 0, { tag: "count" }));
    }
    chunk(size) {
        let size$ = this.dsl.chain.wrap(size);
        return this.reduceToList((optionList) => chunk(optionList, size$.value), {
            dependsOn: size$,
            tag: `chunk(${size})`
        });
    }
    sort(compareFunction) {
        return this.reduceToList((values) => [].concat(values).sort(compareFunction), {
            tag: "sort"
        }).identifiedWith(this.source.identityOf);
    }
    sortBy(attribute) {
        return this.reduceToList((values) => sortBy((values || []), attribute), {
            tag: "sortBy"
        }).identifiedWith(this.source.identityOf);
    }
    sortUsing(sortAll, options) {
        const sorterModel = this.dsl.chain.wrap(sortAll);
        return this.reduceToList((values) => sortAll(values), {
            tag: "sortUsing",
            ...options
        }).identifiedWith(this.source.identityOf);
    }
    reverse() {
        return this.reduceToList((values) => (values || []).slice().reverse(), {
            tag: "reverse"
        }).identifiedWith(this.source.identityOf);
    }
    uniq() {
        return this.reduceToList((values) => uniq$1(values || []), {
            tag: "uniq"
        }).identifiedWith(this.source.identityOf);
    }
    uniqBy(property) {
        return this.reduceToList((values) => uniqBy(values || [], property), {
            tag: "uniqBy"
        }).identifiedWith(this.source.identityOf);
    }
    any() {
        return this.isNotEmpty();
    }
    empty() {
        return this.isEmpty();
    }
    isNotEmpty() {
        const model = ComputedValueModel.fromList(this.source, (items) => items && items.length > 0, {
            initialValue: undefined,
            allowNil: true
        });
        DebugContext.getOrCreate(model).tag("isNotEmpty");
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
    isEmpty() {
        const model = ComputedValueModel.fromList(this.source, (items) => {
            return isNil(items) || items.length < 1;
        }, { initialValue: undefined, allowNil: true });
        DebugContext.getOrCreate(model).tag("isEmpty");
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
    includes(valueOrModel) {
        const compareTo = MutableValueModel.wrap(valueOrModel);
        const model = ComputedValueModel.fromList(this.source, (items) => {
            // console.log({compareTo: compareTo.value, items})
            return items && items.includes(compareTo.value);
        }, { initialValue: undefined, allowNil: true, dependsOn: compareTo });
        DebugContext.getOrCreate(model).tag("includes");
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
    indexOf(valueOrModel) {
        const compareTo = MutableValueModel.wrap(valueOrModel);
        const model = ComputedValueModel.fromList(this.source, (items) => {
            const other = compareTo.value;
            return items && items.findIndex(t => {
                return this.source.identityOf(t) === this.source.identityOf(other);
            });
        }, { initialValue: undefined, allowNil: true, dependsOn: compareTo });
        DebugContext.getOrCreate(model).tag("indexOf");
        this.dsl.registerDisposable(model);
        return this.dsl.chain.numericValue(model);
    }
    indexBy(key, options) {
        let hasOne = this.autoDisposedIndexCache().getHasOne(key);
        if (options) {
            hasOne = Mixin.createProxy(hasOne, new ListModelChainMixin.OnMapEntryMissingDecorator(hasOne, options));
        }
        return this.dsl.chain(hasOne);
    }
    indexManyBy(key, options) {
        let hasMany = this.autoDisposedIndexCache().getHasMany(key);
        if (options) {
            hasMany = Mixin.createProxy(hasMany, new ListModelChainMixin.OnMultiMapEntryMissingDecorator(hasMany, options));
        }
        return this.dsl.chain(hasMany);
    }
    indexUsing(func, options) {
        // NOTE: no caching for now
        let hasOne = this.dsl.registerDisposable(HasOneIndex.identifiedWith(this.source, func));
        if (options) {
            hasOne = Mixin.createProxy(hasOne, new ListModelChainMixin.OnMapEntryMissingDecorator(hasOne, options));
        }
        return this.dsl.chain(hasOne);
    }
    indexManyUsing(func, options) {
        // NOTE: no caching for now
        let hasOne = this.dsl.registerDisposable(HasManyIndex.identifiedWith(this.source, func));
        if (options) {
            hasOne = Mixin.createProxy(hasOne, new ListModelChainMixin.OnMultiMapEntryMissingDecorator(hasOne, options));
        }
        return this.dsl.chain(hasOne);
    }
    convert(converter) {
        // note: we can't use gated models here as they're inherently readonly and converted models are mutable.
        const model = new MutableListModel();
        this.dsl.registerDisposable(new Binding(model, this.source, Binding.adaptConverter(converter))).writeLeft();
        DebugContext.getOrCreate(model).tag(`convert`);
        return this.dsl.chain(model);
    }
    autoDisposedIndexCache() {
        // This ensures multiple calls to the one key are backed by the same underlying index so we don't
        // recompute the lookup for each client.
        return this.dsl.getOrCreateAdapter(this.source, IndexCache, (src) => {
            return new IndexCache(this.dsl, src);
        });
    }
}
(function (ListModelChainMixin) {
    function arrayify(thing) {
        if (isNil(thing)) {
            return [];
        }
        else {
            return isArray(thing) ? thing : [thing];
        }
    }
    class OnMapEntryMissingDecorator extends Mixin {
        constructor(mapModel, options) {
            super();
            this.mapModel = mapModel;
            this.options = options;
        }
        get(key) {
            const value = this.mapModel.get(key);
            if (isNil(value)) {
                this.options.onMissing(key);
            }
            return value;
        }
    }
    ListModelChainMixin.OnMapEntryMissingDecorator = OnMapEntryMissingDecorator;
    class OnMultiMapEntryMissingDecorator extends Mixin {
        constructor(mapModel, options) {
            super();
            this.mapModel = mapModel;
            this.options = options;
        }
        get(key) {
            const value = this.mapModel.get(key);
            if (isNil(value) || value.length < 1) {
                this.options.onEmpty(key);
            }
            return value;
        }
    }
    ListModelChainMixin.OnMultiMapEntryMissingDecorator = OnMultiMapEntryMissingDecorator;
})(ListModelChainMixin || (ListModelChainMixin = {}));

const isEmpty = (map) => {
    for (const nullItem of map.keys()) {
        return false;
    }
    return true;
};
class AbstractMapModelChainMixin extends HasValueMixin {
    constructor(source, dsl) {
        super(source, dsl);
        this.source = source;
    }
    keys() {
        const model = new ComputedListModel.ComputedListModelFromHasValue(this.source, (map) => {
            return Array.from(map.keys());
        }, { initialValue: [] });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    includesKey(key) {
        return this.keys().includes(key);
    }
    isEmpty() {
        const model = new ComputedValueModel.ComputedValueModelImpl(this.source, isEmpty, { initialValue: true });
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
    isNotEmpty() {
        const model = new ComputedValueModel.ComputedValueModelImpl(this.source, map => !isEmpty(map), { initialValue: false });
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
}

class MapModelChainMixin extends AbstractMapModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    createConverter() {
        const source = this.source;
        const converter = {
            fromSource(id) {
                return isNil(id) ? undefined : source.value.get(id);
            },
            fromSourceDependsOn: source,
            toSource(entity, current) {
                return entity ? source.identityOf(entity) : undefined;
            }
        };
        return converter;
    }
    values() {
        const model = new ComputedListModel.ComputedListModelFromHasValue(this.source, (map) => {
            return Array.from(map.values());
        }, { initialValue: [], identifiedWith: this.source.identityOf });
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    includesValue(value) {
        return this.values().includes(value);
    }
    map(func, options) {
        const model = new MappedMapModel(this.source, func, options);
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    findBy(keyOrModel, options) {
        let keyModel = MutableValueModel.wrap(keyOrModel);
        return this.dsl.chain(keyModel).map(key => {
            const result = this.source.value.get(key);
            if (isNil(result) && options?.onMissing) {
                options.onMissing(key);
            }
            return result;
        }, { dependsOn: this.source }).identifiedWith(this.source.identityOf);
    }
    findAllBy(keyOrModel, options) {
        let keyModel = ListModel.wrap(keyOrModel);
        return this.dsl.chain(keyModel).reduceToList(keys => {
            const result = [];
            keys.forEach(key => {
                const value = this.source.value.get(key);
                if (isNil(value)) {
                    if (options?.onMissing) {
                        options.onMissing(key);
                    }
                }
                else {
                    result.push(value);
                }
            });
            return result;
        }, { dependsOn: this.source }).identifiedWith(this.source.identityOf);
    }
    bind(idModel, model) {
        const source = this.source;
        const modelBinding = new Binding(idModel, model, {
            toLeft: item => item ? source.identityOf(item) : undefined,
            toRight: id => id ? source.value.get(id) : undefined
        }).rightDependsOn(source);
        this.dsl.registerDisposable(modelBinding);
        return modelBinding;
    }
}

class MultiMapModelChainMixin extends AbstractMapModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    findBy(keyOrModel, options) {
        const chain = this.dsl.chain;
        let keyModel = chain.wrap(keyOrModel);
        return chain(keyModel).mapToList(key => {
            const result = this.source.value.get(key);
            if (options?.onEmpty && isEmpty$2(result)) {
                options.onEmpty(key);
            }
            return result;
        }, { dependsOn: this.source });
    }
}

class StreamChainMixinBase {
    constructor(source, dsl) {
        this.source = source;
        this.dsl = dsl;
    }
    subscribe(callback) {
        return this.dsl.registerDisposable(this.source.subscribe(callback));
    }
    collectLast(size, options) {
        const list = new MutableListModel();
        this.dsl.registerDisposable(this.source.subscribe(value => {
            if (list.length < size) {
                list.push(value);
            }
            else {
                list.value = list.value.slice(1 - size).concat(value);
            }
        }));
        if (options?.resetOnChangeTo) {
            const triggers = Array.isArray(options.resetOnChangeTo) ? options.resetOnChangeTo : [options.resetOnChangeTo];
            this.dsl.when.anyOf(...triggers).changes(() => {
                return list.value = options.resetValuesTo ? options.resetValuesTo(list.value) : [];
            });
        }
        return this.dsl.chain(list);
    }
    ;
    throttle(millisecondDelay) {
        return this.dsl.chain(this.dsl.registerDisposable(new ThrottledStream(this.source, millisecondDelay)));
    }
    ;
    throttleAndChunk(millisecondDelay) {
        return this.dsl.chain(this.dsl.registerDisposable(new ThrottledAccumulatorStream(this.source, millisecondDelay)));
    }
    ;
    filter(predicate) {
        return this.dsl.chain(this.dsl.registerDisposable(new FilteredStream(this.source, predicate)));
    }
    ;
    select(predicate) {
        return this.filter(item => predicate(item));
    }
    ;
    selectInstanceOf(klass) {
        return this.filter(item => item instanceof klass);
    }
    ;
    reject(predicate) {
        return this.filter(item => !predicate(item));
    }
    ;
    tap(tee) {
        return this.dsl.chain(this.dsl.registerDisposable(new FilteredStream(this.source, item => {
            tee(item);
            return true;
        })));
    }
    ;
}

class StreamChainMixin extends StreamChainMixinBase {
    constructor(source, dsl) {
        super(source, dsl);
    }
    map(map) {
        return this.dsl.chain(this.dsl.registerDisposable(new MappedStream(this.source, map)));
    }
    last() {
        const lastItem = new MutableValueModel();
        this.dsl.registerDisposable(this.source.subscribe(message => lastItem.value = message));
        return this.dsl.chain(lastItem);
    }
    rejectNil() {
        return this.filter(item => !isNil(item));
    }
    /**
     * @deprecated use #selectInstanceOf instead
     */
    ofType(ctor) {
        return this.filter(item => item instanceof ctor);
    }
}

class BaseValueModelChainMixin extends HasValueMixin {
    constructor(source, dsl) {
        super(source, dsl);
        this.source = source;
    }
    /**
     * Subscribes to the current value of the model and any subsequent changes.
     *
     * @param func the callback to be notified of the current value and any subsequent changes.
     * @param options
     */
    subscribe(func, options = { initialValue: "evaluate" }) {
        this.dsl.when(this.source).matches(() => true, { ...options }).execute(func); // using matches instead of changes lets us use 'evaluate' as the key.
    }
    map(func, options = {}) {
        const model = MappedValueModel.create(this.source, func, { initialValue: undefined, ...options });
        DebugContext.getOrCreate(model).tag(DebugContext.getTagOrDefault(options, "map"));
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    mapToList(func, options = {}) {
        const model = ComputedListModel.fromValue(this.source, func, { initialValue: [], ...options });
        DebugContext.getOrCreate(model).tag(options.tag ? options.tag : "mapToList");
        this.dsl.registerDisposable(model);
        return this.dsl.chain(model);
    }
    /**
     * Prevents any changes from occurring while the specified condition is false.  When the condition becomes true
     * the list will update and fire events if there have been any changes in the meantime.
     * @param condition
     */
    postponeUntil(condition) {
        return this.map(value => value, {
            postponeUntil: condition,
            tag: "postponedUntil"
        }).identifiedWith(this.source.identityOf);
    }
    /**
     * Prevents any changes from occurring while the specified condition is true.  When the condition becomes false
     * the list will update and fire events if there have been any changes in the meantime.
     * @param condition
     */
    postponeWhile(condition) {
        return this.map(value => value, {
            postponeWhile: condition,
            tag: "postponedUntil"
        }).identifiedWith(this.source.identityOf);
    }
    asChangeStream() {
        // TODO: remove onValueChange and add {initialValue: 'ignore' | 'publish' | 'publishUnlessNil'} options.
        const stream = this.dsl.registerDisposable(new MutableStream());
        this.dsl.registerDisposable(this.source.onValueChange((value, previousValue) => {
            stream.publish({ value, previous: previousValue });
        }));
        return this.dsl.chain(stream.readonly);
    }
    /**
     * @deprecated use MapModelChain#findBy instead
     */
    findIn(index, options = {}) {
        return this.map(value => {
            const result = index.get(value);
            if (isNil(result) && options.onMissing) {
                options.onMissing(value);
            }
            return result;
        }, { ...options, tag: "findIn", dependsOn: index });
    }
    /**
     * @deprecated use MultiMapModelChain#findBy instead
     */
    findAllIn(index, options = {}) {
        return this.mapToList(value => {
            const result = index.get(value);
            if (result.length < 1 && options.onMissing) {
                options.onMissing(value);
            }
            return result;
        }, { ...options, tag: "findAllIn", dependsOn: index });
    }
    throttle(millisecondDelay = 250) {
        const throttledValueModel = this.dsl.chain(this.dsl.registerDisposable(new ThrottledValueModel(this.source, millisecondDelay)));
        const valueModelChain = ValueModel.isInstance(this.source) ?
            throttledValueModel.identifiedWith(this.source.identityOf) :
            throttledValueModel;
        DebugContext.getOrCreate(valueModelChain).tag(`throttle(millisecondDelay=${millisecondDelay})`);
        return valueModelChain;
    }
    ;
    debounce(millisecondDelay = 250) {
        return this.throttle(millisecondDelay);
    }
    /**
     * Creates a two way binding between the this model and the returned model.
     * @param converter
     */
    convert(converter) {
        // note: we can't use gated models here as they're inherently readonly and converted models are mutable.
        const model = new MutableValueModel();
        this.dsl.registerDisposable(new Binding(model, this.source, Binding.adaptConverter(converter))).writeLeft();
        DebugContext.getOrCreate(model).tag("convert");
        return this.dsl.chain(model);
    }
    /**
     * Allows you to tap into a method chain and observe the result.  The return value is ignored and the value is passed unchanged to the next point in the chain.
     * Note the callback will be invoked immediately if the source already has a non nil value (or if allowNil is true).  This is to prevent the deep confusion when you add a tap and see nothing.
     *
     * @param func
     * @param options: AllowNil
     */
    tap(func, options) {
        // TODO: replace options allow nill with {initialValue: 'ignore' | 'evaluate' | 'evaluateUnlessNil'}.
        const callback = (value) => {
            if ((options && options.allowNil) || !isNil(value)) {
                func(value);
            }
        };
        const chain = this.dsl.chain(this.source);
        chain.subscribe(change => callback(change));
        return chain;
    }
    satisfies(predicate, options) {
        const model = ComputedValueModel.fromValue(this.source, (value) => predicate(value), { initialValue: undefined, allowNil: true, dependsOn: DependsOnOptions.extract(options) });
        if (options && options.tag) {
            DebugContext.getOrCreate(model).tag(options.tag);
        }
        this.dsl.registerDisposable(model);
        return this.dsl.chain.booleanValue(model);
    }
    isNil() {
        return this.satisfies((value) => isNil(value), {
            tag: "isNil"
        });
    }
    isNotNil() {
        return this.satisfies((value) => !isNil(value), {
            tag: "isNotNil"
        });
    }
    equals(compareToValue, options) {
        let compareToModel = this.dsl.chain.wrap(compareToValue);
        const identityOf = CanIdentify.createIdentityFunction(options, CanIdentify.wrap(this.source));
        return this.satisfies(value => {
            return identityOf(value) === identityOf(compareToModel.value);
        }, { dependsOn: compareToModel, tag: "equals" });
    }
    doesNotEqual(compareToValue) {
        return this.equals(compareToValue).isFalsey();
    }
    isNot(compareToValue) {
        return this.doesNotEqual(compareToValue);
    }
    isAnyOf(...values) {
        return this.satisfies(value => includes(values, value), {
            tag: "isAnyOf"
        });
    }
    isTruthy(debugOptions) {
        return this.satisfies(v => !!v, {
            tag: "isTruthy",
            ...debugOptions
        });
    }
    isFalsey(debugOptions) {
        return this.satisfies(v => !v, {
            tag: "isFalsey",
            ...debugOptions
        });
    }
}

class BooleanValueModelChainMixin extends BaseValueModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    registerDisposableAndWrap(model, tag) {
        this.dsl.registerDisposable(model);
        DebugContext.tag(model, tag);
        return this.dsl.chain.booleanValue(model);
    }
    or(other) {
        const model = new OrValueModel([this.source, other]);
        return this.registerDisposableAndWrap(model, "or");
    }
    orNot(other) {
        const model = new OrValueModel([this.source, this.dsl.chain(other).isFalsey()]);
        return this.registerDisposableAndWrap(model, "orNot");
    }
    and(other) {
        const model = new AndValueModel([this.source, other]);
        return this.registerDisposableAndWrap(model, "and");
    }
    andNot(other) {
        const model = new AndValueModel([this.source, this.dsl.chain(other).isFalsey()]);
        return this.registerDisposableAndWrap(model, "andNot");
    }
}

var BooleanModelDsl;
(function (BooleanModelDsl) {
    BooleanModelDsl.PROXY_PROPERTY_KEY = Symbol('pectin:dsl:booleanModelChainProxy');
    function create(dsl) {
        assert.notNil(dsl);
        const valueModel = (source) => {
            assert.notNil(source);
            return dsl.getOrCreateProxy(source, BooleanValueModelChainMixin, () => new BooleanValueModelChainMixin(source, dsl));
        };
        const staticMethods = new BooleanModelDsl.Static(dsl);
        const proxy = new Proxy(valueModel, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    BooleanModelDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
    }
    BooleanModelDsl.Static = Static;
})(BooleanModelDsl || (BooleanModelDsl = {}));

class NumericValueModelChainMixin extends BaseValueModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    reduceWith(other, func, tag) {
        const otherModel = this.dsl.chain.wrap(other);
        const model = this.dsl.chain(this.source).map(a => {
            const b = otherModel.value;
            return func(a, b);
        }, { dependsOn: otherModel, allowNil: true });
        DebugContext.tag(model, tag);
        return model;
    }
    reduceToNumeric(other, func, tag) {
        return this.dsl.chain.numericValue(this.reduceWith(other, func, tag));
    }
    reduceToBoolean(other, func, tag) {
        return this.dsl.chain.booleanValue(this.reduceWith(other, func, tag));
    }
    dividedBy(compareToValue) {
        return this.reduceToNumeric(compareToValue, (a, b) => a / b, "dividedBy");
    }
    multipliedBy(compareToValue) {
        return this.reduceToNumeric(compareToValue, (a, b) => a * b, "multipliedBy");
    }
    ;
    subtract(compareToValue) {
        return this.reduceToNumeric(compareToValue, (a, b) => a - b, "subtract");
    }
    ;
    add(compareToValue) {
        return this.reduceToNumeric(compareToValue, (a, b) => a + b, "add");
    }
    ;
    isGreaterThan(compareToValue) {
        return this.reduceToBoolean(compareToValue, (a, b) => {
            return a > b;
        }, "isGreaterThan");
    }
    ;
    isGreaterThanOrEqualTo(compareToValue) {
        return this.reduceToBoolean(compareToValue, (a, b) => a >= b, "isGreaterThanOrEqualTo");
    }
    ;
    isLessThan(compareToValue) {
        return this.reduceToBoolean(compareToValue, (a, b) => a < b, "isLessThan");
    }
    ;
    isLessThanOrEqualTo(compareToValue) {
        return this.reduceToBoolean(compareToValue, (a, b) => a <= b, "isLessThanOrEqualTo");
    }
    ;
}

var NumericModelDsl;
(function (NumericModelDsl) {
    NumericModelDsl.PROXY_PROPERTY_KEY = Symbol('pectin:dsl:numericModelChainProxy');
    function create(dsl) {
        assert.notNil(dsl);
        const numericModel = (source) => {
            assert.notNil(source);
            return dsl.getOrCreateProxy(source, NumericValueModelChainMixin, () => new NumericValueModelChainMixin(source, dsl));
        };
        const staticMethods = new NumericModelDsl.Static(dsl);
        const proxy = new Proxy(numericModel, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    NumericModelDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
    }
    NumericModelDsl.Static = Static;
})(NumericModelDsl || (NumericModelDsl = {}));

class StringValueModelChainMixin extends BaseValueModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    isBlank() {
        return this.satisfies(value => isNil(value) || value.toString().trim() == "", {
            tag: "isBlank"
        });
    }
    isNotBlank() {
        return this.isBlank().isFalsey({ tag: "isNotBlank" });
    }
    matches(regex) {
        return this.satisfies(value => regex.test(value), {
            tag: "matches"
        });
    }
    ;
}

var StringModelDsl;
(function (StringModelDsl) {
    StringModelDsl.PROXY_PROPERTY_KEY = Symbol('pectin:dsl:stringModelChainProxy');
    function create(dsl) {
        assert.notNil(dsl);
        const valueModel = (source) => {
            assert.notNil(source);
            return dsl.getOrCreateProxy(source, StringValueModelChainMixin, () => new StringValueModelChainMixin(source, dsl));
        };
        const staticMethods = new StringModelDsl.Static(dsl);
        const proxy = new Proxy(valueModel, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    StringModelDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
    }
    StringModelDsl.Static = Static;
})(StringModelDsl || (StringModelDsl = {}));

class SubscriptionAdapter extends GarbageCollector {
    constructor(_model) {
        super();
        this._model = _model;
        this.publishToModel = true;
        // we can't trust `this` to be us with observables.
        this.next = (value) => {
            this._lastPublishedValue = value;
            if (this.publishToModel) {
                this._model.value = value;
            }
        };
        this.complete = () => {
        };
        this.error = (error) => {
        };
        this.onDispose(() => {
            this.unsubscribe();
        });
    }
    unsubscribe() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }
    /**
     * Subscribe to the observable and return the most recent value.
     * @param observable
     */
    subscribe(observable, publishToModel = true) {
        this.unsubscribe();
        if (observable) {
            try {
                // Ugly flag to stop subscribe from pushing changes to our model
                // during the subscription process.  If it does we'll get transaction
                // update errors.
                this.publishToModel = publishToModel;
                this._subscription = observable.subscribe(this);
            }
            finally {
                this.publishToModel = true;
            }
        }
    }
    get lastPublishedValue() {
        return this._lastPublishedValue;
    }
}

class ValueModelChainMixin extends BaseValueModelChainMixin {
    constructor(source, dsl) {
        super(source, dsl);
    }
    pluck(property, options = {}) {
        return this.map(value => value[property], {
            tag: `pluck('${property.toString()}')`,
            ...options
        });
    }
    pluckString(property, options = {}) {
        const stringModel = this.pluck(property, {
            tag: `pluckString('${property.toString()}')`,
            ...options
        });
        return this.dsl.chain.stringValue(stringModel);
    }
    pluckNumeric(property, options = {}) {
        const numericModel = this.pluck(property, {
            tag: `pluckNumeric('${property.toString()}')`,
            ...options
        });
        return this.dsl.chain.numericValue(numericModel);
    }
    pluckList(property, options = {}) {
        // @ts-ignore what the?
        return this.mapToList(value => value[property], {
            tag: `pluckList('${property.toString()}')`,
            ...options
        });
    }
    isInstanceOf(constructor) {
        return this.satisfies((value) => value instanceof constructor, {
            tag: `instanceOf`,
        });
    }
    selectInstanceOf(constructor) {
        return this.map((value) => value instanceof constructor ? value : undefined, {
            tag: `selectInstanceOf`,
        });
    }
    identifiedBy(key) {
        return this.dsl.chain(DelegatingValueModel.wrap(this.source, { initialValue: undefined, identifiedBy: key }));
    }
    identifiedWith(func) {
        return this.dsl.chain(DelegatingValueModel.wrap(this.source, { initialValue: undefined, identifiedWith: func }));
    }
    otherwise(otherModelOrValue) {
        const otherModel = this.dsl.chain.wrap(otherModelOrValue);
        return this.map(value => isNil(value) ? otherModel.value : value, {
            allowNil: true,
            dependsOn: otherModel,
            tag: "otherwise"
        });
    }
    substitute(substituteValueOrModel, options) {
        assert.oneOf(options, 'while', 'until');
        const trigger = this.dsl.chain.wrap(options.while) || this.dsl.chain(options.until).isFalsey();
        return this.dsl.switchOn(trigger).toValue(when => {
            when.equalTo(true, substituteValueOrModel);
            when.otherwise(this.source);
        });
    }
    // Pull Methods
    // Pull methods are used to handle cases where the map function returns some kind of observable.  They
    // ensure that subscription and created and disposed whenever teh map function returns a different observable.
    pullMutableValueModel(func) {
        // todo: make this handle the mutable/non mutable case at runtime.
        const model = this.dsl.registerDisposable(new DelegatingValueModel());
        const getDelegateFrom = value => value ? func(value) : null;
        model.setDelegate(getDelegateFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullMutableValueModel");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                const newValue = tx.updateDelegate(getDelegateFrom(sourceTx.committedValue));
                tx.commit(newValue);
            }, model);
        }, model));
        return model;
    }
    pullValueModel(func) {
        // todo: make this handle the mutable/non mutable case at runtime.
        const model = this.dsl.registerDisposable(new DelegatingValueModel());
        const getDelegateFrom = value => value ? func(value) : null;
        model.setDelegate(getDelegateFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullValueModel");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                const newValue = tx.updateDelegate(getDelegateFrom(sourceTx.committedValue));
                tx.commit(newValue);
            }, model);
        }, model));
        return this.dsl.chain(model);
    }
    pullListModel(func) {
        // todo: make this handle the mutable/non mutable case at runtime.
        const model = new DelegatingListModel();
        const getDelegateFrom = value => value ? func(value) : undefined;
        model.setDelegate(getDelegateFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullListModel");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                const newValue = tx.updateDelegate(getDelegateFrom(sourceTx.committedValue));
                tx.commit(newValue);
            }, model);
        }, model));
        return this.dsl.chain(model);
    }
    pullMutableListModel(func) {
        // todo: make this handle the mutable/non mutable case at runtime.
        const model = this.dsl.registerDisposable(new DelegatingListModel());
        const getDelegateFrom = value => value ? func(value) : null;
        model.setDelegate(getDelegateFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullMutableListModel");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                const newValue = tx.updateDelegate(getDelegateFrom(sourceTx.committedValue));
                tx.commit(newValue);
            }, model);
        }, model));
        return model;
    }
    pullObservableValue(func) {
        const getObservableFrom = value => value ? func(value) : null;
        const model = new MutableValueModel();
        const adapter = this.dsl.registerDisposable(new SubscriptionAdapter(model));
        adapter.subscribe(getObservableFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullObservableValue");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                // todo: make a custom transaction as per pullABCModel and hide the publish
                //      ugliness behind that.
                adapter.subscribe(getObservableFrom(sourceTx.committedValue), false);
                tx.commit(adapter.lastPublishedValue);
            }, model);
        }, model));
        return this.dsl.chain(model);
    }
    pullObservableList(func) {
        const getObservableFrom = value => value ? func(value) : null;
        const model = new MutableListModel();
        const adapter = this.dsl.registerDisposable(new SubscriptionAdapter(model));
        adapter.subscribe(getObservableFrom(this.source.value));
        DebugContext.getOrCreate(model).tag("pullObservableList");
        this.dsl.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, tx => {
                // todo: make a custom transaction as per pullABCModel and hide the publish
                //      ugliness behind that.
                adapter.subscribe(getObservableFrom(sourceTx.committedValue), false);
                tx.commit(adapter.lastPublishedValue);
            }, model);
        }, model));
        return this.dsl.chain(model);
    }
}

var ChainDsl;
(function (ChainDsl) {
    function create(dsl) {
        assert.notNil(dsl);
        // @ts-ignore
        const chainDsl = (source) => {
            assert.notNil(source);
            if (source instanceof MapModel) {
                return dsl.getOrCreateProxy(source, MapModelChainMixin, () => new MapModelChainMixin(source, dsl));
            }
            if (source instanceof MultiMapModel) {
                return dsl.getOrCreateProxy(source, MultiMapModelChainMixin, () => new MultiMapModelChainMixin(source, dsl));
            }
            if (source instanceof Stream) {
                return dsl.getOrCreateProxy(source, StreamChainMixin, () => {
                    return new StreamChainMixin(source, dsl);
                });
            }
            if (source instanceof ListModel) {
                return dsl.getOrCreateProxy(source, ListModelChainMixin, () => new ListModelChainMixin(source, dsl));
            }
            if (source instanceof ValueModel) {
                return dsl.getOrCreateProxy(source, ValueModelChainMixin, () => new ValueModelChainMixin(source, dsl));
            }
            lang.illegalState(`Unsupported HasValue type, got ${source.constructor.name}`);
        };
        const staticMethods = new ChainDsl.Static(dsl);
        const proxy = new Proxy(chainDsl, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    ChainDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
            this.numericValue = NumericModelDsl.create(dsl);
            this.stringValue = StringModelDsl.create(dsl);
            this.booleanValue = BooleanModelDsl.create(dsl);
        }
        wrap(source) {
            if (source instanceof ListModel) {
                return this.dsl.chain(source);
            }
            if (source instanceof ValueModel) {
                return this.dsl.chain(source);
            }
            if (Array.isArray(source)) {
                return this.dsl.chain(new MutableListModel(source).readonly); // TODO: no constant for lists yet.
            }
            else {
                return this.dsl.chain(new Constant(source));
            }
        }
        reduce(a, b, c, func) {
            const isTernary = !!func;
            const dependsOnModels = isTernary ? [a, b, c] : [a, b];
            const reducer = (isTernary ? func : c);
            const computedValueModel = ComputedValueModel.fromValue(a, a => {
                const values = dependsOnModels.map(m => m.value);
                return reducer(...values);
            }, { initialValue: [], allowNil: true, dependsOn: dependsOnModels.slice(1) });
            return this.dsl.chain(this.dsl.registerDisposable(computedValueModel));
        }
    }
    ChainDsl.Static = Static;
})(ChainDsl || (ChainDsl = {}));

class ObservableAdapter extends Stream {
    // Don't be tempted to pass an observable in here, cold ones emit values on subcribe before
    // subclass constructors have run.
    constructor() {
        super();
        this._errorStream = new MutableStream();
        this._lastErrorModel = new MutableValueModel();
        this._complete = new MutableValueModel(false);
        this.onDispose(() => {
            this.safelyUnsubscribe();
        });
    }
    errorStream() {
        return this._errorStream.readonly;
    }
    lastError() {
        return this._lastErrorModel.readonly;
    }
    complete() {
        return this._complete.readonly;
    }
    setDelegate(delegate) {
        this.safelyUnsubscribe();
        if (delegate) {
            this._subscription = delegate.subscribe({
                next: value => {
                    this.publish(value);
                    this.updateValue(value);
                },
                error: error => {
                    this._errorStream.publish(error);
                    this._lastErrorModel.value = error;
                },
                complete: () => {
                    this._complete.value = true;
                }
            });
            // we assume the new observable isn't complete, I can't
            // find a way of checking that.  Is it worth checking the delegate is a subject and
            // using delegate.closed?
            this._complete.value = false;
        }
    }
    safelyUnsubscribe() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    }
}
(function (ObservableAdapter) {
    class Value extends ObservableAdapter {
        constructor() {
            super(...arguments);
            this._last = new MutableValueModel();
        }
        updateValue(value) {
            this._last.value = value;
        }
        lastValue() {
            return this._last.readonly;
        }
    }
    ObservableAdapter.Value = Value;
    class List extends ObservableAdapter {
        constructor() {
            super(...arguments);
            this._last = new MutableListModel();
        }
        updateValue(value) {
            this._last.value = value;
        }
        lastValue() {
            return this._last.readonly;
        }
    }
    ObservableAdapter.List = List;
})(ObservableAdapter || (ObservableAdapter = {}));

class ObservableAdapterChainMixin extends StreamChainMixinBase {
    constructor(source, dsl) {
        super(source, dsl);
        this.source = source;
    }
    errorStream() {
        return this.dsl.chain(this.source.errorStream());
    }
    lastError() {
        return this.dsl.chain(this.source.lastError());
    }
    complete() {
        return this.dsl.chain(this.source.complete());
    }
    onError(callback) {
        this.errorStream().subscribe(callback);
    }
    onComplete(callback) {
        this.dsl.when.valueOf(this.complete()).becomesTruthy(callback);
    }
}
(function (ObservableAdapterChainMixin) {
    class Value extends ObservableAdapterChainMixin {
        constructor(source, dsl) {
            super(source, dsl);
            this.source = source;
            this.dsl = dsl;
        }
        last() {
            return this.dsl.chain(this.source.lastValue());
        }
        ;
    }
    ObservableAdapterChainMixin.Value = Value;
    class List extends ObservableAdapterChainMixin {
        constructor(source, dsl) {
            super(source, dsl);
            this.source = source;
            this.dsl = dsl;
        }
        last() {
            return this.dsl.chain(this.source.lastValue());
        }
        ;
    }
    ObservableAdapterChainMixin.List = List;
})(ObservableAdapterChainMixin || (ObservableAdapterChainMixin = {}));

class ObservableDsl {
    constructor(dsl) {
        this.dsl = dsl;
    }
    static create(dsl) {
        assert.notNil(dsl);
        return new ObservableDsl(dsl);
    }
    valuesFrom(source) {
        const adapter = this.dsl.getOrCreateAdapter(source, ObservableAdapter.Value, (src) => {
            const value = new ObservableAdapter.Value();
            value.setDelegate(src);
            return value;
        });
        return this.dsl.getOrCreateProxy(adapter, ObservableAdapterChainMixin.Value, () => {
            return new ObservableAdapterChainMixin.Value(adapter, this.dsl);
        });
    }
    listsFrom(source) {
        const adapter = this.dsl.getOrCreateAdapter(source, ObservableAdapter.List, (src) => {
            const list = new ObservableAdapter.List();
            list.setDelegate(src);
            return list;
        });
        return this.dsl.getOrCreateProxy(adapter, ObservableAdapterChainMixin.List, () => {
            return new ObservableAdapterChainMixin.List(adapter, this.dsl);
        });
    }
}

var SwitchCaseBuilder;
(function (SwitchCaseBuilder) {
    class Base extends GarbageCollector {
        constructor(trackSource, triggerModel, wrapResult) {
            super();
            this.trackSource = trackSource;
            this.triggerModel = triggerModel;
            this.wrapResult = wrapResult;
            this._whenModels = [];
        }
        matches(predicate, use, options) {
            this.trackDependencies(options);
            const useValueModel = this.wrapResult(use);
            this.trackSource(useValueModel);
            this._whenModels.push({ predicate, model: useValueModel });
        }
        equalTo(compareTo, use) {
            const compareToModel = compareTo instanceof ValueModel ? compareTo : new MutableValueModel(compareTo).readonly;
            this.matches(v => this.triggerModel.identityOf(v) === this.triggerModel.identityOf(compareToModel.value), use, { dependsOn: compareToModel });
        }
        otherwise(use) {
            this._otherwiseModel = this.wrapResult(use);
            this.trackSource(this._otherwiseModel);
        }
        evaluate() {
            const matching = this._whenModels.find(item => item.predicate(this.triggerModel.value));
            const newModel = matching ? matching.model : this._otherwiseModel;
            return newModel.value;
        }
        validateAndInitialize() {
            assert.notNil(this._otherwiseModel, "you must call builder.otherwise(...) and pass it a value or model");
        }
        trackDependencies(options) {
            DependsOnOptions.extract(options).forEach(d => this.trackSource(d));
        }
    }
    SwitchCaseBuilder.Base = Base;
})(SwitchCaseBuilder || (SwitchCaseBuilder = {}));

class SwitchCaseListModel extends AbstractComputedListModel {
    constructor(trigger, builder, globalDependsOn) {
        super({ initialValue: [], ...globalDependsOn });
        this.trackSource(trigger);
        const trackSource = (source) => this.trackSource(source);
        this.builderImpl = this.registerDisposable(new SwitchCaseBuilder.Base(trackSource, trigger, result => {
            return (result instanceof ListModel ? result : new MutableListModel(result).readonly); // what the ??
        }));
        builder(this.builderImpl);
        this.builderImpl.validateAndInitialize();
    }
    doComputeValue() {
        return this.builderImpl.evaluate();
    }
}

class SwitchCaseValueModel extends AbstractComputedValueModel {
    constructor(trigger, builder, globalDependsOn) {
        super({ initialValue: undefined, ...globalDependsOn });
        this.trackSource(trigger);
        const trackSource = (source) => this.trackSource(source);
        this.builderImpl = this.registerDisposable(new SwitchCaseBuilder.Base(trackSource, trigger, result => {
            return (result instanceof ValueModel) ? result : new MutableValueModel(result).readonly;
        }));
        builder(this.builderImpl);
        this.builderImpl.validateAndInitialize();
    }
    doComputeValue() {
        return this.builderImpl.evaluate();
    }
}

var SwitchDsl;
(function (SwitchDsl) {
    function create(dsl) {
        assert.notNil(dsl);
        return (valueModel) => {
            return {
                toValue(builder, options) {
                    const model = new SwitchCaseValueModel(valueModel, builder, options);
                    return dsl.chain(dsl.registerDisposable(model));
                },
                toList(builder, options) {
                    const model = new SwitchCaseListModel(valueModel, builder, options);
                    dsl.registerDisposable(model);
                    return dsl.chain(model);
                }
            };
        };
    }
    SwitchDsl.create = create;
})(SwitchDsl || (SwitchDsl = {}));

class ChangeMonitor {
    constructor(predicate, trigger, userCallback) {
        this.predicate = predicate;
        this.trigger = trigger;
        this.userCallback = userCallback;
        assert.isFunction(predicate);
        assert.isFunction(trigger);
        assert.isFunction(userCallback);
    }
    handleValueChange(value, oldValue) {
        try {
            if (this.predicatePassed(value, oldValue) && this.triggered(value, oldValue)) {
                Logger.get(this).runWithDebug("handleValueChange", () => this.userCallback(value, oldValue));
                if (this.singleShotSubscription) {
                    this.singleShotSubscription.dispose();
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        // don't try the trigger until the predicate has passed.
    }
    triggered(value, oldValue) {
        return !this.trigger || this.trigger(value, oldValue);
    }
    predicatePassed(value, oldValue) {
        return !this.predicate || this.predicate(value, oldValue);
    }
    setSingleShot(subscription) {
        this.singleShotSubscription = subscription;
    }
}

class TransitionBuilder {
    constructor(dsl, installChangeHandler) {
        this.dsl = dsl;
        this.installChangeHandler = installChangeHandler;
    }
    createMatcher(predicate, options) {
        const self = this;
        return {
            execute(callback) {
                self.createChangeMonitor(predicate, options || {}, callback);
            }
        };
    }
    createChangeMonitor(trigger, options, userCallback) {
        const source = this.prepareGatedSource(options);
        const monitor = new ChangeMonitor(this.extractValueChangePredicate(options), trigger, userCallback);
        const subscription = this.installChangeHandler(source, monitor);
        this.registerAndInitialiseHandler(options, monitor, subscription, source);
    }
    extractValueChangePredicate(options) {
        return assert.oneOrNoneOf(options, "unless", "asLongAs", () => {
            return options.asLongAs ?
                this.asValueChangePredicate(options.asLongAs) :
                this.asValueChangePredicate(options.unless, true);
        }, () => true);
    }
    asValueChangePredicate(predicateOrValueModel, negate = false) {
        const predicate = isFunction$1(predicateOrValueModel)
            ? predicateOrValueModel
            : (value, oldValue) => predicateOrValueModel['value'];
        return negate ? (value, oldValue) => !predicate(value, oldValue) : predicate;
    }
    extractPredicate(options) {
        return assert.oneOrNoneOf(options, "unless", "asLongAs", () => {
            return options.asLongAs ?
                this.asPredicate(options.asLongAs) :
                this.asPredicate(options.unless, true);
        }, () => true);
    }
    asPredicate(predicateOrValueModel, negate = false) {
        const predicate = isFunction$1(predicateOrValueModel) ? predicateOrValueModel : () => predicateOrValueModel['value'];
        return negate ? () => !predicate() : predicate;
    }
    registerAndInitialiseHandler(options, monitor, subscription, evaluateNowSource) {
        this.dsl.registerDisposable(subscription);
        this.configureSingleShot(options, monitor, subscription);
        if (evaluateNowSource) {
            this.evaluateNowIfRequested(options, evaluateNowSource, monitor);
        }
    }
    configureSingleShot(options, monitor, subscription) {
        if (options) {
            if (options.once) {
                monitor.setSingleShot(subscription);
            }
        }
    }
    evaluateNowIfRequested(options, source, monitor) {
        if (options) {
            const opts = OptionsHelper.for(options);
            const initialValue = TransitionBuilder.InitialValueConfig.getAction(options?.initialValue);
            const alwaysEvaluate = (initialValue === "evaluate");
            const evaluateUnlessNil = (initialValue === "evaluateUnlessNil");
            const initialPreviousValue = opts.get("usePreviousValueOnInitOf", null);
            // console.log("evaluateNowIfRequested", {options, initialPreviousValue})
            if (alwaysEvaluate || (evaluateUnlessNil && !this.isNilishInitialValue(source.value))) {
                monitor.handleValueChange(source.value, initialPreviousValue);
            }
        }
    }
    isNilishInitialValue(value) {
        return isNil(value);
    }
}
(function (TransitionBuilder) {
    class InitialValueConfig {
        constructor() {
            this.ignore = 'ignore';
            this.evaluate = 'evaluate';
            this.triggerChange = 'evaluate';
            this.evaluateUnlessNil = 'evaluateUnlessNil';
            this.triggerChangeUnlessNil = 'evaluateUnlessNil';
        }
        static instance() {
            if (!this['__instance']) {
                this['__instance'] = new InitialValueConfig();
            }
            return this['__instance'];
        }
        static getAction(key) {
            return this.instance()[key] || 'ignore';
        }
    }
    TransitionBuilder.InitialValueConfig = InitialValueConfig;
})(TransitionBuilder || (TransitionBuilder = {}));

class AnyTransitionBuilder extends TransitionBuilder {
    constructor(dsl, sources, installChangeHandler) {
        // create a dummy source that'll we'll update  when ever a source changes
        super(dsl, (gatedSource, monitor) => {
            this.garbage.registerDisposable(installChangeHandler(gatedSource, monitor));
            return this.garbage;
        });
        this.sources = sources;
        this.dummySource = new MutableValueModel();
        this.garbage = new GarbageCollector();
        this.sources.forEach(source => {
            // manually trigger a change to our model when ever a source changes.
            this.garbage.registerDisposable(source.onValueChange(() => {
                // hack, we know our source is a mutable value model
                return this.dummySource.value = {};
            }));
        });
    }
    prepareGatedSource(options) {
        return assert.oneOrNoneOf(options, "postponeUntil", "postponeWhile", () => {
            return new IdentityValueModel(this.dummySource, options);
        }, this.dummySource);
    }
    changes(callback, options) {
        this.createChangeMonitor(() => true, options || {}, callback);
    }
}

const EVALUATE_NOW_PREVIOUS_VALUE = [];
class ListTransitionBuilder extends TransitionBuilder {
    constructor(dsl, source, installChangeHandler) {
        super(dsl, installChangeHandler);
        this.source = source;
    }
    prepareGatedSource(options) {
        return assert.oneOrNoneOf(options, "postponeUntil", "postponeWhile", () => {
            return new IdentityListModel(this.source, options);
        }, this.source);
    }
    registerAndInitialiseHandler(options, monitor, subscription, evaluateNowSource) {
        super.registerAndInitialiseHandler({
            ...options,
            usePreviousValueOnInitOf: EVALUATE_NOW_PREVIOUS_VALUE
        }, monitor, subscription, evaluateNowSource);
    }
    // protected createMatcher(predicate: (newValue: S[], oldValue: S[]) => boolean,
    //                         options?: TransitionBuilder.InitialValueOptions<S[]> & TransitionBuilder.ConditionalExecutionOptions<S[]>) {
    //     const self = this;
    //     return {
    //         execute(callback: (newValue?: S[], oldValue?: S[]) => void): void {
    //             self.createChangeMonitor(predicate, options || {}, callback);
    //         }
    //     }
    // }
    changes(userCallback, options) {
        this.createMatcher(() => true, options).execute(userCallback);
    }
}
(function (ListTransitionBuilder) {
    function isEvaluateNowValue(value) {
        return value === EVALUATE_NOW_PREVIOUS_VALUE;
    }
    ListTransitionBuilder.isEvaluateNowValue = isEvaluateNowValue;
})(ListTransitionBuilder || (ListTransitionBuilder = {}));

/**
 * A small utilitiy class that stores the computed difference so hasItemsAdded/Removed
 * can access it when invoking the callback.  Otherwise the difference would have to be
 * computed twice.
 */
class AddRemoveMatcher {
    constructor(identifiedBy) {
        this.identifiedBy = identifiedBy;
        this._difference = [];
    }
    itemsHaveBeenAdded(newValue, oldValue) {
        this._difference = differenceBy(newValue, oldValue, this.identifiedBy);
        return this._difference.length > 0;
    }
    itemsHaveBeenRemoved(newValue, oldValue) {
        this._difference = differenceBy(oldValue, newValue, this.identifiedBy);
        return this._difference.length > 0;
    }
    get difference() {
        return this._difference;
    }
}
class ListChangeTransitionBuilder extends ListTransitionBuilder {
    matches(predicate, options) {
        return this.createMatcher(predicate, options);
    }
    becomesEmpty(f, options) {
        return this.createMatcher((newValue, oldValue) => {
            // First time we evaluate the old value will be nil.
            return newValue.length == 0 && (ListTransitionBuilder.isEvaluateNowValue(oldValue) || oldValue.length > 0);
        }, options).execute(f);
    }
    becomesPopulated(f, options) {
        const predicate = (newValue, oldValue) => newValue.length > 0 && (ListTransitionBuilder.isEvaluateNowValue(oldValue) || oldValue.length == 0);
        return this.createMatcher(predicate, options).execute(f);
    }
    /**
     * Invoked whenever a new items have been added to the list.  This uses the identify function of the underlying list
     * and only fires when the entity is seen for the first time and not when it has been mutated.
     * @param callback
     * @param options
     */
    hasItemsAdded(callback, options) {
        const matchHelper = new AddRemoveMatcher(this.source.identityOf);
        return this.createMatcher((newValue, oldValue) => {
            return matchHelper.itemsHaveBeenAdded(newValue, oldValue);
        }, options).execute(() => callback(matchHelper.difference));
    }
    /**
     * Invoked whenever items have been removed from the list.  This uses the identify function of the underlying list
     * and only fires when the entity is removed and not if the entity has been mutated.
     * @param callback
     * @param options
     */
    hasItemsRemoved(callback, options) {
        const matchHelper = new AddRemoveMatcher(this.source.identityOf);
        return this.createMatcher((newValue, oldValue) => {
            return matchHelper.itemsHaveBeenRemoved(newValue, oldValue);
        }, options).execute(() => callback(matchHelper.difference));
    }
}

class ValueTransitionBuilder extends TransitionBuilder {
    constructor(dsl, source, installChangeHandler) {
        super(dsl, installChangeHandler);
        this.source = source;
    }
    prepareGatedSource(options) {
        return assert.oneOrNoneOf(options, "postponeUntil", "postponeWhile", () => {
            return new IdentityValueModel(this.source, options);
        }, this.source);
    }
    /**
     * Called when ever the value of this model changes.
     *
     * @param valueChangeCallback the callback to invoke when the model changes.
     * @param options the options.
     */
    changes(valueChangeCallback, options) {
        this.createMatcher(() => true, options).execute(valueChangeCallback);
    }
}

class ValueChangeTransitionBuilder extends ValueTransitionBuilder {
    matches(predicate, options) {
        return this.createMatcher(predicate, options);
    }
    becomesTruthy(f, options) {
        return this.createMatcher((newValue, oldValue) => !!newValue && !oldValue, options).execute(f);
    }
    becomesFalsey(f, options) {
        const predicate = (newValue, oldValue) => !newValue && !!oldValue;
        const allOptions = { ...options, usePreviousValueOnInitOf: true }; // this allows our predicate to fire if the initial value is falsey.
        return this.createMatcher(predicate, allOptions).execute(f);
    }
    changesTo(desiredValue, options) {
        return this.createMatcher((newValue, oldValue) => isEqual(newValue, desiredValue) && !isEqual(oldValue, desiredValue), options);
    }
    changesToAnyOf(...desiredValues) {
        return this.createMatcher((newValue, oldValue) => {
            return includes(desiredValues, newValue) && !includes(desiredValues, oldValue);
        });
    }
    changesFrom(previousValue, options) {
        const me = this;
        return {
            to(desiredValue) {
                return me.createMatcher((newValue, oldValue) => {
                    return isEqual(oldValue, previousValue) && isEqual(newValue, desiredValue);
                }, options);
            },
            execute(func) {
                return me.createMatcher((newValue, oldValue) => isEqual(oldValue, previousValue) && !isEqual(newValue, previousValue), options).execute(func);
            }
        };
    }
    changesFromAnyOf(...oldValues) {
        const me = this;
        return {
            to(desiredValue) {
                return me.createMatcher((newValue, oldValue) => {
                    return includes(oldValues, oldValue) && isEqual(newValue, desiredValue);
                });
            },
            execute(func) {
                return me.createMatcher((newValue, oldValue) => includes(oldValues, oldValue) && !includes(oldValues, newValue)).execute(func);
            }
        };
    }
}

const afterSourceChangeListener = (gatedSource, monitor) => {
    return gatedSource.onTransactionStart((tx) => {
        tx.afterRootTransactionFinalised(() => {
            if (tx.hasChanged()) {
                monitor.handleValueChange(tx.committedValue, tx.initialValue);
            }
        });
    }, monitor);
};
class AfterListChangeTransitionBuilder extends ListChangeTransitionBuilder {
    constructor(dsl, source) {
        super(dsl, source, afterSourceChangeListener);
    }
}
class AfterValueChangeTransitionBuilder extends ValueChangeTransitionBuilder {
    constructor(dsl, source) {
        super(dsl, source, afterSourceChangeListener);
    }
}
var AfterDsl;
(function (AfterDsl) {
    function create(dsl) {
        assert.notNil(dsl);
        const afterDsl = (source) => {
            assert.notNil(source);
            if (source instanceof ListModel) {
                return dsl.getOrCreateAdapter(source, AfterListChangeTransitionBuilder, () => {
                    return new AfterListChangeTransitionBuilder(dsl, source);
                });
            }
            if (source instanceof ValueModel) {
                return dsl.getOrCreateAdapter(source, AfterValueChangeTransitionBuilder, () => {
                    return new AfterValueChangeTransitionBuilder(dsl, source);
                });
            }
            return lang.illegalState(`Unsupported HasValue type, got ${source.constructor.name}`);
        };
        const staticMethods = new AfterDsl.Static(dsl);
        const proxy = new Proxy(afterDsl, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    AfterDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
        /**
         * @deprecated use when(valueModel) instead.
         * @param source
         */
        valueOf(source) {
            return this.dsl.after(source);
        }
        /**
         * @deprecated use when(listModel) instead.
         * @param source
         */
        listOf(source) {
            return this.dsl.after(source);
        }
        anyOf(...sources) {
            return new AnyTransitionBuilder(this.dsl, sources, afterSourceChangeListener);
        }
    }
    AfterDsl.Static = Static;
})(AfterDsl || (AfterDsl = {}));

var BeforeDsl;
(function (BeforeDsl) {
    const beforeSourceChanges = (gatedSource, monitor) => {
        return gatedSource.onTransactionStart((tx) => {
            monitor.handleValueChange(tx.initialValue, tx.initialValue);
        });
    };
    function create(dsl) {
        assert.notNil(dsl);
        const beforeDsl = (source) => {
            assert.notNil(source);
            if (source instanceof ListModel) {
                return dsl.getOrCreateAdapter(source, ListChangeTransitionBuilder, () => {
                    return new ListTransitionBuilder(dsl, source, beforeSourceChanges);
                });
            }
            if (source instanceof ValueModel) {
                return dsl.getOrCreateAdapter(source, ValueTransitionBuilder, () => {
                    return new ValueTransitionBuilder(dsl, source, beforeSourceChanges);
                });
            }
            return lang.illegalState(`Unsupported HasValue type, got ${source.constructor.name}`);
        };
        const staticMethods = new BeforeDsl.Static(dsl);
        const proxy = new Proxy(beforeDsl, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    BeforeDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
        /**
         * @deprecated use when(valueModel) instead.
         * @param source
         */
        valueOf(source) {
            return this.dsl.before(source);
        }
        /**
         * @deprecated use when(listModel) instead.
         * @param source
         */
        listOf(source) {
            return this.dsl.before(source);
        }
        anyOf(...sources) {
            return new AnyTransitionBuilder(this.dsl, sources, beforeSourceChanges);
        }
    }
    BeforeDsl.Static = Static;
})(BeforeDsl || (BeforeDsl = {}));

const whenSourceChanges = (gatedSource, monitor) => {
    return gatedSource.onTransactionStart((tx) => {
        tx.onRootTransactionFinalised(() => {
            if (tx.hasChanged()) {
                monitor.handleValueChange(tx.committedValue, tx.initialValue);
            }
        });
    }, monitor);
};
class WhenListChangeTransitionBuilder extends ListChangeTransitionBuilder {
    constructor(dsl, source) {
        super(dsl, source, whenSourceChanges);
    }
}
class WhenValueChangeTransitionBuilder extends ValueChangeTransitionBuilder {
    constructor(dsl, source) {
        super(dsl, source, whenSourceChanges);
    }
}
var WhenDsl;
(function (WhenDsl) {
    function create(dsl) {
        assert.notNil(dsl);
        const whenDsl = (source) => {
            assert.notNil(source);
            if (source instanceof ListModel) {
                return dsl.getOrCreateAdapter(source, WhenListChangeTransitionBuilder, () => {
                    return new WhenListChangeTransitionBuilder(dsl, source);
                });
            }
            if (source instanceof ValueModel) {
                return dsl.getOrCreateAdapter(source, WhenValueChangeTransitionBuilder, () => {
                    return new WhenValueChangeTransitionBuilder(dsl, source);
                });
            }
            return lang.illegalState(`Unsupported HasValue type, got ${source.constructor.name}`);
        };
        const staticMethods = new WhenDsl.Static(dsl);
        const proxy = new Proxy(whenDsl, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    WhenDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
        /**
         * @deprecated use when(valueModel) instead.
         * @param source
         */
        valueOf(source) {
            return this.dsl.when(source);
        }
        /**
         * @deprecated use when(listModel) instead.
         * @param source
         */
        listOf(source) {
            return this.dsl.when(source);
        }
        anyOf(...sources) {
            return new AnyTransitionBuilder(this.dsl, sources, whenSourceChanges);
        }
    }
    WhenDsl.Static = Static;
})(WhenDsl || (WhenDsl = {}));

class ValueOfDsl {
    constructor(dsl) {
        this.dsl = dsl;
    }
    all(...models) {
        const self = this;
        return {
            areTruthy() {
                const model = self.dsl.registerDisposable(new AndValueModel.Truthy(models));
                return self.dsl.chain.booleanValue(model);
            },
            areFalsey() {
                const model = self.dsl.registerDisposable(new OrValueModel.Truthy(models));
                return self.dsl.chain.booleanValue(model).isFalsey();
            }
        };
    }
    any(...models) {
        const self = this;
        return {
            areTruthy() {
                const model = self.dsl.registerDisposable(new OrValueModel.Truthy(models));
                return self.dsl.chain.booleanValue(model);
            },
            areFalsey() {
                const model = self.dsl.registerDisposable(new AndValueModel.Truthy(models));
                return self.dsl.chain.booleanValue(model).isFalsey();
            }
        };
    }
}

const DSL_REGISTRATIONS_KEY = Symbol.for('pectin:dsl:scope');
const nullGC = {
    registerDisposable(thing) {
        return thing;
    },
    dispose() {
    }
};
class Dsl extends GarbageCollector {
    constructor(gc) {
        super();
        this.gc = gc;
        gc.registerDisposable(this);
        this.proxies = this.registerDisposable(new ProxyRegistry(DebugContext.getOrCreate(gc)));
        this.adapters = this.registerDisposable(new AdapterRegistry(DebugContext.getOrCreate(gc)));
        this.chain = ChainDsl.create(this);
        this.switchOn = SwitchDsl.create(this);
        this.observe = ObservableDsl.create(this);
        this.valueOf = new ValueOfDsl(this);
        this.before = BeforeDsl.create(this);
        this.when = WhenDsl.create(this);
        this.after = AfterDsl.create(this);
    }
    getOrCreateProxy(source, mixinType, factory) {
        return this.proxies.getOrCreateProxy(source, mixinType, factory);
    }
    getOrCreateAdapter(source, mixinType, factory) {
        return this.adapters.getOrCreateAdapter(source, mixinType, factory);
    }
}
const dslPropertyKey = Symbol.for('pectin:dsl:Dsl');
(function (Dsl) {
    Dsl.withoutGC = new Dsl(nullGC);
    function disposeWith(garbage) {
        if (!garbage[dslPropertyKey]) {
            garbage[dslPropertyKey] = new Dsl(garbage);
        }
        return garbage[dslPropertyKey];
    }
    Dsl.disposeWith = disposeWith;
})(Dsl || (Dsl = {}));

class CaseWhenListModel extends AbstractComputedListModel {
    constructor(options) {
        super(options);
        this._defaultModel = new DelegatingListModel();
        this._alternates = [];
        this.garbage = new GarbageCollector();
        this.dependsOn(this._defaultModel);
    }
    setDefault(valueOrValueModel) {
        this._defaultModel.setDefault(valueOrValueModel);
        return this;
    }
    when(trigger) {
        const self = this;
        const { chain } = Dsl.disposeWith(this.garbage);
        return {
            use(listOrModel) {
                const model = chain.wrap(listOrModel);
                self.dependsOn(model);
                self.dependsOn(trigger);
                self._alternates.push({ triggerModel: trigger, model: model });
            }
        };
    }
    doComputeValue() {
        let value = this._defaultModel.value;
        for (let alternate of this._alternates) {
            if (alternate.triggerModel.value) {
                value = alternate.model.value;
                break;
            }
        }
        return value;
    }
}

var StreamDsl;
(function (StreamDsl) {
    StreamDsl.PROXY_PROPERTY_KEY = Symbol('pectin:dsl:streamChainProxy');
    function create(dsl) {
        assert.notNil(dsl);
        const stream = (source) => {
            assert.notNil(source);
            return dsl.getOrCreateProxy(source, StreamChainMixin, () => {
                return new StreamChainMixin(source, dsl);
            });
        };
        const staticMethods = new StreamDsl.Static(dsl);
        const proxy = new Proxy(stream, {
            get: function (target, prop) {
                return staticMethods[prop];
            }
        });
        return proxy;
    }
    StreamDsl.create = create;
    class Static {
        constructor(dsl) {
            this.dsl = dsl;
        }
        changesFrom(hasValue) {
            const stream = this.dsl.registerDisposable(new MutableStream());
            this.dsl.registerDisposable(hasValue.onValueChange((value, previousValue) => {
                stream.publish({ value, previous: previousValue });
            }));
            return this.dsl.chain(stream.readonly);
        }
    }
    StreamDsl.Static = Static;
})(StreamDsl || (StreamDsl = {}));

/**
 * @file Automatically generated by barrelsby.
 */

var Interceptor;
(function (Interceptor) {
    class Chain {
        constructor() {
            this.interceptors = [];
        }
        add(interceptor) {
            if (this.interceptors.includes(interceptor)) {
                lang.illegalArgument('interceptor already added');
            }
            this.interceptors.push(interceptor);
            return Disposable.disposableThatRuns(() => {
                this.interceptors = this.interceptors.filter(i => i !== interceptor);
            });
        }
        async runInterceptors() {
            if (this.interceptors.length > 0) {
                for (let interceptor of this.interceptors) {
                    const result = await interceptor();
                    if (typeof result === 'boolean' && !result) {
                        throw Error('Interceptor canceled');
                    }
                }
            }
            return true;
        }
    }
    Interceptor.Chain = Chain;
})(Interceptor || (Interceptor = {}));

class AbstractCommand extends GarbageCollector {
    constructor(options) {
        super();
        this.interceptors = new Interceptor.Chain();
        this._userEnabledModel = this.registerDisposable(new DelegatingValueModel().withDefault(true));
        this._busyModel = new MutableValueModel(false);
        const opts = OptionsHelper.for(options);
        opts.withOneOrNoneOf("enableWhile", "disableWhile", (options) => {
            if (options.enableWhile) {
                this.enableWhile(options.enableWhile);
            }
            else if (options.disableWhile) {
                this.disableWhile(options.disableWhile);
            }
        });
        opts.withOptional("intercept", (intercept) => {
            Array.isArray(intercept) ?
                intercept.forEach(i => this.addInterceptor(i)) :
                this.addInterceptor(intercept);
        });
        const disableWhileBusy = opts.get("disableWhileBusy", true);
        if (disableWhileBusy) {
            this._enabledModel = ComputedValueModel.fromValue(this._busyModel, busy => {
                return !busy && !!this._userEnabledModel.value;
            }, { initialValue: true, dependsOn: [this._userEnabledModel] });
        }
        else {
            this._enabledModel = this._userEnabledModel;
        }
        DebugContext.getOrCreate(this._userEnabledModel).tag("Command.enableWhile");
        DebugContext.getOrCreate(this._enabledModel).tag("Command.enabled");
        DebugContext.getOrCreate(this._busyModel).tag("Command.busy");
    }
    async runExecutor(executor, context) {
        if (!this.enabled$.value) {
            throw new Error('command is disabled');
        }
        else {
            try {
                await this.interceptors.runInterceptors();
                this._busyModel.value = true;
                this._context = context;
                Pectin.get()._notifyCommandStart(this);
                return await executor();
            }
            finally {
                this._busyModel.value = false;
                this._context = undefined;
                Pectin.get()._notifyCommandFinished(this);
            }
        }
    }
    get busy$() {
        return this._busyModel.readonly;
    }
    /**
     * @deprecated use #busy$ instead
     */
    get busy() {
        return this.busy$;
    }
    get enabled$() {
        return this._enabledModel.readonly;
    }
    /**
     * @deprecated use #enabled$ instead
     */
    get enabled() {
        return this.enabled$;
    }
    get context() {
        return this._context;
    }
    enableWhile(valueModel) {
        this._userEnabledModel.setDelegate(valueModel);
        return this;
    }
    disableWhile(valueModel) {
        const notDisabled = MappedValueModel.create(valueModel, v => !v);
        DebugContext.getOrCreate(notDisabled).tag("Command.disableWhile");
        this.enableWhile(notDisabled);
        return this;
    }
    addInterceptor(interceptor) {
        return this.interceptors.add(interceptor);
    }
}

class Command extends AbstractCommand {
    constructor(options) {
        super(options);
    }
    withContext(context) {
        const self = this;
        return {
            execute() {
                return self.runExecutor(() => self.onExecute(), context);
            }
        };
    }
    execute() {
        return this.runExecutor(() => this.onExecute());
    }
    onExecute() {
        return lang.abstractMethod(this.constructor);
    }
    enableWhile(valueModel) {
        return super.enableWhile(valueModel);
    }
    disableWhile(valueModel) {
        return super.disableWhile(valueModel);
    }
}
(function (Command) {
    class Factory {
        constructor(action, options) {
            this.action = action;
            this.options = options;
        }
        create(item, options) {
            return options.disposedWith.registerDisposable(Command.create((context) => this.action(item, context), this.options));
        }
    }
    Command.Factory = Factory;
    class CommandImpl extends Command {
        constructor(executor, options) {
            super(options);
            this.executor = executor;
        }
        onExecute() {
            return this.executor(this.context);
        }
    }
    function create(executor, options) {
        return new CommandImpl(executor, options);
    }
    Command.create = create;
    function createFactory(executor, options) {
        return new Factory(executor, options);
    }
    Command.createFactory = createFactory;
})(Command || (Command = {}));

class DelegatingCommand extends Command {
    constructor(delegate = undefined) {
        super();
        this._busy = this.registerDisposable(new DelegatingValueModel().withDefault(false));
        this.setDelegate(delegate);
        this.onDispose(() => this.setDelegate(undefined));
    }
    static hasDelegate(command) {
        if (command instanceof DelegatingCommand) {
            // go down the rabbit hole...
            return command.hasDelegate() ? this.hasDelegate(command.getDelegate()) : false;
        }
        else {
            return !!command; // it's a regular command
        }
    }
    setDelegate(delegate) {
        this._delegate = delegate;
        this.enableWhile(delegate ? delegate.enabled$ : ValueModel.FALSE);
        this._busy.setDelegate(delegate ? delegate.busy$ : undefined);
    }
    getDelegate() {
        return this._delegate;
    }
    hasDelegate() {
        return !!this._delegate;
    }
    onExecute() {
        assert.notNil(this._delegate); // the command will be disabled if the delegate is nil.
        return this._delegate.withContext(this.context).execute();
    }
    get busy() {
        return this._busy.readonly;
    }
}

class UnaryCommand extends AbstractCommand {
    constructor(options) {
        super(options);
    }
    withContext(context) {
        const self = this;
        return {
            execute(param) {
                return self.runExecutor(() => self.onExecute(param), context);
            }
        };
    }
    execute(param) {
        return this.runExecutor(() => this.onExecute(param));
    }
    onExecute(param) {
        return lang.abstractMethod(this.constructor);
    }
    enableWhile(valueModel) {
        return super.enableWhile(valueModel);
    }
    disableWhile(valueModel) {
        return super.disableWhile(valueModel);
    }
}
(function (UnaryCommand) {
    function create(executor, options) {
        return new class extends UnaryCommand {
            onExecute(param) {
                return executor(param, this.context);
            }
        }(options);
    }
    UnaryCommand.create = create;
})(UnaryCommand || (UnaryCommand = {}));

class DelegatingUnaryCommand extends UnaryCommand {
    constructor(delegate = undefined) {
        super();
        this._busy = this.registerDisposable(new DelegatingValueModel().withDefault(false));
        this.setDelegate(delegate);
        this.onDispose(() => this.setDelegate(undefined));
    }
    setDelegate(delegate) {
        this._delegate = delegate;
        this.enableWhile(delegate ? delegate.enabled$ : ValueModel.FALSE);
        this._busy.setDelegate(delegate ? delegate.busy$ : undefined);
    }
    getDelegate() {
        return this._delegate;
    }
    hasDelegate() {
        return !!this._delegate;
    }
    onExecute(param) {
        assert.notNil(this._delegate); // commands with no delegate are disabled.
        return this._delegate.withContext(this.context).execute(param);
    }
    get busy() {
        return this._busy.readonly;
    }
}

/**
 * @file Automatically generated by barrelsby.
 */

var DelegatingMultipleSelectionModel;
(function (DelegatingMultipleSelectionModel) {
    function createDelegate() {
        return DelegateProxyHandler.create("MultipleSelectionModel", delegate => {
            delegate.forProperty("sourceList$", () => new DelegatingListModel());
            delegate.forProperty("leadSelection", () => new DelegatingValueModel());
            delegate.forProperty("leadSelection$", () => new DelegatingValueModel());
            delegate.forProperty("selectedItems", () => new DelegatingListModel());
            delegate.forProperty("selectedItems$", () => new DelegatingListModel());
            delegate.forProperty("count$", () => new DelegatingValueModel());
            delegate.forProperty("empty$", () => new DelegatingValueModel());
            delegate.forProperty("enabled$", () => new DelegatingValueModel());
            delegate.forProperty("selectedItemCount$", () => new DelegatingValueModel());
            delegate.forProperty("totalItemCount$", () => new DelegatingValueModel());
            delegate.forProperty("allSelected$", () => new DelegatingValueModel());
            delegate.forProperty("noneSelected$", () => new DelegatingValueModel());
            delegate.forProperty("someSelected$", () => new DelegatingValueModel());
            delegate.forProperty("selectCommand", () => new DelegatingUnaryCommand());
            delegate.forProperty("clearCommand", () => new DelegatingCommand());
            delegate.forProperty("toggleAllCommand", () => new DelegatingCommand());
            delegate.forFunction("clear");
            delegate.forFunction("add");
            delegate.forFunction("remove");
            delegate.forFunction("select");
            delegate.forFunction("selectAll");
            delegate.forFunction("isSelected");
            delegate.forFunction("enableWhile");
            delegate.forFunction("disableWhile");
        });
    }
    DelegatingMultipleSelectionModel.createDelegate = createDelegate;
})(DelegatingMultipleSelectionModel || (DelegatingMultipleSelectionModel = {}));

var DelegatingSelectionModel;
(function (DelegatingSelectionModel) {
    function createDelegate() {
        return DelegatingMultipleSelectionModel.createDelegate();
    }
    DelegatingSelectionModel.createDelegate = createDelegate;
})(DelegatingSelectionModel || (DelegatingSelectionModel = {}));

var DelegatingSingleSelectionModel;
(function (DelegatingSingleSelectionModel) {
    function createDelegate() {
        return DelegateProxyHandler.create("SingleSelectionModel", delegate => {
            delegate.forProperty("source$", () => new DelegatingListModel());
            delegate.forProperty("sourceList", () => new DelegatingListModel());
            delegate.forProperty("selectedId$", () => new DelegatingValueModel());
            delegate.forProperty("selectedIdModel", () => new DelegatingValueModel());
            delegate.forProperty("leadSelection$", () => new DelegatingValueModel());
            delegate.forProperty("leadSelection", () => new DelegatingValueModel());
            delegate.forProperty("enabled$", () => new DelegatingValueModel());
            delegate.forProperty("selectedItems$", () => new DelegatingListModel());
            delegate.forProperty("selectedItems", () => new DelegatingListModel());
            delegate.forProperty("selectCommand", () => new DelegatingUnaryCommand());
            delegate.forProperty("clearCommand", () => new DelegatingCommand());
            delegate.forFunction("clear");
            delegate.forFunction("select");
            delegate.forFunction("isSelected");
            delegate.forFunction("enableWhile");
            delegate.forFunction("disableWhile");
        });
    }
    DelegatingSingleSelectionModel.createDelegate = createDelegate;
})(DelegatingSingleSelectionModel || (DelegatingSingleSelectionModel = {}));

// todo: remove the form dependency... or add it explicitly to the base class constraints.
var HasEnabled;
(function (HasEnabled) {
    function Mixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this._enabledWhenDelegate$ = new DelegatingValueModel().withDefault(true);
                this._masterEnabledWhenDelegate$ = new DelegatingValueModel().withDefault(true); // todo: I don't think I'm using this any more...
            }
            get enabled$() {
                if (!this._enabled$) {
                    const models = [
                        assert.notNull(this._enabledWhenDelegate$),
                        assert.notNull(this._masterEnabledWhenDelegate$)
                    ];
                    this._enabled$ = new AndValueModel(models);
                }
                return this._enabled$;
            }
            /**
             * @deprecated use #enabled$ instead
             */
            get enabled() {
                return this.enabled$;
            }
            isEnabled() {
                return this.enabled$.value;
            }
            enableWhile(condition) {
                this._enabledWhenDelegate$.setDelegate(condition);
                return this;
            }
            disableWhile(condition) {
                this.enableWhile(MappedValueModel.create(condition, enabled => !enabled));
                return this;
            }
            __setMasterEnable(masterEnable) {
                this._masterEnabledWhenDelegate$.setDelegate(masterEnable);
            }
        };
    }
    HasEnabled.Mixin = Mixin;
    function DelegateMixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__enabledDelegate = this.registerDisposable(new DelegatingValueModel().withDefault(false));
            }
            setDelegate(delegate) {
                super.setDelegate(delegate);
                this.__enabledDelegate.setDelegate(delegate && delegate['enabled$'] ? delegate['enabled$'] : ValueModel.TRUE);
            }
            get enabled$() {
                return this.__enabledDelegate.readonly;
            }
            /**
             * @deprecated use #enabled$ instead
             */
            get enabled() {
                return this.__enabledDelegate.readonly;
            }
        };
    }
    HasEnabled.DelegateMixin = DelegateMixin;
    function setMasterEnabled(hasEnabled, masterEnabled) {
        assert.notNil(masterEnabled);
        hasEnabled['__setMasterEnable$'](masterEnabled);
    }
    HasEnabled.setMasterEnabled = setMasterEnabled;
})(HasEnabled || (HasEnabled = {}));

class SelectionModel extends HasEnabled.Mixin(GarbageCollector) {
    /**
     * @deprecated use #leadSelection$ instead
     */
    get leadSelection() {
        return this.leadSelection$;
    }
    /**
     * @deprecated use #selectedItems$ instead
     */
    get selectedItems() {
        return this.selectedItems$;
    }
}

/**
 * A multiple selection model that maintains selection with changes to the underlying source of truth.
 */
class MultipleSelectionModel extends SelectionModel {
    constructor(sourceList$, identityOf, idModel) {
        super();
        this.sourceList$ = sourceList$;
        this.identityOf = identityOf;
        this._leadSelectionId$ = new MutableValueModel();
        assert.isFunction(identityOf);
        const { chain, valueOf, before, when, after, observe } = Dsl.disposeWith(this);
        // we're using a binding here rather than a converted model so we can use writeLeft/writeRight.
        this.sourceOfTruth$ = chain(sourceList$);
        this._selectedItemIds$ = idModel;
        DebugContext.tag(this.sourceOfTruth$, "MultipleSelectionModel.sourceOfTruth");
        const index = HasOneIndex.identifiedWith(this.sourceOfTruth$, identityOf);
        this.selectedItems$ = chain(index)
            .findAllBy(this._selectedItemIds$)
            .reduceToList(items => this.enabled$.value ? items : [], { dependsOn: this.enabled$ })
            .identifiedWith(identityOf);
        this.leadSelection$ = chain(index)
            .findBy(this._leadSelectionId$)
            .map(items => this.enabled$.value ? items : undefined, { dependsOn: this.enabled$ })
            .identifiedWith(identityOf);
        this.count$ = chain(this.selectedItems$).count();
        this.empty$ = chain.numericValue(this.count$).isLessThan(1);
        this.selectCommand = UnaryCommand.create((item) => {
            this._toggleSelection(item);
        }, { enableWhile: this.enabled$ });
        when(this._selectedItemIds$).changes(() => this.syncLeadSelection());
        when(this.sourceList$).changes((items) => this.syncLeadSelection());
        this.clearCommand = Command.create(() => {
            this._selectedItemIds$.value = [];
            this._leadSelectionId$.value = undefined;
        }, { enableWhile: this.enabled$ });
        this.toggleAllCommand = Command.create(() => {
            if (!this.allSelected$.value) {
                this.selectAll(this.sourceOfTruth$.value);
            }
            else {
                this.clear();
            }
        }, {
            enableWhile: valueOf.all(this.sourceOfTruth$.isNotEmpty(), this.enabled$).areTruthy()
        });
        this.totalItemCount$ = this.sourceOfTruth$.count();
        this.selectedItemCount$ = chain(this.selectedItems$).count();
        this.allSelected$ = valueOf.all(chain.numericValue(this.totalItemCount$).isGreaterThan(0), chain.numericValue(this.totalItemCount$).equals(this.selectedItemCount$)).areTruthy();
        this.noneSelected$ = valueOf.all(chain.numericValue(this.totalItemCount$).isGreaterThan(0), chain.numericValue(this.selectedItemCount$).equals(0)).areTruthy();
        this.someSelected$ = valueOf.all(chain.numericValue(this.totalItemCount$).isGreaterThan(0), chain(this.allSelected$).isFalsey(), chain(this.noneSelected$).isFalsey()).areTruthy();
    }
    static fromList(sourceOfTruth$, identity, options) {
        const { optionsHelper, identityOf } = this.extractOptions(sourceOfTruth$, identity, options);
        const idModel$ = optionsHelper.get('storeIdsIn', () => {
            const idModel$ = new MutableListModel();
            DebugContext.tag(idModel$, "MultipleSelectionModel.storeIdIn");
            return idModel$;
        });
        return new MultipleSelectionModel(sourceOfTruth$, identityOf, idModel$);
    }
    static extractOptions(sourceOfTruth, identityOrOptions, options) {
        if (isNil$1(identityOrOptions) && isNil$1(options)) {
            return {
                optionsHelper: OptionsHelper.for(null),
                identityOf: sourceOfTruth.identityOf
            };
        }
        if (isPlainObject(identityOrOptions)) {
            return {
                optionsHelper: OptionsHelper.for(identityOrOptions),
                identityOf: sourceOfTruth.identityOf
            };
        }
        else {
            return {
                optionsHelper: OptionsHelper.for(options),
                identityOf: isFunction(identityOrOptions)
                    ? identityOrOptions
                    : (item) => isNil$1(item)
                        ? undefined :
                        item[identityOrOptions]
            };
        }
    }
    _toggleSelection(item) {
        this.whileEnabled(() => {
            assert.notNil(item);
            const itemId = this.identityOf(item);
            if (this.isSelected(item)) {
                this._selectedItemIds$.remove(itemId);
                // if we removed the lead selection then update it.
                if (itemId === this._leadSelectionId$.value) {
                    this._leadSelectionId$.value = this.getFirstSelectedItemId();
                }
            }
            else {
                this._selectedItemIds$.push(itemId);
                this._leadSelectionId$.value = itemId;
            }
        });
    }
    selectAll(items) {
        this.whileEnabled(() => {
            this._selectedItemIds$.value = items.map(i => this.identityOf(i));
            this._leadSelectionId$.value = this.getFirstSelectedItemId();
        });
    }
    getFirstSelectedItemId() {
        return this.selectedItems$.length > 0 ? this.identityOf(this.selectedItems$.value[0]) : null;
    }
    add(item) {
        return this.whileEnabled(() => {
            if (this.isSelected(item)) {
                return false;
            }
            else {
                this._toggleSelection(item);
                return true;
            }
        }, false);
    }
    remove(item) {
        return this.whileEnabled(() => {
            if (this.isSelected(item)) {
                this._toggleSelection(item);
                return true;
            }
            else {
                return false;
            }
        }, false);
    }
    clear() {
        return this.clearCommand.execute();
    }
    isSelected(item) {
        return this.whileEnabled(() => {
            return this.selectedItems$.query().includes(item);
        }, false);
    }
    syncLeadSelection() {
        if (!this._selectedItemIds$.query().includes(this._leadSelectionId$.value)) {
            this._leadSelectionId$.value = this.getFirstSelectedItemId();
        }
    }
    whileEnabled(runnable, otherwise) {
        if (this.enabled$.value) {
            return runnable();
        }
        else {
            return otherwise;
        }
    }
}

class SelectionSanitizer extends GarbageCollector {
    constructor(selectionModel, items) {
        super();
        this.selectionModel = selectionModel;
        this.items = items;
        const { before, after } = Dsl.disposeWith(this);
        before.valueOf(selectionModel).changes(currentValue => this.rememberSelectedIndex(currentValue));
        after.listOf(items).changes(() => this.restoreSelection());
    }
    rememberSelectedIndex(value) {
        if (value) {
            this.lastSelectedIndex = this.items.query().indexOf(value);
        }
        else {
            this.lastSelectedIndex = -1;
        }
    }
    restoreSelection() {
        if (!this.items.query().includes(this.selectionModel.value)) {
            let newValues = this.items.value;
            if (this.lastSelectedIndex >= 0) { // we had a selection.
                if (this.lastSelectedIndex < newValues.length) {
                    this.selectionModel.value = newValues[this.lastSelectedIndex];
                }
                else {
                    this.selectionModel.value = last$1(newValues);
                }
            }
            else {
                this.selectionModel.value = first$1(newValues);
            }
        }
        else {
            // get updated value.
            const index = this.items.query().indexOf(this.selectionModel.value);
            this.selectionModel.value = this.items.value[index];
        }
    }
}

class SingleSelectionModel extends SelectionModel {
    constructor(source$, identityOf, _selectedId$, allowEmptySelection = true) {
        super();
        this.source$ = source$;
        this.identityOf = identityOf;
        this._selectedId$ = _selectedId$;
        this.allowEmptySelection = allowEmptySelection;
        const { chain, valueOf, before, when, after, observe } = Dsl.disposeWith(this);
        this.sourceOfTruth = chain(source$);
        DebugContext.tag(this.sourceOfTruth, "SingleSelectionModel.sourceOfTruth");
        const index = this.registerDisposable(HasOneIndex.identifiedWith(this.sourceOfTruth, this.identityOf));
        this.leadSelection$ = chain(index).findBy(this._selectedId$).map(item => {
            return this.enabled$.value ? item : undefined;
        }, { dependsOn: this.enabled$ }).identifiedWith(this.identityOf);
        this.selectedItems$ = chain(this.leadSelection$).mapToList(value => isNil$1(value) ? [] : [value]);
        this.selectCommand = UnaryCommand.create((item) => {
            this.select(item);
        }, { enableWhile: this.enabled$ });
        this.clearCommand = Command.create(() => {
            this.clear();
        }, { enableWhile: this.enabled$ });
        DebugContext.getOrCreate(this.leadSelection$).tag("SingleSelectionModel.leadSelection");
    }
    static fromList(sourceOfTruth, identityOrOptions, options) {
        const { optionsHelper, identityOf } = this.extractOptions(sourceOfTruth, identityOrOptions, options);
        const idModel = optionsHelper.get("storeIdIn", () => {
            const idModel = new MutableValueModel();
            DebugContext.tag(idModel, "SingleSelectionModel.storeIdIn");
            return idModel;
        });
        const model = new SingleSelectionModel(sourceOfTruth, identityOf, idModel, optionsHelper.get("allowEmptySelection", false));
        const autoSelectOnFirstLoad = optionsHelper.get("autoSelectFirstItemOnLoad", false);
        const selectNearestOnMissing = optionsHelper.get("selectNearestOnMissing", false);
        const resetSelectionStateOnChangesTo = optionsHelper.get("resetSelectionStateOnChangesTo", ValueModel.constant(undefined));
        model.registerDisposable(new SingleSelectionModel.SelectionMonitor(model, autoSelectOnFirstLoad, selectNearestOnMissing, resetSelectionStateOnChangesTo));
        return model;
    }
    static extractOptions(sourceOfTruth, identityOrOptions, options) {
        if (isNil$1(identityOrOptions) && isNil$1(options)) {
            return {
                optionsHelper: OptionsHelper.for(null),
                identityOf: sourceOfTruth.identityOf
            };
        }
        if (isPlainObject(identityOrOptions)) {
            return {
                optionsHelper: OptionsHelper.for(identityOrOptions),
                identityOf: sourceOfTruth.identityOf
            };
        }
        else {
            return {
                optionsHelper: OptionsHelper.for(options),
                identityOf: isFunction(identityOrOptions)
                    ? identityOrOptions
                    : (item) => isNil$1(item)
                        ? undefined :
                        item[identityOrOptions]
            };
        }
    }
    select(item) {
        if (this.enabled$.value) {
            if (this.isSelected(item)) {
                if (this.allowEmptySelection) {
                    this._selectedId$.value = undefined;
                }
            }
            else {
                this._selectedId$.value = this.identityOf(item);
            }
        }
        else {
            console.warn("Can't select item while selection model is disabled", item);
        }
    }
    clear() {
        this.select(undefined);
    }
    isSelected(item) {
        return this.enabled$.value ? this.selectedId$.value == this.identityOf(item) : false;
    }
    get selectedId$() {
        return this._selectedId$.readonly;
    }
    /**
     * @deprecated use #selectedId$ instead
     */
    get selectedIdModel() {
        return this.selectedId$.readonly;
    }
    /**
     * @deprecated use #source$ instead
     */
    get sourceList() {
        return this.source$.readonly;
    }
}
(function (SingleSelectionModel) {
    class SelectionMonitor extends GarbageCollector {
        constructor(selectionModel, autoSelectFirstItemOnLoad, selectNearestOnMissing, resetSelectionStateOnChangesTo) {
            super();
            this.selectionModel = selectionModel;
            this.autoSelectFirstItemOnLoad = autoSelectFirstItemOnLoad;
            this.selectNearestOnMissing = selectNearestOnMissing;
            this.resetSelectionStateOnChangesTo = resetSelectionStateOnChangesTo;
            const { chain, valueOf, before, when, after, observe } = Dsl.disposeWith(this);
            const sourceList = this.selectionModel.source$;
            const selectedIdModel = this.selectionModel.selectedId$;
            const leadSelectionModel = this.selectionModel.leadSelection$;
            const snapshot = chain(sourceList).reduce(source => {
                return {
                    sourceList: source,
                    initialSelection: leadSelectionModel.value,
                    resetTrigger: resetSelectionStateOnChangesTo.value,
                };
            }, {
                dependsOn: [
                    resetSelectionStateOnChangesTo
                ],
                tag: "SelectionModel.SelectionMonitor"
            });
            this.registerDisposable(snapshot.onTransactionStart(sourceTx => {
                const txMonitor = new SelectionStateTracker(selectedIdModel.value, sourceTx.initialValue, autoSelectFirstItemOnLoad, selectNearestOnMissing, selectionModel.identityOf);
                if (selectedIdModel.isInTransaction()) {
                    console.warn(`SingleSelectionModel 'storeIdIn' model (${DebugContext.getDebugLabel(selectedIdModel)}) is in same transaction as source models. Options for autoSelectFirstItemOnLoad and selectNearestOnMissing options can't be applied.`);
                }
                else {
                    selectedIdModel.joinTransaction(sourceTx, idTx => {
                        idTx.commit(txMonitor.computeSelectedId(sourceTx.committedValue));
                    }, snapshot);
                }
            }));
            // trigger a no-op transaction to initialise the selection state.
            sourceList.startTransaction().commit(sourceList.value);
        }
    }
    SingleSelectionModel.SelectionMonitor = SelectionMonitor;
    class SelectionStateTracker {
        constructor(initiallySelectedId, initialState, autoSelectFirstItemOnLoad, selectNearestOnMissing, identityOf) {
            this.initiallySelectedId = initiallySelectedId;
            this.initialState = initialState;
            this.autoSelectFirstItemOnLoad = autoSelectFirstItemOnLoad;
            this.selectNearestOnMissing = selectNearestOnMissing;
            this.identityOf = identityOf;
            if (!isNil$1(initiallySelectedId)) {
                this.mostRecentSelectedIndex = initialState.sourceList.findIndex(item => this.identityOf(item) === initiallySelectedId);
            }
        }
        computeSelectedId(committedState) {
            const sourceList = committedState.sourceList;
            const reset = this.initialState.resetTrigger !== committedState.resetTrigger;
            if (reset) {
                if (this.autoSelectFirstItemOnLoad && sourceList.length > 0) {
                    return this.identityOf(sourceList[0]);
                }
                else {
                    return undefined;
                }
            }
            else {
                if (isNil$1(this.initiallySelectedId) && sourceList.length > 0 && this.autoSelectFirstItemOnLoad) {
                    return this.identityOf(sourceList[0]);
                }
                // ELSE.. we have an id...
                const isEmpty = sourceList.length < 1;
                if (!isEmpty) {
                    const currentlySelectedItemInNewList = sourceList.find(i => this.identityOf(i) === this.initiallySelectedId);
                    if (isNil$1(currentlySelectedItemInNewList) && this.selectNearestOnMissing) {
                        // our most recent item is not longer in the list.
                        const newIndex = sourceList.length > this.mostRecentSelectedIndex ?
                            this.mostRecentSelectedIndex : // select the item at the selected index;
                            sourceList.length - 1; // select the last item in the list.
                        return this.identityOf(sourceList[newIndex]);
                    }
                }
            }
            // by default we leave the id alone in case the list was cleared temporarily (as can happen with async loads
            // and intermediate states)
            return this.initiallySelectedId;
        }
    }
    SingleSelectionModel.SelectionStateTracker = SelectionStateTracker;
})(SingleSelectionModel || (SingleSelectionModel = {}));

/**
 * @file Automatically generated by barrelsby.
 */

var FocusContext;
(function (FocusContext) {
    function createProxy() {
        return DelegateProxyHandler.create("FocusContext", delegate => {
            delegate.forProperty("focused", () => new DelegatingValueModel().withDefault(false));
            delegate.forProperty("focusCommand", () => new DelegatingCommand());
            delegate.forFunction("requestFocus");
            delegate.forFunction("notifyFocusIn");
            delegate.forFunction("notifyFocusOut");
        });
    }
    FocusContext.createProxy = createProxy;
})(FocusContext || (FocusContext = {}));

class FocusManager extends GarbageCollector {
    constructor() {
        super();
        this._currentFocusedModel = new MutableValueModel();
        this._focusTargets = new MutableListModel();
        this.mostRecentTarget = new MutableValueModel();
        const { chain, when } = Dsl.disposeWith(this);
        this.focused = chain(this._currentFocusedModel).isNotNil();
        this.firstItem = chain(this._focusTargets).first();
        this.lastItem = chain(this._focusTargets).last();
        this.currentFocusIndex = chain(this._focusTargets).indexOf(this._currentFocusedModel);
        when.valueOf(this._currentFocusedModel).changes((value) => {
            if (!isNil$1(value)) {
                this.mostRecentTarget.value = value;
            }
        });
    }
    get focusTargets() {
        return this._focusTargets.readonly;
    }
    get focusTarget$() {
        return this._currentFocusedModel.readonly;
    }
    focusFirst() {
        if (this.firstItem.value) {
            this.requestFocus(this.firstItem.value);
        }
    }
    focusNext() {
        if (this.currentFocusIndex.value < 0) {
            this.focusFirst();
        }
        else {
            if (this.currentFocusIndex.value < this._focusTargets.length - 1) {
                this._currentFocusedModel.value = this._focusTargets.value[this.currentFocusIndex.value + 1];
            }
        }
    }
    focusPrevious() {
        if (this.currentFocusIndex.value >= 0) {
            if (this.currentFocusIndex.value > 0) {
                this._currentFocusedModel.value = this._focusTargets.value[this.currentFocusIndex.value - 1];
            }
        }
        else {
            this.focusLast();
        }
    }
    focusLast() {
        if (this.lastItem.value) {
            this.requestFocus(this.lastItem.value);
        }
    }
    restoreFocus() {
        if (this.mostRecentTarget.value && this.focusTargets.query().includes(this.mostRecentTarget.value)) {
            this.requestFocus(this.mostRecentTarget.value);
        }
        else {
            this.focusFirst();
        }
    }
    registerFocusable(focusable) {
        assert.isFalsey(this._focusTargets.query().includes(focusable));
        const garbage = new GarbageCollector();
        const { chain } = Dsl.disposeWith(garbage);
        this._focusTargets.push(focusable);
        // FIXME: RAKE: equals checks if the value is already a valueModel and will use it directly.  This
        // will result in equals comparing this._currentFocusedModel.value === model.value rather than this._currentFocusedModel.value === model.
        // by wrapping in a MutableValueModel we get this._currentFocusedModel.value === holder.value which will be correct.
        const focused = chain(this._currentFocusedModel).equals(new MutableValueModel(focusable));
        const self = this;
        return {
            focused,
            focusCommand: Command.create(() => self.requestFocus(focusable)),
            requestFocus: () => self.requestFocus(focusable),
            notifyFocusIn: () => self.notifyFocusIn(focusable),
            notifyFocusOut: () => self.notifyFocusOut(focusable),
            dispose: () => {
                this.notifyFocusOut(focusable);
                self._focusTargets.remove(focusable);
                garbage.dispose();
            }
        };
    }
    requestFocus(focusTarget) {
        assert.isTruthy(this._focusTargets.query().includes(focusTarget));
        if (this._currentFocusedModel.value !== focusTarget) {
            this._currentFocusedModel.value = focusTarget;
        }
    }
    notifyFocusIn(focusTarget) {
        if (this._currentFocusedModel.value !== focusTarget) {
            this._currentFocusedModel.value = focusTarget;
        }
    }
    notifyFocusOut(focusTarget) {
        if (this._currentFocusedModel.value === focusTarget) {
            this._currentFocusedModel.value = undefined;
        }
    }
}

var FormContext;
(function (FormContext) {
    function createProxy() {
        return DelegateProxyHandler.create("FormContext", (delegate) => {
            delegate.forProperty("enabled$", () => new DelegatingValueModel().withDefault(false));
            delegate.forProperty("focusTarget$", () => new DelegatingValueModel());
            // TODO remove when deprecated
            delegate.forProperty("enabled", () => new DelegatingValueModel().withDefault(false));
            delegate.forProperty("focusTarget", () => new DelegatingValueModel());
            delegate.forSubscriptionFunction("registerValidator");
            delegate.forSubscriptionFunctionWithProxy("registerFocusable", () => FocusContext.createProxy());
        });
    }
    FormContext.createProxy = createProxy;
})(FormContext || (FormContext = {}));

class ValidationResult {
    constructor() {
        this.errors = [];
    }
    addError(error) {
        assert.notNil(error);
        this.errors.push(error);
    }
    hasErrors() {
        return this.errors.length > 0;
    }
}

var HasValidators;
(function (HasValidators) {
    function asPredicate(options) {
        return assert.oneOrNoneOf(options, "asLongAs", "unless", () => {
            return options.unless ?
                () => !options.unless.value :
                () => options.asLongAs.value;
        }, () => true);
    }
    function Mixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__validators = [];
                this.__errorList = new MutableListModel();
                this.__hasErrors = ComputedValueModel.fromList(this.__errorList, errors => errors.length > 0);
            }
            get errorList() {
                return this.__errorList.readonly;
            }
            get hasErrors() {
                return this.__hasErrors.readonly;
            }
            validateUsing(validator, options) {
                return this._validateUsing(validator, options || {});
            }
            ;
            _validateUsing(validator, options) {
                if (isArray$1(validator)) {
                    validator.forEach(v => this.__registerValidator(v, options));
                }
                else {
                    this.__registerValidator(validator, options);
                }
                return this;
            }
            __registerValidator(validator, options) {
                this.__validators.push({ validator, predicate: asPredicate(options) });
            }
            runValidators(result) {
                this.__validators.filter(r => r.predicate()).forEach(r => {
                    if (!result.hasErrors()) {
                        const error = r.validator(this.value, result);
                        if (error) {
                            result.addError(error);
                        }
                    }
                });
            }
            ;
            validate(options) {
                const result = new ValidationResult();
                this.runValidators(result);
                if (!options || !options.silent) {
                    this.injectErrors(result.errors);
                }
                return !result.hasErrors();
            }
            ;
            injectErrors(errorList) {
                this.__errorList.value = isNil$1(errorList) ? [] : errorList;
            }
            clearErrors() {
                this.injectErrors([]);
            }
        };
    }
    HasValidators.Mixin = Mixin;
    function DelegateMixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__errorList = this.registerDisposable(new DelegatingListModel().withDefault([]));
            }
            setDelegate(delegate) {
                super.setDelegate(delegate);
                this.__errorList.setDelegate(delegate && delegate['errorList'] ? delegate['errorList'] : undefined);
            }
            get errorList() {
                return this.__errorList.readonly;
            }
        };
    }
    HasValidators.DelegateMixin = DelegateMixin;
})(HasValidators || (HasValidators = {}));

class ConvertedFormListModel extends HasValidators.Mixin(MutableListModel) {
    constructor(sourceModel, converter) {
        super();
        this.sourceModel = sourceModel;
        // Don't be tempted to use a ConvertingValueModel as it will round trip the conversion
        // causing the formatted value to clear if the converter fails to convert it.  This approach
        // allows the formatted model to have intermediate invalid values.
        const binding = new Binding(this, sourceModel, {
            toLeft: (right, currentLeftValue) => right.map((v, index) => converter.fromSource(v, currentLeftValue[index])),
            leftDependsOn: converter.fromSourceDependsOn,
            toRight: (left, currentRightValue) => left.map((v, index) => converter.toSource(v, currentRightValue[index])),
            rightDependsOn: converter.toSourceDependsOn
        }).writeLeft();
        this.focusContext = sourceModel.formContext.registerFocusable(this);
    }
    validateUsing(validator, options) {
        return this._validateUsing(validator, options);
    }
    ;
    enableWhile(condition) {
        this.sourceModel.enableWhile(condition);
        return this;
    }
    disableWhile(condition) {
        this.sourceModel.disableWhile(condition);
        return this;
    }
    get enabled$() {
        return this.sourceModel.enabled$;
    }
    /**
     * @deprecated use #enabled$ instead
     */
    get enabled() {
        return this.enabled$;
    }
    isEnabled() {
        return this.sourceModel.isEnabled();
    }
    get errorList$() {
        return this.sourceModel.errorList;
    }
    /**
     * @deprecated use #errorList$ instead
     */
    get errorList() {
        return this.errorList$;
    }
}

class ConvertedFormValueModel extends HasValidators.Mixin(MutableValueModel) {
    constructor(sourceModel, converter) {
        super();
        this.sourceModel = sourceModel;
        // Don't be tempted to use a ConvertingValueModel as it will round trip the conversion
        // causing the formatted value to clear if the converter fails to convert it.  This approach
        // allows the formatted model to have intermediate invalid values.
        const binding = new Binding(this, sourceModel, {
            toLeft: (rightValue, currentLeftValue) => converter.fromSource(rightValue, currentLeftValue),
            leftDependsOn: converter.fromSourceDependsOn,
            toRight: (leftValue, currentRightValue) => converter.toSource(leftValue, currentRightValue),
            rightDependsOn: converter.toSourceDependsOn
        }).writeLeft();
        this.focusContext = sourceModel.formContext.registerFocusable(this);
    }
    validateUsing(validator, options) {
        return this._validateUsing(validator, options);
    }
    ;
    enableWhile(condition) {
        this.sourceModel.enableWhile(condition);
        return this;
    }
    disableWhile(condition) {
        this.sourceModel.disableWhile(condition);
        return this;
    }
    get enabled$() {
        return this.sourceModel.enabled$;
    }
    /**
     * @deprecated use #enabled$ instead
     */
    get enabled() {
        return this.enabled$;
    }
    isEnabled() {
        return this.sourceModel.isEnabled();
    }
    get errorList$() {
        return this.sourceModel.errorList;
    }
    /**
     * @deprecated use #errorList$ instead
     */
    get errorList() {
        return this.errorList$;
    }
}

class ReducedFormListModel extends HasValidators.Mixin(MutableValueModel) {
    constructor(sourceModel, converter) {
        super();
        this.sourceModel = sourceModel;
        // Don't be tempted to use a ConvertingValueModel as it will round trip the conversion
        // causing the formatted value to clear if the converter fails to convert it.  This approach
        // allows the formatted model to have intermediate invalid values.
        const binding = new Binding(this, sourceModel, {
            toRight: (reduced, currentSource) => {
                return converter.toSource(reduced, currentSource);
            },
            rightDependsOn: converter.toSourceDependsOn,
            toLeft: sourceValue => {
                return converter.fromSource(sourceValue);
            },
            leftDependsOn: converter.fromSourceDependsOn
        }).writeLeft();
        this.focusContext = sourceModel.formContext.registerFocusable(this);
    }
    validateUsing(validator, options) {
        return this._validateUsing(validator, options);
    }
    ;
    disableWhen(whenModel) {
        return this.disableWhile(whenModel);
    }
    enableWhen(whenModel) {
        return this.enableWhile(whenModel);
    }
    enableWhile(condition) {
        this.sourceModel.enableWhen(condition);
        return this;
    }
    disableWhile(condition) {
        this.sourceModel.disableWhen(condition);
        return this;
    }
    get enabled$() {
        return this.sourceModel.enabled$;
    }
    /**
     * @deprecated use #enabled$ instead
     */
    get enabled() {
        return this.enabled$;
    }
    isEnabled() {
        return this.sourceModel.isEnabled();
    }
    get errorList$() {
        return this.sourceModel.errorList;
    }
    /**
     * @deprecated use #errorList$ instead
     */
    get errorList() {
        return this.errorList$;
    }
}

var HasFormContext;
(function (HasFormContext) {
    function DelegateMixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.formContext = FormContext.createProxy();
            }
            setDelegate(delegate) {
                super.setDelegate(delegate);
                this.formContext.setDelegate(delegate && delegate['formContext']);
            }
        };
    }
    HasFormContext.DelegateMixin = DelegateMixin;
})(HasFormContext || (HasFormContext = {}));

/*
    TODO:
    Linking forms
    - validation
    - injectErrors
    - focus tracking
    - value

    form.connectTo(HasFormContext, {
        validation: boolean,
        focusTracking: boolean,
        injectErrors: boolean | "propertyName"
    });
 */
class Form extends GarbageCollector {
    constructor(parent) {
        super();
        this.parent = parent;
        this._pluckedValueModels = new Map();
        this._pluckedListModels = new Map();
        this._holdersAndWrappedModels = [];
        this.validationCallbacks = this.registerDisposable(new EventListenerList());
        this.injectErrorCallbacks = this.registerDisposable(new EventListenerList());
        this._userEnabled$ = this.registerDisposable(new DelegatingValueModel().withDefault(true));
        this._hasErrors$ = new OrValueModel();
        this._enabled$ = new AndValueModel([this._userEnabled$]);
        if (parent) {
            this._enabled$.addSource(parent.enabled$);
            this.registerDisposable(parent.registerValidator((options) => this.validate(options)));
        }
        else {
            this._focusManager = new FocusManager();
        }
    }
    get enabled$() {
        return this._enabled$;
    }
    /**
     * @deprecated use #enabled$ instead
     */
    get enabled() {
        return this._enabled$;
    }
    enableWhile(condition) {
        this._userEnabled$.setDelegate(condition);
        return this;
    }
    disableWhile(condition) {
        const { chain } = Dsl.disposeWith(this);
        return this.enableWhile(chain(condition).isFalsey());
    }
    isEnabled() {
        return this.enabled$.value;
    }
    registerValidator(validator) {
        return this.validationCallbacks.add(validator);
    }
    registerFocusable(focusable) {
        return (this.parent || this._focusManager).registerFocusable(focusable);
    }
    get focusTarget$() {
        return (this.parent || this._focusManager).focusTarget$;
    }
    /**
     * @deprecated use #focusTarget$ instead
     */
    get focusTarget() {
        return this.focusTarget$;
    }
    /**
     * Creates a Form.ValueModel that is not bound to the forms data type.
     * @param initialValue
     */
    _valueModel(initialValue, factory) {
        const model = factory();
        model.value = initialValue;
        this._holdersAndWrappedModels.push(model);
        this._hasErrors$.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a Form.ValueModel from an external ValueModel.
     * @param mutableValueModel
     */
    _wrapValueModel(mutableValueModel, factory) {
        const model = factory();
        this.registerDisposable(new Binding(model, mutableValueModel, {
            toLeft: Functions.identity,
            toRight: Functions.identity
        })).writeLeft();
        this._holdersAndWrappedModels.push(model);
        this._hasErrors$.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a Form.ListModel that is not bound to the forms entity type.
     * @param initialValue
     */
    _listModel(initialValue, factory) {
        const model = factory();
        model.value = initialValue;
        // this.registerModel(model, null);
        this._holdersAndWrappedModels.push(model);
        this._hasErrors$.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a Form.ValueModel from an external ValueModel.
     * @param mutableValueModel
     */
    _wrapListModel(mutableListModel, factory) {
        const model = factory();
        this.registerDisposable(new Binding(model, mutableListModel, {
            toLeft: Functions.identity,
            toRight: Functions.identity
        })).writeLeft();
        this._holdersAndWrappedModels.push(model);
        this._hasErrors$.addSource(model.hasErrors);
        return model;
    }
    lazyCreate(cache, key, factory) {
        let model = cache.get(key);
        if (!model) {
            model = factory();
            cache.set(key, model);
        }
        return model;
    }
    /**
     * Creates a Form.ValueModel that is bound the to the specified property in the form data type.
     * @param options
     */
    _pluck(propertyName, options, factory) {
        return this.lazyCreate(this._pluckedValueModels, propertyName, () => {
            // make sure it's not taken by a subform
            // assert.isFalsey(this.hasSubFormForProperty(propertyName), `this model is already in use by a subform.`);
            const model = factory();
            this._hasErrors$.addSource(model.hasErrors);
            return model;
        });
    }
    /**
     * Creates a Form.ListModel that is bound the to the specified array property in the form data type.
     * @param options
     */
    _pluckList(propertyName, options, factory) {
        return this.lazyCreate(this._pluckedListModels, propertyName, () => {
            const model = factory();
            this._hasErrors$.addSource(model.hasErrors);
            return model;
        });
    }
    /**
     * Returns a model that is true when any form model has an error. Note, this does not include subform models.
     */
    get hasErrors$() {
        return this._hasErrors$.readonly;
    }
    /**
     * @deprecated use #hasErrors$ instead
     */
    get hasErrors() {
        return this.hasErrors$;
    }
    validate(options) {
        let passed = true;
        this._pluckedValueModels.forEach((model) => {
            passed = passed && model.validate(options);
        });
        this._pluckedListModels.forEach((model) => {
            passed = passed && model.validate(options);
        });
        this._holdersAndWrappedModels.forEach((model) => {
            passed = passed && model.validate(options);
        });
        this.validationCallbacks.fire(validate => {
            passed = passed && validate(options);
        });
        return passed;
    }
    clearErrors() {
        this.injectErrors({}); // clears all our property based models and sub forms.
        this._holdersAndWrappedModels.forEach(m => m.clearErrors()); // clears everything else.
    }
    injectErrors(errors) {
        const injectErrors = (model, propertyName) => {
            const errs = errors[propertyName];
            if (errs) {
                model.injectErrors(Array.isArray(errs) ? errs : [errs]);
            }
            else {
                model.injectErrors([]);
            }
        };
        this._pluckedValueModels.forEach(injectErrors);
        this._pluckedListModels.forEach(injectErrors);
    }
}
(function (Form) {
    class DelegatingFormValueModel extends HasFormContext.DelegateMixin(HasEnabled.DelegateMixin(HasValidators.DelegateMixin(DelegatingValueModel))) {
        constructor() {
            super(...arguments);
            this.focusContext = FocusContext.createProxy();
        }
        setDelegate(delegate) {
            super.setDelegate(delegate);
            this.focusContext.setDelegate(delegate && delegate['focusContext'] ? delegate['focusContext'] : undefined);
        }
        dispose() {
        }
    }
    Form.DelegatingFormValueModel = DelegatingFormValueModel;
    class DelegatingFormListModel extends HasFormContext.DelegateMixin(HasEnabled.DelegateMixin(HasValidators.DelegateMixin(DelegatingListModel))) {
        constructor() {
            super(...arguments);
            this.focusContext = FocusContext.createProxy();
        }
        setDelegate(delegate) {
            super.setDelegate(delegate);
            this.focusContext.setDelegate(delegate && delegate['focusContext'] ? delegate['focusContext'] : undefined);
        }
    }
    Form.DelegatingFormListModel = DelegatingFormListModel;
    class ValueModelBase extends HasEnabled.Mixin(HasValidators.Mixin(MutableValueModel)) {
        constructor(formContext) {
            super();
            this.formContext = formContext;
            this.__setMasterEnable(formContext.enabled$);
            this.focusContext = formContext.registerFocusable(this);
        }
        // // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
        // get value(): T {
        //     return this.valueStore.read();
        // }
        //
        // set value(value: T) {
        //     this.startTransaction().commit(value);
        // }
        convertedUsing(converter) {
            assert.notNil(converter);
            if (this.convertedModel) {
                lang.illegalState("converter or formatter already registered");
            }
            this.convertedModel = new ConvertedFormValueModel(this, converter);
            return this.convertedModel;
        }
        formattedUsing(converter) {
            return this.convertedUsing(converter);
        }
        // Keeping typescript happy. The .d.ts files are returning `any`.
        enableWhile(condition) {
            return super.enableWhile(condition);
        }
        disableWhile(condition) {
            return super.disableWhile(condition);
        }
        validateUsing(validator, options) {
            return this._validateUsing(validator, options);
        }
        ;
        runValidators(result) {
            // we run our converter validators first
            if (this.convertedModel) {
                this.convertedModel.runValidators(result);
            }
            // and then our own, but only if the converter was happy.
            if (!result.hasErrors()) {
                super.runValidators(result);
            }
        }
    }
    Form.ValueModelBase = ValueModelBase;
    class ListModelBase extends HasEnabled.Mixin(HasValidators.Mixin(MutableListModel)) {
        constructor(formContext) {
            super();
            this.formContext = formContext;
            this.derivedModels = [];
            this.__setMasterEnable(formContext.enabled$);
            this.focusContext = formContext.registerFocusable(this);
        }
        // // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
        // get value(): T[] {
        //     return this.valueStore.read();
        // }
        //
        // set value(value: T[]) {
        //     this.startTransaction().commit(value);
        // }
        reduceUsing(converter) {
            assert.notNil(converter);
            const model = new ReducedFormListModel(this, converter);
            this.derivedModels.push(model);
            return model;
        }
        convertedUsing(converter) {
            assert.notNil(converter);
            if (this.convertedModel) {
                lang.illegalState("converter or formatter already registered");
            }
            const model = new ConvertedFormListModel(this, converter);
            this.derivedModels.push(model);
            return model;
        }
        // Keeping typescript happy. The .d.ts files are returning `any`.
        enableWhile(condition) {
            return super.enableWhile(condition);
        }
        disableWhile(condition) {
            return super.disableWhile(condition);
        }
        validateUsing(validator, options) {
            return this._validateUsing(validator, options);
        }
        ;
        runValidators(result) {
            if (this.derivedModels.length > 0) {
                this.derivedModels.forEach(m => m.runValidators(result));
            }
            if (!result.hasErrors()) {
                super.runValidators(result);
            }
        }
    }
    Form.ListModelBase = ListModelBase;
})(Form || (Form = {}));

var Validator;
(function (Validator) {
    function present(message) {
        return (value) => {
            const present = isObject$1(value)
                || (isString$1(value) && !lang.isBlank(value))
                || isNumber(value)
                || isBoolean(value)
                || isArray$1(value);
            return !present ? message : undefined;
        };
    }
    Validator.present = present;
    function includedIn(values, message) {
        return (value) => {
            return values.includes(value) ? undefined : message;
        };
    }
    Validator.includedIn = includedIn;
})(Validator || (Validator = {}));

/**
 * @file Automatically generated by barrelsby.
 */

var DirtyModel;
(function (DirtyModel) {
    let ReadWriteOptions;
    (function (ReadWriteOptions) {
        ReadWriteOptions[ReadWriteOptions["ALL"] = 0] = "ALL";
        ReadWriteOptions[ReadWriteOptions["DIRTY"] = 1] = "DIRTY";
    })(ReadWriteOptions = DirtyModel.ReadWriteOptions || (DirtyModel.ReadWriteOptions = {}));
})(DirtyModel || (DirtyModel = {}));

var HasDirtyTracking;
(function (HasDirtyTracking) {
    class DirtyTracker extends AbstractComputedValueModel {
        constructor(source) {
            super({ initialValue: false, allowNil: true });
            this.source = source;
            this._hasCheckpoint = false;
            this.trackSource(source);
        }
        doComputeValue() {
            return this._hasCheckpoint ? this.source.hasChanged(this.source.value, this._checkpointValue) : false;
        }
        checkpoint() {
            this.runInTransaction(() => {
                this._hasCheckpoint = true;
                this._checkpointValue = this.source.value;
            });
        }
        ;
        revert() {
            this.runInTransaction(() => {
                if (this._hasCheckpoint) {
                    this.source.value = this._checkpointValue;
                }
            });
        }
        ;
    }
    HasDirtyTracking.DirtyTracker = DirtyTracker;
    function Mixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this._internalDirtyModel = new DirtyTracker(this);
            }
            checkpoint() {
                this._internalDirtyModel.checkpoint();
            }
            ;
            revert() {
                this._internalDirtyModel.revert();
            }
            ;
            get dirty() {
                return this._internalDirtyModel;
            }
        };
    }
    HasDirtyTracking.Mixin = Mixin;
    function DelegateMixin(Base) {
        return class extends Base {
            constructor() {
                super(...arguments);
                this.__dirtyDelegate = this.registerDisposable(new DelegatingValueModel().withDefault(false));
            }
            setDelegate(delegate) {
                super.setDelegate(delegate);
                this.__dirtyDelegate.setDelegate(delegate && delegate.dirty ? delegate.dirty : null);
            }
            get dirty() {
                return this.__dirtyDelegate.readonly;
            }
        };
    }
    HasDirtyTracking.DelegateMixin = DelegateMixin;
})(HasDirtyTracking || (HasDirtyTracking = {}));

class DirtyTrackingListModel extends HasDirtyTracking.Mixin(Form.ListModelBase) {
    constructor(formContext) {
        super(formContext);
    }
}

class DirtyTrackingValueModel extends HasDirtyTracking.Mixin(Form.ValueModelBase) {
    constructor(formContext) {
        super(formContext);
    }
}

var ModelAdapter;
(function (ModelAdapter) {
    class Base {
        constructor(property, model, options) {
            this.property = property;
            this.model = model;
            this.options = options;
            this.disableWriteCondition = new DelegatingValueModel().withDefault(false);
            this.disableWriteCondition.setDelegate(options && options.disableWriteWhen);
        }
        get isWriteEnabled() {
            return !this.disableWriteCondition.value;
        }
        shouldWrite(include) {
            return this.isWriteEnabled && (include === DirtyModel.ReadWriteOptions.ALL || this.isDirty());
        }
        injectErrors(errors) {
            const errs = errors[this.property];
            if (errs) {
                this.model.injectErrors(Array.isArray(errs) ? errs : [errs]);
            }
            else {
                this.model.injectErrors([]);
            }
        }
        isDirty() {
            return this.model.dirty.value;
        }
    }
    ModelAdapter.Base = Base;
    class ValueAdapter extends Base {
        constructor(property, formValueModel, options) {
            super(property, formValueModel, options);
        }
        readFrom(source) {
            // @ts-ignore hangs head in shame.
            this.model.value = source ? source[this.property] : undefined;
        }
        writeTo(source, include) {
            if (this.shouldWrite(include)) {
                source[this.property] = this.model.value;
            }
        }
    }
    ModelAdapter.ValueAdapter = ValueAdapter;
    class ListAdapter extends Base {
        constructor(property, formListModel, options) {
            super(property, formListModel, options);
        }
        readFrom(source) {
            // @ts-ignore hangs head in shame.
            this.model.value = source ? source[this.property] : [];
        }
        writeTo(source, include) {
            if (this.shouldWrite(include)) {
                // @ts-ignore hangs head in shame.
                source[this.property] = this.model.value;
            }
        }
    }
    ModelAdapter.ListAdapter = ListAdapter;
    class SubFormAdapter extends Base {
        constructor(property, form, options) {
            super(property, form, options);
        }
        readFrom(source) {
            // nested sub forms may have null for their source.
            this.model.load(source ? source[this.property] : null);
        }
        writeTo(source, include) {
            if (this.shouldWrite(include)) {
                if (!source[this.property]) {
                    source[this.property] = {};
                }
                this.model.writeStateTo(source[this.property], include);
            }
        }
        injectErrors(errors) {
            const errs = errors[this.property];
            if (errs) {
                this.model.injectErrors(errs);
            }
            else {
                this.model.injectErrors({});
            }
        }
    }
    ModelAdapter.SubFormAdapter = SubFormAdapter;
})(ModelAdapter || (ModelAdapter = {}));

class DirtyTrackingForm extends Form {
    constructor(parentFormContext) {
        super(parentFormContext);
        this._propertyAdapters = [];
        this._propertyValueModels = new Map();
        this._propertyListModels = new Map();
        this._subForms = [];
        this._holdersAndWrappedModelsWithADifferentName = [];
        this._childModels = [];
        this._dirty = new OrValueModel();
        this._hasErrorsWithADifferentName = new OrValueModel();
        this._enabledChangeNotifications = new MutableValueModel(true);
        this._onEditTransactionStartListeners = new EventListenerList();
        this._afterLoadEditListeners = new EventListenerList();
        this._afterEditListeners = new EventListenerList();
        this._afterCheckpointListeners = new EventListenerList();
        this._afterRevertListeners = new EventListenerList();
    }
    loadState(source) {
        this.executeBulkChange(() => {
            this._propertyAdapters.forEach(a => {
                a.readFrom(source);
                a.model.checkpoint();
            });
        });
        this._afterLoadEditListeners.fire(l => l());
        return this;
    }
    writeStateTo(destination, include = DirtyModel.ReadWriteOptions.ALL) {
        this._propertyAdapters.forEach(a => a.writeTo(destination, include));
    }
    readState(include = DirtyModel.ReadWriteOptions.ALL) {
        const destination = {};
        this.writeStateTo(destination, include);
        return destination;
    }
    writeDirtyStateTo(destination) {
        this.writeStateTo(destination, DirtyModel.ReadWriteOptions.DIRTY);
    }
    readDirtyState() {
        return this.readState(DirtyModel.ReadWriteOptions.DIRTY);
    }
    /**
     * Creates a DirtyTrackingValueModel that is not bound to the forms data type.
     * @param initialValue
     * @param options
     */
    valueModel(initialValue, options) {
        const model = this._createFormValueModel(initialValue);
        this.registerModel(model, null, options);
        this._holdersAndWrappedModelsWithADifferentName.push(model);
        this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a DirtyTrackingValueModel from an external ValueModel.
     * @param mutableValueModel
     * @param options
     */
    wrapValueModel(mutableValueModel, options) {
        const model = this._createFormValueModel();
        this.registerModel(model, null, options);
        this.registerDisposable(new Binding(model, mutableValueModel, {
            toLeft: Functions.identity,
            toRight: Functions.identity
        })).writeLeft();
        this._holdersAndWrappedModelsWithADifferentName.push(model);
        this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a DirtyTrackingListModel that is not bound to the forms entity type.
     * @param initialValue
     * @param options
     */
    listModel(initialValue, options) {
        const model = this._createFormListModel(initialValue);
        this.registerModel(model, null, options);
        this._holdersAndWrappedModelsWithADifferentName.push(model);
        this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a DirtyTrackingValueModel from an external ValueModel.
     * @param mutableListModel
     * @param options
     */
    wrapListModel(mutableListModel, options) {
        const model = this._createFormListModel();
        this.registerModel(model, null, options);
        this.registerDisposable(new Binding(model, mutableListModel, {
            toLeft: Functions.identity,
            toRight: Functions.identity
        })).writeLeft();
        this._holdersAndWrappedModelsWithADifferentName.push(model);
        this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        return model;
    }
    /**
     * Creates a DirtyTrackingValueModel that is bound the to the specified property in the form data type.
     * @param propertyName
     * @param options
     */
    pluck(propertyName, options) {
        let model = this._propertyValueModels.get(propertyName);
        if (!model) {
            // make sure it's not taken by a subform
            assert.isFalsey(this.hasSubFormForProperty(propertyName), `this model is already in use by a subform.`);
            model = this._createFormValueModel();
            model = this.registerModel(model, new ModelAdapter.ValueAdapter(propertyName, model, options), options);
            this._propertyValueModels.set(propertyName, model);
            this._holdersAndWrappedModelsWithADifferentName.push(model);
            this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        }
        return model;
    }
    /**
     * Creates a DirtyTrackingListModel that is bound the to the specified array property in the form data type.
     * @param initialValue
     * @param options
     */
    pluckList(propertyName, options) {
        let model = this._propertyListModels.get(propertyName);
        if (!model) {
            model = this._createFormListModel();
            const propertyAdapter = new ModelAdapter.ListAdapter(propertyName, model, options);
            this.registerModel(model, propertyAdapter, options);
            this._propertyListModels.set(propertyName, model);
            this._hasErrorsWithADifferentName.addSource(model.hasErrors);
        }
        return model;
    }
    /**
     * Creates a new Form instance that is bound the to the specified property in the form data type.
     * @param propertyName
     * @param options
     */
    createSubForm(propertyName, options) {
        // make sure it's not taken by a value model
        assert.isFalsey(this.hasValueModelForProperty(propertyName), `this model is already in use by a valueModel.`);
        const model = this._createSubForm();
        this.registerModel(model, new ModelAdapter.SubFormAdapter(propertyName, model, options), options);
        this._subForms.push({ modelName: propertyName, form: model });
        return model;
    }
    hasSubFormForProperty(propertyName) {
        return this._subForms.find(f => f.modelName === propertyName);
    }
    hasValueModelForProperty(propertyName) {
        return !!this._propertyValueModels.get(propertyName);
    }
    _createFormValueModel(initialValue) {
        const model = new DirtyTrackingValueModel(this);
        // @ts-ignore
        model.value = initialValue;
        return model;
    }
    _createFormListModel(initialValue = []) {
        const model = new DirtyTrackingListModel(this);
        // @ts-ignore
        model.value = initialValue;
        return model;
    }
    _createSubForm() {
        return new DirtyTrackingForm(this);
    }
    get dirty() {
        return this._dirty.readonly;
    }
    isDirty() {
        return this.dirty.value;
    }
    /**
     * Returns a model that is true when any form model has an error. Note, this does not include subform models.
     */
    get hasErrors$() {
        return this._hasErrorsWithADifferentName.readonly;
    }
    validate(options) {
        const modelResults = this._childModels.map(model => model.validate(options));
        return modelResults.findIndex(v => !v) < 0;
    }
    checkpoint() {
        this._dirty.runInTransaction(() => {
            this._childModels.forEach(model => model.checkpoint());
        });
        this._afterCheckpointListeners.fire(l => l());
    }
    revert() {
        // run in transactions so we don't flood the world with value change events for our derived models.
        this.executeBulkChange(() => {
            this._childModels.forEach(model => model.revert());
        });
        this._afterRevertListeners.fire(l => l());
    }
    get object() {
        return this._object;
    }
    load(source) {
        this._object = source;
        this.loadState(this._object);
    }
    onPropertyModelAdded(propertyAdapter) {
        if (this.object) {
            // the model was created after the state was loaded so we need to read it in.
            propertyAdapter.readFrom(this.object);
        }
    }
    executeBulkChange(func) {
        this._enabledChangeNotifications.value = false;
        try {
            // only fire a dirty change at the end of it all.
            this._dirty.runInTransaction(() => func());
        }
        finally {
            this._enabledChangeNotifications.value = true;
        }
    }
    clearErrors() {
        this.injectErrors({}); // clears all our property based models and sub forms.
        this._holdersAndWrappedModelsWithADifferentName.forEach(m => m.clearErrors()); // clears everything else.
    }
    injectErrors(errors) {
        this._propertyAdapters.forEach((adapter) => {
            adapter.injectErrors(errors);
        });
    }
    onTransactionStart(listener) {
        return this._onEditTransactionStartListeners.add(listener);
    }
    onLoad(listener) {
        return this._afterLoadEditListeners.add(listener);
    }
    onEdit(listener) {
        return this._afterEditListeners.add(listener);
    }
    onCheckpoint(listener) {
        return this._afterCheckpointListeners.add(listener);
    }
    onRevert(listener) {
        return this._afterRevertListeners.add(listener);
    }
    onModelTransactionStart(tx) {
        if (this._enabledChangeNotifications.value) {
            if (!this._currentTx) {
                this._currentTx = tx.getRoot();
                this._currentTx.onComplete(() => {
                    this._currentTx = undefined;
                });
                this._currentTx.afterRootTransactionFinalised(() => {
                    this._afterEditListeners.fire(l => l());
                });
                this._onEditTransactionStartListeners.fire(l => l(tx));
            }
            else {
                assert.isTruthy(this._currentTx === tx.getRoot());
            }
        }
    }
    registerModel(model, propertyAdapter, options) {
        this._childModels.push(model);
        if (propertyAdapter) {
            this._propertyAdapters.push(propertyAdapter);
            this.onPropertyModelAdded(propertyAdapter);
        }
        model.checkpoint(); // establish our dirty baseline.
        this.registerDisposable(model.onTransactionStart(tx => this.onModelTransactionStart(tx)));
        if (!options || isNil$1(options.dirtyTracking) || options.dirtyTracking) {
            this._dirty.addSource(model.dirty);
        }
        return model;
    }
}
(function (DirtyTrackingForm) {
    class UpdateInPlace extends DirtyTrackingForm {
        constructor(options) {
            super();
            this._autoCommit = ValueModel.isInstance(options.autoCommit) ? options.autoCommit : new Constant(options.autoCommit);
            this.onCheckpoint(() => this.handleCheckpoint());
            this.onRevert(() => this.handleRevert());
            this.onEdit(() => this.handleEdit());
        }
        isAutoCommit() {
            return this._autoCommit.value;
        }
        handleEdit() {
            if (this.isAutoCommit()) {
                this.persistState();
            }
        }
        handleRevert() {
            if (this.isAutoCommit()) {
                this.persistState();
            }
        }
        handleCheckpoint() {
            if (this.isAutoCommit()) {
                this.persistState();
            }
        }
        persistState() {
            if (this._object) {
                this.writeStateTo(this._object);
            }
        }
    }
    DirtyTrackingForm.UpdateInPlace = UpdateInPlace;
})(DirtyTrackingForm || (DirtyTrackingForm = {}));

/**
 * @file Automatically generated by barrelsby.
 */

// TODO: scenarios.
//
//   Selection models:
//      selectedHero = formListModel.trackUpdates(heroSelectionModel.leadSelection); // <- LiveUpdateForm.ValueModel<Hero>
//      <hero-editor  [heroModel]='selectedHero'></hero-editor>
//
//      @Input() @TrackExternal()
//      heroModel: LiveUpdateForm.ValueModel<Hero>
//
//      ngOnInit() {
//         private form = LiveUpdateForm.create(this.heroModel)
//      }
//
//   List of editors:  <hero-editor *ngFor="let hero in heroList.value" [heroModel]='heroList.trackUpdates(hero)'></hero-editor>
//
//      @Input() @StoreInValueModel('heroModel')
//      hero: Hero;
//
//     @Input() @TrackExternal()
//      heroModel: ValueModel<Hero>;
//
//      private form = LiveUpdateForm.create(this.heroModel)
//
//
//   List of editors:  <hero-editor *ngFor="let hero in heroList.value" [hero]='hero' [editContext]="heroList"></hero-editor>
//
//      @Input()
//      updateStrategy: LiveUpdateContext<Hero>;
//
//      @Input() @StoreInValueModel('heroModel')
//      hero: Hero;
//
//      private heroModel = new  MutableValueModel<Hero>();
//
//      ngOnInit() {
//         private form = LiveUpdateForm.create(this.heroModel, this.editContext)
//      }
//
class LiveUpdateForm extends Form {
    constructor(source, applyChanges, parentFormContext) {
        super(parentFormContext);
        this.source = source;
        this.applyChanges = applyChanges;
    }
    static fromSource(valueModel, applyChangesOrFormContext, formContext) {
        if (isFunction(applyChangesOrFormContext)) {
            return new LiveUpdateForm(valueModel, applyChangesOrFormContext, formContext || valueModel["formContext"]);
        }
        else {
            assert.isFunction(valueModel['applyChanges']);
            return new LiveUpdateForm(valueModel, valueModel['applyChanges'], applyChangesOrFormContext || valueModel["formContext"]);
        }
    }
    /**
     * Creates a form that tracks the specified ValueModel and pushes any changes to the underlying list.
     * @param valueModel the model to base the form on.
     * @param sourceList the source list model to update with any changes.
     */
    static fromValueInList(valueModel, sourceList) {
        const applyChanges = (is, was) => {
            sourceList.applyChanges(is, was);
        };
        return LiveUpdateForm.fromSource(valueModel, applyChanges, sourceList.formContext);
    }
    valueModel(initialValue) {
        return this._valueModel(initialValue, () => new LiveUpdateForm.FormValueModel(this));
    }
    wrapValueModel(other) {
        return this._wrapValueModel(other, () => new LiveUpdateForm.FormValueModel(this));
    }
    listModel(initialValue) {
        return this._listModel(initialValue, () => new LiveUpdateForm.FormListModel(this));
    }
    wrapListModel(other) {
        return this._wrapListModel(other, () => new LiveUpdateForm.FormListModel(this));
    }
    pluck(propertyName, options) {
        return this._pluck(propertyName, options, () => {
            const model = new LiveUpdateForm.FormValueModel(this);
            // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
            model["value"] = this.source.value ? this.source.value[propertyName] : undefined;
            this.installBindings(model, propertyName);
            return model;
        });
    }
    pluckList(propertyName, options) {
        return this._pluckList(propertyName, options, () => {
            const model = new LiveUpdateForm.FormListModel(this);
            // TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
            // @ts-ignore it also doesn't think it's an array...
            model["value"] = this.source.value ? this.source.value[propertyName] : undefined;
            this.installBindings(model, propertyName);
            return model;
        });
    }
    // TODO: make this typesafe
    installBindings(model, propertyName) {
        const { when } = Dsl.disposeWith(this);
        this.registerDisposable(this.source.onTransactionStart(sourceTx => {
            model.joinTransaction(sourceTx, (modelTx) => {
                const sourceValue = sourceTx.committedValue;
                modelTx.commit(sourceValue ? sourceValue[propertyName] : undefined);
            }, model);
        }, model));
        this.registerDisposable(model.onTransactionStart(modelTx => {
            const triggeredBySourceChange = this.source.isInTransaction();
            modelTx.onRootTransactionFinalised(() => {
                if (!triggeredBySourceChange && modelTx.hasChanged()) {
                    const updated = produce(this.source.value, draft => {
                        // @ts-ignore
                        draft[propertyName] = modelTx.committedValue;
                    });
                    this.applyChanges(updated, this.source.value);
                }
            });
        }, model));
    }
}
(function (LiveUpdateForm) {
    class DelegatingFormValueModel extends Form.DelegatingFormValueModel {
        constructor() {
            super(...arguments);
            this.applyChanges = (value, previous) => {
                this._delegateApplyChanges(value, previous);
            };
        }
        setDelegate(delegate) {
            super.setDelegate(delegate);
            this._delegateApplyChanges = delegate ?
                (value, previous) => delegate.applyChanges(value, previous) :
                (value, previous) => {
                    throw Error("applyChanges called when delegate was undefined");
                };
        }
    }
    LiveUpdateForm.DelegatingFormValueModel = DelegatingFormValueModel;
    class DelegatingFormListModel extends Form.DelegatingFormListModel {
        constructor() {
            super(...arguments);
            this.applyChanges = (value, previous) => {
                this._delegateApplyChanges(value, previous);
            };
        }
        setDelegate(delegate) {
            super.setDelegate(delegate);
            this._delegateApplyChanges = delegate ?
                (value, previous) => delegate.applyChanges(value, previous) :
                (value, previous) => {
                    throw Error("applyChanges called when delegate was undefined");
                };
        }
    }
    LiveUpdateForm.DelegatingFormListModel = DelegatingFormListModel;
    class FormValueModel extends Form.ValueModelBase {
        constructor() {
            super(...arguments);
            this.applyChanges = (value, previous) => {
                // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
                this["value"] = value;
            };
            // // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
            // get value(): T {
            //     return this.valueStore.read();
            // }
            //
            // set value(value: T) {
            //     this.startTransaction().commit(value);
            // }
        }
    }
    LiveUpdateForm.FormValueModel = FormValueModel;
    class FormListModel extends Form.ListModelBase {
        constructor() {
            super(...arguments);
            this.applyChanges = (value, previous) => {
                this.runInTransaction(draft => {
                    const currentItemId = this.identityOf(previous);
                    try {
                        const updatedList = draft.value.map(existingItem => {
                            return this.identityOf(existingItem) === currentItemId ? value : existingItem;
                        });
                        draft.value = updatedList;
                    }
                    catch (error) {
                        console.error(error);
                        throw error;
                    }
                });
            };
        }
        // // @TODO: Typescript Hack, for some reason typescript isn't seeing that value is writable under all the mixins.
        // get value(): T[] {
        //     return this.valueStore.read();
        // }
        //
        // set value(value: T[]) {
        //     this.startTransaction().commit(value);
        // }
        /**
         * Wraps the specified model and returns an new LiveUpdateForm.ValueModel that will push any changes
         * back into the underlying list.  This is useful for selection models.
         * @param valueModel
         */
        interceptWrite(valueModel) {
            return this.formContext.registerDisposable(new InterceptedFormValueModel(valueModel, this));
        }
    }
    LiveUpdateForm.FormListModel = FormListModel;
    class InterceptedFormValueModel extends FormValueModel {
        constructor(interceptedModel, formListModel) {
            super(formListModel.formContext);
            this.interceptedModel = interceptedModel;
            this.formListModel = formListModel;
            this.garbage = new GarbageCollector();
            this.applyChanges = (value, previous) => {
                this.formListModel.applyChanges(value, previous);
            };
            this.garbage.registerDisposable(interceptedModel.onTransactionStart(interceptedTx => {
                this.joinTransaction(interceptedTx, (tx) => {
                    tx.commit(interceptedTx.committedValue);
                }, this);
            }, this));
        }
        dispose() {
            this.garbage.dispose();
        }
        // @ts-ignore
        get value() {
            return this.valueStore.read();
        }
        set value(value) {
            this.formListModel.applyChanges(value, this.value);
        }
    }
    LiveUpdateForm.InterceptedFormValueModel = InterceptedFormValueModel;
})(LiveUpdateForm || (LiveUpdateForm = {}));

/**
 * @file Automatically generated by barrelsby.
 */

class PageController extends GarbageCollector {
}
class GotoPageCommand extends UnaryCommand {
    constructor(controller) {
        super();
        this.controller = controller;
    }
    onExecute(pageNumber) {
        const totalPages = this.controller.totalPages$.value;
        if (pageNumber < 1 || pageNumber > totalPages) {
            lang.illegalArgument(`pageNumber must be between 1 and ${totalPages}.  Got ${pageNumber}`);
        }
        return this.controller.gotoPage(pageNumber);
    }
}
class ChangePageCommand extends Command {
    constructor(controller, direction) {
        super();
        this.controller = controller;
        this.direction = direction;
    }
    onExecute() {
        return this.controller.gotoPageCommand.execute(this.controller.pageNumber$.value + this.direction);
    }
}
class NextCommand extends ChangePageCommand {
    constructor(controller) {
        super(controller, 1);
        const { valueOf, chain } = Dsl.disposeWith(this);
        const enabled = chain.numericValue(this.controller.pageNumber$).isLessThan(this.controller.totalPages$);
        this.enableWhile(valueOf.all(enabled, controller.enabled).areTruthy());
    }
}
class PreviousCommand extends ChangePageCommand {
    constructor(controller) {
        super(controller, -1);
        const { valueOf, chain } = Dsl.disposeWith(this);
        const enabled = chain.numericValue(this.controller.pageNumber$).isGreaterThan(1);
        this.enableWhile(valueOf.all(enabled, controller.enabled).areTruthy());
    }
}
(function (PageController) {
    function create(totalItems, pageSize$) {
        return new Impl(totalItems, pageSize$);
    }
    PageController.create = create;
    class Impl extends GarbageCollector {
        /**
         *
         * @param {ValueModel<number>} _totalItems
         * @param _pageSize
         */
        constructor(_totalItems, _pageSize) {
            super();
            this._totalItems = _totalItems;
            this._pageSize = _pageSize;
            this._deferredInitialize = Deferred.defer();
            this._offset = new MutableValueModel(0);
            this._enableWhenDelegate = new DelegatingValueModel().withDefault(true);
            const { chain, when, valueOf } = Dsl.disposeWith(this);
            this._totalPages = chain.reduce(this._totalItems, this._pageSize, (totalItems, pageSize) => {
                return (totalItems > 0 && pageSize > 0) ? Math.ceil(totalItems / pageSize) : 1;
            }).otherwise(1); // we always have 1 page, even if it's empty. This allows us to auto load when the page size is set for the first time.
            this._pageIndex = chain.reduce(this._offset, this._pageSize, (offset, limit) => {
                return Math.ceil(offset / limit);
            }).otherwise(0);
            // when the page size changes we keep the current start index so the first item in the current page stays put.  But this
            // means we're no longer on an even page boundary.  This is the offset from the boundary which is then uses on subsequent
            // page changes so we move a whole page at a time (until we hit the first page where it resets).
            this._pageOffsetAdjustment = chain.reduce(this._offset, this._pageIndex, this._pageSize, (index, pageIndex, size) => {
                return index - (pageIndex * size);
            }).otherwise(0);
            this._pageNumber = this._pageIndex.map(index => index + 1);
            this._page = chain(this._offset).map(offset => {
                let pageSize = this._pageSize.value;
                return pageSize > 0 ? { offset, limit: pageSize } : undefined;
            }, {
                dependsOn: this._pageSize,
                postponeWhile: chain.numericValue(this._pageSize).isLessThan(1)
            });
            this._initialized = chain(this._page).isNotNil();
            // const txo = new TransactionObserver({ verbose: true }).onEvent(e => console.log(e.name, e.payload));
            // txo.observe("this._page", this._page);
            // txo.observe("this._pageSize", this._pageSize);
            // txo.observe("this._offset", this._offset);
            this._gotoPageCommand = new GotoPageCommand(this);
            this._nextCommand = this.registerDisposable(new NextCommand(this));
            this._previousCommand = this.registerDisposable(new PreviousCommand(this));
            // if the pages size reduces then we make sure the current page never goes past the end.
            when.valueOf(this._totalPages).changes((newSize, oldSize) => {
                if (newSize < this._pageNumber.value) {
                    this.gotoPage(newSize);
                }
            });
            // }, {unless: () => !this.isInitialized()});
        }
        get enabled() {
            return this._enableWhenDelegate.readonly;
        }
        enableWhen(enabled) {
            this._enableWhenDelegate.setDelegate(enabled);
            return this;
        }
        disableWhen(disable) {
            this.enableWhen(Dsl.disposeWith(this).chain.booleanValue(disable).isFalsey());
            return this;
        }
        gotoPage(pageNumber) {
            const pageSize = this._pageSize.value;
            assert.isTruthy(pageSize > 0, "can't load page until page size is set.");
            assert.isInteger(pageNumber);
            assert.isTruthy(pageNumber > 0, "pageNumber must be greater that 0");
            assert.isTruthy(pageNumber <= this.totalPages$.value, "pageNumber must be less than or equal to the total number of pages.");
            const newOffset = (this.pageSize$.value * (pageNumber - 1)) + this._pageOffsetAdjustment.value;
            this._offset.value = Math.max(newOffset, 0);
        }
        // @trace
        resetToFirstPage() {
            if (this.initialized$.value) {
                this.gotoPage(1);
            }
        }
        // handlePageSizeChanged(size: number, was: number): void {
        //   console.log(`--> ${this.constructor.name}.handlePageSizeChanged(${size}, ${was})`);
        //   if (size < 1) {
        //     lang.illegalState(`page size must be greater than 0, got: ${size}`)
        //   }
        //   const firstTime = !this.isInitialized();
        //   const oldPageSize = this._pageSize.value;
        //   if (firstTime) {
        //     // we've never been loaded so we goto page 1.
        //     this.gotoPage(1);
        //     this._initialized = true;
        //     this._deferredInitialize.resolve(this);
        //   }
        // }
        get initialized$() {
            return this._initialized.readonly;
        }
        waitUntilInitialized() {
            return this._deferredInitialize.promise;
        }
        get page$() {
            return this._page.readonly;
        }
        get pageNumber$() {
            return this._pageNumber;
        }
        get pageSize$() {
            return this._pageSize.readonly;
        }
        get totalPages$() {
            return this._totalPages.readonly;
        }
        get nextCommand() {
            return this._nextCommand;
        }
        get previousCommand() {
            return this._previousCommand;
        }
        get gotoPageCommand() {
            return this._gotoPageCommand;
        }
    }
    PageController.Impl = Impl;
})(PageController || (PageController = {}));
(function (PageController) {
    function createDelegatingPageController() {
        return DelegateProxyHandler.create("PageController", b => {
            b.forProperty("page$", () => new DelegatingValueModel());
            b.forProperty("initialized$", () => new DelegatingValueModel());
            b.forProperty("pageNumber$", () => new DelegatingValueModel());
            b.forProperty("pageSize$", () => new DelegatingValueModel());
            b.forProperty("totalPages$", () => new DelegatingValueModel());
            b.forProperty("nextCommand", () => new DelegatingCommand());
            b.forProperty("previousCommand", () => new DelegatingCommand());
            b.forProperty("gotoPageCommand", () => new DelegatingUnaryCommand());
            b.forFunction("gotoPage");
        });
    }
    PageController.createDelegatingPageController = createDelegatingPageController;
})(PageController || (PageController = {}));

class DelegatingPagedListModel extends DelegatingListModel {
    constructor() {
        super(...arguments);
        this.pageController = PageController.createDelegatingPageController();
    }
    setDelegate(delegate) {
        super.setDelegate(delegate);
        this.pageController.setDelegate(delegate ? delegate.pageController : null);
    }
    getDelegate() {
        return super.getDelegate();
    }
}

class PagedListModel extends ListModel {
    get readonly() {
        return this;
    }
    get pageController() {
        return lang.abstractMethod(this.constructor);
    }
}
(function (PagedListModel) {
    function create(source, pageSize$) {
        return new Wrapper(source, pageSize$);
    }
    PagedListModel.create = create;
    class Wrapper extends GarbageCollector.Mixin(PagedListModel) {
        constructor(source, pageSize$) {
            super({ initialValue: [], identifiedWith: item => source.identityOf(item) });
            this.source = source;
            const { chain, valueOf, before, when, after, observe } = Dsl.disposeWith(this);
            this._totalItems = chain(source).count();
            this._pageController = PageController.create(this._totalItems, pageSize$);
            when.valueOf(this._pageController.page$).changes(page => this.loadPage(page), { initialValue: "triggerChangeUnlessNil" });
            when.listOf(source).changes(() => {
                this.reloadCurrentPage();
            }, { asLongAs: this.pageController.initialized$ });
        }
        loadPage(page) {
            this.startTransaction().commit(this.source.value.slice(page.offset, page.offset + page.limit));
        }
        get pageController() {
            return this._pageController;
        }
        reloadCurrentPage() {
            this.loadPage(this.pageController.page$.value);
        }
        // TODO: move to controller?
        gotoPageOf(item) {
            const itemIndex = this.source.query().indexOf(item);
            const pageSize = this.pageController.pageSize$.value;
            this.pageController.gotoPage(1 + Math.floor(itemIndex / pageSize));
        }
    }
    PagedListModel.Wrapper = Wrapper;
})(PagedListModel || (PagedListModel = {}));

/**
 * @file Automatically generated by barrelsby.
 */

var HasDelegate;
(function (HasDelegate) {
    function findRoot(hasDelegate$) {
        let hasDelegate = hasDelegate$;
        while (!!hasDelegate && hasDelegate["getDelegate"]) {
            hasDelegate = hasDelegate["getDelegate"]();
        }
        return hasDelegate;
    }
    HasDelegate.findRoot = findRoot;
})(HasDelegate || (HasDelegate = {}));

/**
 * Creates property property getter and setter that stores the value in the ValueModel
 * with the specified property name.
 * @param valueModelProperty the name of the ValueModel property to use.
 */
function StoreInValueModel(valueModelProperty) {
    return (target, propertyKey) => {
        Object.defineProperty(target, propertyKey, {
            get: function () {
                assert.isTruthy(ValueModel.isInstance(this[valueModelProperty]));
                return this[valueModelProperty].value;
            },
            set: function (value) {
                assert.isTruthy(ValueModel.isInstance(this[valueModelProperty]));
                this[valueModelProperty].value = value;
            }
        });
    };
}
/**
 * Creates property property getter and setter that stores the value in the ListModel
 * with the specified property name.
 * @param listModelProperty the name of the ListModel property to use.
 */
function StoreInListModel(listModelProperty) {
    return (target, propertyKey) => {
        Object.defineProperty(target, propertyKey, {
            get: function () {
                assert.isTruthy(ListModel.isInstance(this[listModelProperty]));
                return this[listModelProperty].value;
            },
            set: function (value) {
                assert.isTruthy(ListModel.isInstance(this[listModelProperty]));
                this[listModelProperty].value = value;
            }
        });
    };
}

const DELEGATION_STRATEGY = Symbol.for("pectin:delegate:factory");
function TrackExternal(options) {
    return (target, propertyKey) => {
        const defaultTag = `@TrackExternal(${target.constructor.name}.${propertyKey.toString()})`;
        const delegateTo = options?.delegateTo;
        if (delegateTo) {
            const self = this;
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    return this[delegateTo];
                },
                set: function (value) {
                    return this[delegateTo].setDelegate(value);
                }
            });
        }
        else {
            let type = Reflect.getMetadata("design:type", target, propertyKey);
            if (!type) {
                lang.illegalState(`@TrackExternal -> Reflect.getMetadata returned null for 'design:type' in ${target.constructor.name}.${propertyKey.toString()}.  Please ensure tsConfig.json compilerOptions includes {"emitDecoratorMetadata": "true"}.  This has also been known to occur when the angular build optimiser is enabled. Try setting '"buildOptimizer": false' in your angular config.`);
            }
            const strategy = TrackExternal.findStrategyFor(type);
            strategy.defineProperty(target, propertyKey, {
                ...options,
                tag: OptionsHelper.for(options).get("tag", defaultTag)
            });
        }
    };
}
(function (TrackExternal) {
    // TODO: Update when Constructable<T> = abstract new (...args: any[]) => T is supported in TS 4.2
    function oneTimeBinding(constructor) {
        installStrategy(constructor, new TrackExternal.OneTimeBinding());
    }
    TrackExternal.oneTimeBinding = oneTimeBinding;
    // TODO: simplify this in to be
    //  TrackExternal.useProxy(klass: Constructable<T>, builder: (DelegateProxyHandler.Builder<T>) => void);
    //  Would also be useful to create specialised delegate methods.. e.g.
    //     proxy.valueModel("blah$");
    //     proxy.listModel("blah$");
    //     proxy.mapModel("blah$");
    //     proxy.multiMapModel("blah$");
    //     proxy.function("blahDeBlah");
    function useDelegate(constructor, factory) {
        installStrategy(constructor, new TrackExternal.UseDelegate(factory));
    }
    TrackExternal.useDelegate = useDelegate;
    function installStrategy(constructor, strategy) {
        Reflect.defineMetadata(DELEGATION_STRATEGY, strategy, constructor);
    }
    TrackExternal.installStrategy = installStrategy;
    function findStrategyFor(type) {
        // TODO: warn that returned delegate might not be a full type match if the factory is found up the chain.
        const decoratedConstructor = lang.constructorChain(type).find(ctor => Reflect.hasOwnMetadata(DELEGATION_STRATEGY, ctor));
        if (!decoratedConstructor) {
            return lang.illegalState(`No tracking strategy found for: ${type.name}.  Either it or an ancestor class must use the @TrackExternal.Strategy() class decorator`);
        }
        else {
            return Reflect.getMetadata(DELEGATION_STRATEGY, decoratedConstructor);
        }
    }
    TrackExternal.findStrategyFor = findStrategyFor;
    class OneTimeBinding {
        defineProperty(target, propertyKey, options) {
            const constructorName = target.constructor.name;
            const backingModelKey = `__${propertyKey.toString()}BackingModel`;
            const assertUndefined = (backingModel) => {
                lang.illegalState(`@TrackExternal() for ${constructorName}.${propertyKey.toString()} in only supports a one time assignment.`);
            };
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    if (!this[backingModelKey]) {
                        // Most @TraceExternal implementations use delegates that can be used before the property has been assigned, but this one doesn't;
                        console.warn(`@TrackExternal() for ${constructorName}.${propertyKey.toString()} uses a one time binding rather than a delegating model. You'll need to assign it before use.`);
                    }
                    return this[backingModelKey];
                },
                set: function (value) {
                    if (isUndefined(this[backingModelKey])) {
                        this[backingModelKey] = value;
                    }
                    else {
                        lang.illegalState(`@TrackExternal() for ${constructorName}.${propertyKey.toString()} in only supports a one time assignment.`);
                    }
                }
            });
        }
    }
    TrackExternal.OneTimeBinding = OneTimeBinding;
    class UseDelegate {
        constructor(delegateFactory) {
            this.delegateFactory = delegateFactory;
            assert.notNil(delegateFactory);
        }
        defineProperty(target, propertyKey, options) {
            const self = this;
            const backingModelKey = `__${propertyKey.toString()}BackingModel`;
            Object.defineProperty(target, propertyKey, {
                get: function () {
                    if (!this[backingModelKey]) {
                        const hasDelegate = assert.notNil(self.delegateFactory(options));
                        const delegateIsDisposable = isFunction(hasDelegate["dispose"]);
                        const containerCollectsGarbage = this['registerDisposable'];
                        if (!delegateIsDisposable) {
                            const backingModelClass = hasDelegate.constructor.name;
                            console.warn(`${backingModelClass} does not implement Disposable.  @TrackExternal() ${propertyKey.toString()} may leak memory if the property is not set to null.`);
                        }
                        if (!containerCollectsGarbage) {
                            console.warn(`${target.constructor.name} does not implement Disposable.Collector.  @TrackExternal() ${propertyKey.toString()} may leak memory if the property is not set to null.  To avoid this have ${target.constructor.name} extend GarbageCollector or implement the registerDisposable(...) method of Disposable.Collector`);
                        }
                        if (containerCollectsGarbage && delegateIsDisposable) {
                            this.registerDisposable(hasDelegate);
                        }
                        DebugContext.tag(hasDelegate, options.tag);
                        this[backingModelKey] = hasDelegate;
                    }
                    return this[backingModelKey];
                },
                set: function (value) {
                    this[propertyKey].setDelegate(value);
                }
            });
        }
    }
    TrackExternal.UseDelegate = UseDelegate;
})(TrackExternal || (TrackExternal = {}));

TrackExternal.useDelegate(ValueModel, options => new DelegatingValueModel().withDefault(options?.defaultValue));

TrackExternal.useDelegate(ListModel, options => new DelegatingListModel().withDefault(options?.defaultValue));

TrackExternal.useDelegate(MapModel, (options) => new DelegatingMapModel());
TrackExternal.useDelegate(MultiMapModel, (options) => new DelegatingMultiMapModel());

TrackExternal.oneTimeBinding(Form);
TrackExternal.useDelegate(Form.ValueModelBase, () => new Form.DelegatingFormValueModel());
TrackExternal.useDelegate(Form.ListModelBase, () => new Form.DelegatingFormListModel());
TrackExternal.oneTimeBinding(LiveUpdateForm);
TrackExternal.useDelegate(LiveUpdateForm.FormValueModel, () => new LiveUpdateForm.DelegatingFormValueModel());
TrackExternal.useDelegate(LiveUpdateForm.FormListModel, () => new LiveUpdateForm.DelegatingFormListModel());
TrackExternal.oneTimeBinding(DirtyTrackingForm);
TrackExternal.useDelegate(DirtyTrackingValueModel, () => new Form.DelegatingFormValueModel());
TrackExternal.useDelegate(DirtyTrackingListModel, () => new Form.DelegatingFormListModel());

TrackExternal.useDelegate(Command, () => new DelegatingCommand());
TrackExternal.useDelegate(UnaryCommand, () => new DelegatingUnaryCommand());

TrackExternal.useDelegate(SelectionModel, () => DelegatingSelectionModel.createDelegate());
TrackExternal.useDelegate(SingleSelectionModel, () => DelegatingSingleSelectionModel.createDelegate());
TrackExternal.useDelegate(MultipleSelectionModel, () => DelegatingMultipleSelectionModel.createDelegate());

TrackExternal.useDelegate(Stream, () => new DelegatingStream());

TrackExternal.useDelegate(PagedListModel, () => new DelegatingPagedListModel());
TrackExternal.useDelegate(PageController, () => PageController.createDelegatingPageController());

/*
 * Public API Surface of pectin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractCommand, AbstractComputedListModel, AbstractComputedMapModel, AbstractComputedMultiMapModel, AbstractComputedValueModel, AbstractMapModelChainMixin, AdapterRegistry, AfterDsl, AllowNil, AndValueModel, AnyTransitionBuilder, AsyncDestroy, AsyncMutableListModel, AsyncOperation, AsyncUpdate, BaseValueModelChainMixin, BeforeDsl, Binding, BooleanModelDsl, BooleanValueModelChainMixin, CanIdentify, CaseWhenListModel, ChainDsl, ChangeMonitor, ChangeMonitorValueModel, Command, ComputedListModel, ComputedModelMechanics, ComputedStream, ComputedValueModel, ConcatenatingListModel, ConsoleDestination, Constant, ConvertedFormListModel, ConvertedFormValueModel, Converters, DEBUG_CONTEXT_METADATA_KEY, DSL_REGISTRATIONS_KEY, DebugContext, Deferred, DelegateProxyHandler, DelegatingCommand, DelegatingListModel, DelegatingMapModel, DelegatingMultiMapModel, DelegatingMultipleSelectionModel, DelegatingPagedListModel, DelegatingSelectionModel, DelegatingSingleSelectionModel, DelegatingStream, DelegatingUnaryCommand, DelegatingValueModel, DependsOnOptions, DirtyModel, DirtyTrackingForm, DirtyTrackingListModel, DirtyTrackingValueModel, Disposable, Dsl, EventListenerList, FilteredStream, FocusContext, FocusManager, Form, FormContext, Functions, GarbageCollector, Guard, HasDelegate, HasDependents, HasDirtyTracking, HasEnabled, HasFormContext, HasManyIndex, HasOneIndex, HasValidators, HasValue, HasValueMixin, IdentityListModel, IdentityValueModel, ImmutableMap, ImmutableMultiMap, IndexCache, Interceptor, ListChangeTransitionBuilder, ListHolder, ListModel, ListModelChainMixin, ListQuery, ListTransitionBuilder, LiveUpdateForm, Logger, MapModel, MapModelChainMixin, MappedMapModel, MappedStream, MappedValueModel, Mixin, ModelAdapter, MultiMapModel, MultiMapModelChainMixin, MultipleSelectionModel, MutableListModel, MutableMapModel, MutableStream, MutableValueModel, NumericModelDsl, NumericValueModelChainMixin, ObservableAdapter, ObservableAdapterChainMixin, ObservableDsl, OptionsHelper, OrValueModel, PageController, PagedListModel, Pectin, ProxyRegistry, ReadonlyProxyHandler, ReducedFormListModel, ReducingValueModel, RootDestination, SelectionModel, SelectionSanitizer, SingleSelectionModel, SortedListModel, StoreInListModel, StoreInValueModel, Stream, StreamChainMixin, StreamChainMixinBase, StreamDsl, StringModelDsl, StringValueModelChainMixin, SubscriptionAdapter, SwitchCaseBuilder, SwitchCaseListModel, SwitchCaseValueModel, SwitchDsl, TextAttributeSorter, ThrottledAccumulator, ThrottledAccumulatorStream, ThrottledChunkingStream, ThrottledListModel, ThrottledStream, ThrottledValueModel, Trace, Tracer, TrackExternal, Transaction, TransactionObserver, TransitionBuilder, UnaryCommand, ValidationResult, Validator, ValueChangeTransitionBuilder, ValueHolder, ValueModel, ValueModelChainMixin, ValueOfDsl, ValueQuery, ValueTransitionBuilder, WhenDsl, assert, lang };
